import React, {
  Suspense,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { lazyWithRetry } from "Utils/lazyWithRetry";
import momentTimeZone from "moment-timezone";
import CustomButton from "components/common/Button/CustomButton";
// import ModalSkeleton from "components/Modals/ModalSkeleton";
import {
  baseURLImage,
  capitalizeAllLetters,
  capitalizeFirstLetter,
  capitalizeWords,
  checkDisabilityOfShiftStatus,
  checkRunningShiftStatus,
  convertDaysName,
  convertTimeToDatetimeLocal,
  convertWeeksToFormat,
  fetchOptionsForWorkerAndParticpant,
  formatRecurringValue,
  getNameProfile,
  getShiftLength,
  isCheckNextDayShift,
  parseBooleanVal,
  selectedTabState,
  validateCurrentDate,
} from "Utils/utils";
import api from "store/services/rostering.services";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import InputField from "components/common/Input/Input";
import moment from "moment";
import {
  DUMMY_REGEX_EXP,
  LOADER_STATUS,
  SHIFT_STATUS,
  SHIFT_TIME_OPTIONS,
  TOAST_TYPE,
  STATES_LIST,
} from "Constants/constant";
import { first, isEmpty, isNumber } from "lodash";
import { HiCheckCircle, HiOutlineTrash, HiOutlineArrowRight, HiOutlineDocumentAdd, HiOutlineClipboardList } from "react-icons/hi";
import WorkerShiftDetail from "./WorkerShiftDetail";
import SelectOption from "components/common/Select/Select";
import rosteringApi from "store/services/rostering.services";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import SwitchWithIcon from "components/common/SwitchWithIcon";
import { toast } from "react-toastify";
import {
  URL_ROSTERING_GET_NDIS_LINE_ITEMS_ON_SCHEDULING_SHIFT,
  URL_ROSTERING_GET_SHIFT_INSTRUCTIONS,
  URL_ROSTERING_GET_SPLIT_SHIFTS,
  URL_ROSTERING_MANUALY_END_SHAIFT,
  URL_ROSTERING_SHIFT_CHECK_OVERLAPP,
  URL_ROSTERING_SHIFT_V5,
  URL_ROSTERING_GET_NEARBY_WORKERS,
  URL_ROSTERING_GEOCODE_ADDRESS,
  URL_ROSTERING_GET_KM_CODE_LIST_IN_SETTING,
} from "store/services/URL";
import { apiGetRequest, apiPostRequest } from "helpers/Requests";
import {
  isRequestCancelled,
  replaceAbortController,
} from "Utils/requestCancel";
import { FaQuestionCircle, FaFileInvoiceDollar } from "react-icons/fa";
import { HiAdjustments, HiRefresh } from "react-icons/hi";
import RecurringShift from "./RecurringShift";
import { FaExclamationCircle } from "react-icons/fa";
import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { IoCutSharp, IoWarningOutline } from "react-icons/io5";
import WorkerAvailabiltyModal from "components/Modals/WorkerAvailabiltyModal";
import Loader from "components/common/Loader/Loader";
import { getSearchtextOfScheduleShifts } from "store/selector/rostering.selector";
import { useSelector, useDispatch } from "react-redux";
import useCareLabels from "hooks/useCareLabels";
import { getStateOptions } from "store/selector/general.selector";
import { RECURRING_INTERVAL, TOAST_IDS } from "store/constants";
import WorkerSelection from "./Selection/WorkerSelection";
import ParticipantSelection from "./Selection/ParticiapantSelection";
import UpdateRecurringShiftsModal from "components/Modals/RecurringUpdateShiftsModal";
import { showToast } from "store/actions/general.actions";
import {
  advanceShiftDraftDeleteLocally,
  advanceShiftDraftUpsertLocally,
} from "store/actions/rostering.actions";
// import TimeInputRange from "components/common/TimeInput";
import SweetAlertConfirmationModal from "components/common/SweetAlertConfirmation/SweetAlertConfirmation";
import "react-time-picker-input/dist/components/TimeInput.css";
import "./components/advanceModeTimePicker.css";
// import TimePickerDropdown from "./TimeDropdown";
import WorkerShiftModal from "./WorkerShiftModal";
import TimePicker from "react-time-picker-input";
import LoaderButton from "components/common/LoaderButton/LoaderButton";
import DateRangeWithRegister from "components/common/DateRangePicker/DateRangePickerWithRegister";
import LocationModal from "components/common/Modal/LocationModal";
import SplitShift from "./components/SplitShift";
import useAdvanceCommonResources from "./components/useAdvanceCommonResources";
import BasicModeView from "./components/BasicModeView";
import {
  EMPTY_SHIFT_TASK,
  getParticipantTaskList,
  getParticipantSelectionKey,
  mapParticipantTasksToShiftTasks,
  resolveMandatoryFlag,
  resolveParticipantsForShiftTasks,
  stampUnassignedTasksWithParticipant,
  syncParticipantNoteRows,
} from "./components/participantShiftTasksUtils";
import {
  BASIC_FIELD_REQUIRED_MSG,
  getBasicShiftDurationHHMM,
  getMissingBasicServiceCategoryPaths,
  isBasicSameClockTimeFullDay,
  isBasicShiftZeroDuration,
} from "./components/basicModeValidation";
import {
  createEmptyClientSplit,
  createOpenSlotRow,
  createWorkerCarerRow,
  resolveParticipantsList,
  resolveWorkersList,
  participantNeedsResolve,
  workerNeedsResolve,
  getParticipantUuid,
  getParticipantId,
  getParticipantKmForInvoicing,
  getParticipantDefaultKmCode,
  getParticipantSta,
  getSplitParticipant,
  setParticipantSta,
  clearSplitLineItemAndClaimTypeOnSplit,
  applyStaServiceCategoryToAllSplits,
  applyStaFullDayShiftTimes,
  propagateStaDefaultsFromFirstParticipant,
  getWorkerUuid,
  getWorkerId,
  getWorkerDisplayName,
  resolveAdvanceParticipantIds,
  resolveAdvanceWorkerIds,
  isLastSegmentForParticipant,
  isOpenSlotRow,
  resolveStaValue,
  showClaimTypeInScheduleTimesheets,
  mapSplitRowClaimTypeForApi,
  DEFAULT_ADVANCE_CLAIM_TYPE,
  claimTypeFromIsTravel,
  buildAdvanceShiftCreatePayload,
  buildParticipantTravelFromSplits,
  mergeAssignedWorkersIntoGroupedOptions,
  flattenGroupedWorkerOptions,
  resolveWorkerAgainstOptions,
  workersMatchIdentity,
  resolveParticipantAgainstOptions,
  participantsMatchIdentity,
  isActiveParticipantStatus,
} from "./components/advanceModeSplitDefaults";
import { getAdvanceModeValidationFieldPaths, isAdvanceUnallocatedSameClockSegment, isAdvanceSameClockTimeFullDay, validateAdvanceWorkerOrOpenShift, validateAdvanceWorkerShiftWindowCoverage } from "./components/advanceModeValidation";
import {
  getBasicModeValidationFieldOrder,
  getFirstInvalidFieldPath,
  scrollToFirstFormError,
  scrollToFirstInvalidField,
  scrollElementIntoView,
} from "./components/scrollToFirstFormError";
import {
  ADVANCE_MODE_SECTION_IDS,
  AdvanceModeSection,
  AdvanceModeSectionBody,
  AdvanceModeSectionHeader,
  AdvanceModeViewSkeleton,
  AdvanceModeUpdateSkeleton,
} from "./components/advanceModeUi";
import AdvanceModeRemoveWorkerConfirmModal from "./components/AdvanceModeRemoveWorkerConfirmModal";
import {
  EMPTY_SHIFT_LOCATION,
  extractShiftLocationFromResponse,
  getAdvanceShiftLocationRequest,
  getAdvanceShiftLocationRequestKey,
  hasDisplayableShiftLocation,
  isValidShiftCoordinate,
  mapShiftLocationApiResponse,
} from "./components/advanceModeShiftLocation";
import {
  isAdvanceMultiAssignmentShift,
  parseAdvanceShiftEditResponse,
  unwrapAdvanceShiftPayload,
} from "./components/advanceModeEditUtils";
import {
  isAdvanceShiftDateChangeLocked,
  isAdvanceShiftInRecurringSeries,
  resolveAdvanceDisplayStatus,
} from "pages/Rostering/Calendar/advanceShiftCalendarUtils";
import {
  buildAdvanceShiftDraftPayload,
  isAdvanceShiftDraft,
  parseAdvanceDraftForm,
  resolveDraftLookupsBeforeParse,
  unwrapAdvanceDraftResponse,
} from "./components/advanceModeDraftUtils";

const AdvanceModeView = lazyWithRetry(
  () => import("./components/AdvanceModeView"),
  "Rostering/AdvanceModeView"
);

const WorkerShiftDuplicate = (props) => {
  const {
    createOrUpdateWorkerShiftRequest,
    workerAndParticipantOptions,
    userItem,
    selectedDate,
    calendarView,
    handleClose,
    isShow,
    selectedShift = null,
    createOrUpdateWorkerShiftLoader,
    createOrUpdateWorkerShiftError,
    refreshCalendar,
    isUserGracePeriodOver,
    workerProfileDetailsFetchRequest,
    workerProfileDetails,
    getWorkerProfileLoader,
    //For Add Shift Props
    isCallFromAddShift = false,
    // Daily-view slot create: hour/half-hour defaults (toolbar Add Shift leaves these null)
    preselectedStartTime = null,
    preselectedEndTime = null,
    // Family / SP shift-request row used to seed create modal (View from Shift Requests)
    prefillFromShiftRequest = null,
    setPendingShiftRequestApproval = null,
    clearPendingShiftRequestApproval = null,
    spRosteringSetting,
    spRosteringSettingLoader,
    handleGetShiftStats,
    startDate,
    endDate,
    selectedOps,
    serviceTypeSelectedOptions,
    isRecurringModal,
  } = props;

  const { participantLabel, participantLabelPlural } = useCareLabels();

  const [linkedInReviewShiftRequest, setLinkedInReviewShiftRequest] =
    useState(null);
  const calendarLinkedShiftRequestRef = useRef(false);

  const shiftRequestContext = useMemo(
    () => prefillFromShiftRequest || linkedInReviewShiftRequest,
    [prefillFromShiftRequest, linkedInReviewShiftRequest]
  );

  const isShiftRequestApprovalFlow = Boolean(
    isCallFromAddShift || linkedInReviewShiftRequest
  );

  const refreshShiftStats = useCallback(() => {
    if (typeof handleGetShiftStats !== "function") return;
    if (selectedOps?.length > 0) {
      handleGetShiftStats(startDate, endDate, selectedOps);
    } else {
      handleGetShiftStats(startDate, endDate);
    }
  }, [handleGetShiftStats, startDate, endDate, selectedOps]);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    unregister,
    formState,
    formState: { errors },
    control,
    clearErrors,
    setError,
    trigger,
    getFieldState,
  } = useForm();

  const dispatch = useDispatch();

  const [workerOptions, setWorkerOptions] = useState([]);
  const [participantOptions, setParticipantOptions] = useState([]);
  const [advanceHomeParticipantOptions, setAdvanceHomeParticipantOptions] =
    useState(null);
  const [advanceHomeParticipantsLoading, setAdvanceHomeParticipantsLoading] =
    useState(false);

  // Helper function to sort participants alphabetically by name
  const sortParticipantsByName = (participants) => {
    if (!Array.isArray(participants)) return participants;
    return [...participants].sort((a, b) => {
      const aLabel = a.label || `${a.first_name || ''} ${a.last_name || ''}`.trim();
      const bLabel = b.label || `${b.first_name || ''} ${b.last_name || ''}`.trim();
      return aLabel.localeCompare(bLabel);
    });
  };

  // Helper function to sort workers alphabetically by name
  const sortWorkersByName = (workers) => {
    if (!Array.isArray(workers)) return workers;
    return [...workers].sort((a, b) => {
      const aLabel = a.label || `${a.first_name || ''} ${a.last_name || ''}`.trim();
      const bLabel = b.label || `${b.first_name || ''} ${b.last_name || ''}`.trim();
      return aLabel.localeCompare(bLabel);
    });
  };

  // Wrapper function to set participant options with automatic sorting
  const setParticipantOptionsSorted = (participants) => {
    setParticipantOptions(sortParticipantsByName(participants));
  };

  const mapParticipantsToFormValue = (participants) => {
    if (!Array.isArray(participants)) return [];
    return participants
      .filter((p) => p && (p.uuid || p.value || p.id))
      .map((p) => ({
        ...p,
        uuid: p.uuid || p.value,
        value: p.uuid || p.value,
        label:
          p.label ||
          `${p.first_name || ""} ${p.last_name || ""}`.trim(),
        icon: p.icon
          ? p.icon
          : p.profile_picture
          ? baseURLImage(p.profile_picture)
          : getNameProfile(p.first_name, p.last_name || " "),
      }));
  };

  // Wrapper function to set worker options with automatic sorting
  const setWorkerOptionsSorted = (workers) => {
    setWorkerOptions(sortWorkersByName(workers));
  };

  // Ensure participant options are always sorted when used
  const sortedParticipantOptions = useMemo(() => {
    return sortParticipantsByName(participantOptions);
  }, [participantOptions]);

  const [isFetchRecordDetailLoader, setIsFetchRecordDetailLoader] =
    useState(false);
  const [isInitialCreateShiftLoader, setISInitialCreateShiftLoader] = useState(
    LOADER_STATUS.NA
  );
  const [shiftDetailLoader, setShiftDetailLoader] = useState(false);
  /** True while GET /api/v5/sp/rostering/shift/{uuid} is in flight for advance edit. */
  const [advanceShiftDetailsLoading, setAdvanceShiftDetailsLoading] =
    useState(false);
  const [shiftDetailData, setShiftDetailData] = useState([]);

  const [recurringType, setRecurringType] = useState(null);
  const [recurrInterval, setRecurrInterval] = useState(null);
  const [recurringDates, setRecurringDates] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const serviceTypesRequestRef = useRef(0);
  const serviceTypesLoaderRequestRef = useRef(null);
  const serviceTypesFetchKeyRef = useRef("");

  const [isWorkerLoaded, setIsWorkerLoaded] = useState(false);
  const [isParticipantLoaded, setIsParticipantLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  // const createOrUpdateWorkerShiftLoader = false;
  const [openModal, setOpenModal] = useState(false);
  const [showUpdateShiftRecurringModal, setUpdateShiftRecurringModal] =
    useState(false);
  const [showPastRecurringUpdateConfirm, setShowPastRecurringUpdateConfirm] =
    useState(false);
  const [workerProfileUUID, setWorkerProfileUUID] = useState(null);
  const [recheckAvailability, setRecheckAvailability] = useState(false);
  const [loadingItemId, setLoadingItemId] = useState(null);
  const [tasks, setTasks] = useState([{ ...EMPTY_SHIFT_TASK }]);
  /** Tracks advance participant ids already applied for settings-task hydrate. */
  const advanceAppliedTaskPtIdsRef = useRef([]);
  /** Skip settings hydrate on first edit load (API shift_tasks already applied). */
  const advanceSkipInitialTaskHydrateRef = useRef(false);
  /** True while V5/draft details are in flight — do not consume the skip flag yet. */
  const advanceEditTaskLockRef = useRef(false);
  /** Last basic-mode pt selection key that settings tasks were applied for. */
  const lastAppliedTaskParticipantKeyRef = useRef(null);
  /** Avoid re-fetching worker/participant listing for the same group-shift selection. */
  const lastGroupShiftListingKeyRef = useRef(null);
  const tasksRef = useRef(tasks);
  tasksRef.current = tasks;
  const [selectedDays, setSelectedDays] = useState({
    Mon: false,
    Tue: false,
    Wed: false,
    Thu: false,
    Fri: false,
    Sat: false,
    Sun: false,
  });
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);

  // const [recurringEffectedShiftCount, setRecurringEffectedShiftCount] =
  //   useState(null);
  const [recurringFor, setRecurringFor] = useState(null);
  const searchText = useSelector(getSearchtextOfScheduleShifts);
  const stateOptions = useSelector(getStateOptions);
  const [isSelectLocationOpen, setIsSelectLocationOpen] = useState(false);
  const [shiftLocation, setShiftLocation] = useState({
    street: "",
    suburb: "",
    state: null,
    postcode: "",
    state_name: "",
    lat: null,
    lng: null,
  });
  const [nearbyWorkers, setNearbyWorkers] = useState([]);
  const [nearbyWorkersLoading, setNearbyWorkersLoading] = useState(false);
  const [isLocationManuallySet, setIsLocationManuallySet] = useState(false);
  const [isAdvanceMode, setIsAdvanceMode] = useState(false);
  const [isAdvanceModeEntering, setIsAdvanceModeEntering] = useState(false);
  // UUID of the advance-shift draft currently being edited (Save as draft / Resume)
  const [activeDraftUuid, setActiveDraftUuid] = useState(null);
  const [draftSaving, setDraftSaving] = useState(false);
  // Forces the common-resources anchor when editing an existing advance shift
  // (both sides pre-selected): fetch with type=participant + participant uuids.
  const [advanceEditAnchor, setAdvanceEditAnchor] = useState(null);
  const [advanceValidationAttempted, setAdvanceValidationAttempted] =
    useState(false);
  const isAdvanceModeRef = useRef(false);
  const pendingSubmitRef = useRef(null);
  const advanceModeEnterTimerRef = useRef(null);
  /** Avoid repeat include_ids fetches for the same shift-request category. */
  const shiftRequestCategoryIncludeKeyRef = useRef(null);
  /** One-shot inject when API list omits a saved shift-request category. */
  const shiftRequestCategoryInjectedRef = useRef(null);

  const resolveShiftRequestCategoryId = useCallback((request) => {
    if (!request) return null;
    const rawId =
      request.service_category_id ??
      request.serviceCategoryId ??
      request.invoice_service_type?.id ??
      request.invoiceServiceType?.id;
    if (rawId == null || rawId === "") return null;
    const parsed = Number(rawId);
    return Number.isFinite(parsed) ? parsed : null;
  }, []);

  useEffect(() => {
    isAdvanceModeRef.current = isAdvanceMode;
  }, [isAdvanceMode]);

  const navigate = useNavigate();

  const isDateInPast = (date) => {
    if (!date) return false;
    const today = moment().startOf("day");
    const compareDate = moment(
      date,
      ["YYYY-MM-DD", "DD-MM-YYYY", moment.ISO_8601],
      true
    );
    if (!compareDate.isValid()) return false;
    return compareDate.startOf("day").isBefore(today);
  };

  const toShiftDateKey = (date) => {
    if (!date) return "";
    const parsed = moment(
      date,
      ["YYYY-MM-DD", "DD-MM-YYYY", moment.ISO_8601],
      true
    );
    if (parsed.isValid()) return parsed.format("YYYY-MM-DD");
    const loose = moment(date);
    return loose.isValid() ? loose.format("YYYY-MM-DD") : "";
  };

  // Create: always confirm past dates. Edit: only when the date actually moved
  // into the past so note-only updates of existing past shifts are not prompted.
  const shouldConfirmPastShiftDate = (date) => {
    if (!isDateInPast(date)) return false;
    if (selectedShift === null) return true;
    const original = selectedShift?.shift_date || shiftDetailData?.shift_date;
    return toShiftDateKey(date) !== toShiftDateKey(original);
  };

  // Past recurring occurrence: update this shift only (no series toggle / fan-out).
  // Today and future occurrences keep the existing "apply to series" confirm.
  const isPastRecurringShiftUpdate = () =>
    isDateInPast(selectedShift?.shift_date || shiftDetailData?.shift_date);

  const [isPastShift, setIsPastShift] = useState(false);
  /** Original workers removed from advance dropdown — confirm before update. */
  const [removedOriginalWorkers, setRemovedOriginalWorkers] = useState([]);
  const [isRemoveWorkerTimesheetConfirm, setIsRemoveWorkerTimesheetConfirm] =
    useState(false);

  const handleRemovedOriginalWorkersChange = useCallback((workers) => {
    setRemovedOriginalWorkers(Array.isArray(workers) ? workers : []);
  }, []);

  const watchFormData = watch();

  const advanceSelectedKey = useMemo(() => {
    const selected = watchFormData?.advance_selected_participants || [];
    return selected.map((p) => getParticipantUuid(p)).filter(Boolean).join(",");
  }, [watchFormData?.advance_selected_participants]);

  const advanceSelectedWorkersKey = useMemo(() => {
    const selected = watchFormData?.advance_selected_workers || [];
    return selected.map((w) => getWorkerUuid(w)).filter(Boolean).join(",");
  }, [watchFormData?.advance_selected_workers]);

  // Clear task worker binding when that worker is removed (or none selected → All).
  useEffect(() => {
    if (!isAdvanceMode) return;

    const selected = watchFormData?.advance_selected_workers || [];
    const selectedIds = new Set(
      selected
        .map((worker) => getWorkerId(worker))
        .filter((id) => id != null && id !== "")
        .map(Number)
    );

    // Workers are selected but their ids have not resolved from options yet — bailing
    // out keeps an edit-loaded per-worker task from being reset to "All workers".
    if (selected.length > 0 && selectedIds.size === 0) return;

    setTasks((prev) => {
      if (!Array.isArray(prev) || prev.length === 0) return prev;
      let changed = false;
      const next = prev.map((task) => {
        const assignTo = task?.assign_to ?? task?.assignTo;
        const taskWorkerId =
          task?.worker_id != null && task.worker_id !== ""
            ? Number(task.worker_id)
            : task?.assignee_id != null && task.assignee_id !== ""
            ? Number(task.assignee_id)
            : null;

        if (
          assignTo === "all" ||
          taskWorkerId == null ||
          Number.isNaN(taskWorkerId)
        ) {
          if (assignTo !== "all" && (task.worker_id != null || task.assign_to === "worker")) {
            changed = true;
            return { ...task, assign_to: "all", worker_id: null };
          }
          return task;
        }

        if (selectedIds.size === 0 || !selectedIds.has(taskWorkerId)) {
          changed = true;
          return { ...task, assign_to: "all", worker_id: null };
        }
        return task;
      });
      return changed ? next : prev;
    });
  }, [isAdvanceMode, advanceSelectedWorkersKey, watchFormData?.advance_selected_workers]);

  const advanceFormContext = useMemo(
    () => ({
      shift_date: watchFormData?.shift_date,
      date: watchFormData?.date,
      start_time: watchFormData?.start_time,
      end_time: watchFormData?.end_time,
      sta: watchFormData?.sta,
      advance_sil_home_enabled: watchFormData?.advance_sil_home_enabled,
      advance_sil_home_id: watchFormData?.advance_sil_home_id,
      advance_sil_home_uuid: watchFormData?.advance_sil_home_uuid,
      advance_sil_home_label: watchFormData?.advance_sil_home_label,
      openShiftEnabled: parseBooleanVal(watchFormData?.advance_open_shift),
    }),
    [
      watchFormData?.shift_date,
      watchFormData?.date,
      watchFormData?.start_time,
      watchFormData?.end_time,
      watchFormData?.sta,
      watchFormData?.advance_sil_home_enabled,
      watchFormData?.advance_sil_home_id,
      watchFormData?.advance_sil_home_uuid,
      watchFormData?.advance_sil_home_label,
      watchFormData?.advance_open_shift,
    ]
  );

  const {
    resetCommonResources,
    commonResourcesLoading,
    commonWorkerOptions,
    commonWorkerOptionsWithDistance,
    commonWorkerGroupedOptions,
    commonWorkerGroupedOptionsWithDistance,
    commonParticipantOptions,
    commonAnchor,
    nearbyWorkersLoading: advanceCommonNearbyWorkersLoading,
    nearbyWorkers: advanceCommonNearbyWorkers,
  } = useAdvanceCommonResources({
    isAdvanceMode,
    watch,
    setValue,
    participantSelectionKey: advanceSelectedKey,
    workerSelectionKey: advanceSelectedWorkersKey,
    sortParticipantsByName,
    sortWorkersByName,
    shiftLocation,
    initialAnchor: advanceEditAnchor,
    preserveAssignedWorkers: selectedShift != null,
  });

  const advanceModeParticipantOptions = useMemo(() => {
    if (!isAdvanceMode) return [];
    if (advanceHomeParticipantOptions) {
      return advanceHomeParticipantOptions;
    }
    if (commonParticipantOptions !== null) {
      return commonParticipantOptions;
    }
    if (commonAnchor === "worker") {
      return [];
    }
    return sortedParticipantOptions;
  }, [
    isAdvanceMode,
    advanceHomeParticipantOptions,
    commonParticipantOptions,
    commonAnchor,
    sortedParticipantOptions,
  ]);

  const advanceModeWorkerOptions = useMemo(() => {
    if (!isAdvanceMode) return [];
    if (commonWorkerOptions !== null) {
      if (commonWorkerOptionsWithDistance?.length) {
        return commonWorkerOptionsWithDistance;
      }
      return commonWorkerOptions;
    }
    if (commonAnchor === "participant") {
      return [];
    }
    return sortWorkersByName(workerOptions);
  }, [
    isAdvanceMode,
    commonWorkerOptionsWithDistance,
    commonWorkerOptions,
    commonAnchor,
    workerOptions,
  ]);

  const advanceModeGroupedWorkerOptions = useMemo(() => {
    if (!isAdvanceMode || commonWorkerGroupedOptions === null) return null;

    const baseGrouped = commonWorkerGroupedOptionsWithDistance?.length
      ? commonWorkerGroupedOptionsWithDistance
      : commonWorkerGroupedOptions;

    if (!selectedShift) return baseGrouped;

    return mergeAssignedWorkersIntoGroupedOptions(
      baseGrouped,
      watchFormData?.advance_selected_workers || [],
      sortWorkersByName
    );
  }, [
    isAdvanceMode,
    commonWorkerGroupedOptions,
    commonWorkerGroupedOptionsWithDistance,
    selectedShift,
    watchFormData?.advance_selected_workers,
  ]);

  const advanceUseGroupedWorkerList = useMemo(
    () =>
      isAdvanceMode &&
      commonWorkerGroupedOptions !== null &&
      commonAnchor === "participant",
    [isAdvanceMode, commonWorkerGroupedOptions, commonAnchor]
  );

  const advanceUsePaginatedParticipantList = useMemo(
    () =>
      isAdvanceMode &&
      !advanceHomeParticipantOptions &&
      commonParticipantOptions === null &&
      commonAnchor !== "worker",
    [
      isAdvanceMode,
      advanceHomeParticipantOptions,
      commonParticipantOptions,
      commonAnchor,
    ]
  );

  const advanceUsePaginatedWorkerList = useMemo(
    () =>
      isAdvanceMode &&
      commonWorkerOptions === null &&
      commonWorkerGroupedOptions === null &&
      commonAnchor !== "participant",
    [isAdvanceMode, commonWorkerOptions, commonWorkerGroupedOptions, commonAnchor]
  );

  const showApplyKmToInvoice = useMemo(
    () => parseBooleanVal(spRosteringSetting?.apply_km_to_invoice),
    [spRosteringSetting?.apply_km_to_invoice]
  );
  const settingsDefaultKmCode = useMemo(
    () =>
      spRosteringSetting?.default_km_code !== undefined
        ? spRosteringSetting.default_km_code
        : null,
    [spRosteringSetting?.default_km_code]
  );
  const [kmCodeOptions, setKmCodeOptions] = useState([]);

  useEffect(() => {
    if (!showApplyKmToInvoice) {
      setKmCodeOptions([]);
      return;
    }
    let cancelled = false;
    apiGetRequest(URL_ROSTERING_GET_KM_CODE_LIST_IN_SETTING)
      .then((response) => {
        if (cancelled || !response?.data) return;
        const value = (response?.data?.data?.items || []).map((item) => ({
          label: `${item?.support_item_number} ${item?.support_item_name}`,
          value: item?.support_item_number,
        }));
        setKmCodeOptions([
          {
            label: "AI Suggested Codes",
            value: null,
          },
          ...value,
        ]);
      })
      .catch(() => {
        if (!cancelled) setKmCodeOptions([]);
      });
    return () => {
      cancelled = true;
    };
  }, [showApplyKmToInvoice]);

  const showClaimTypeFromSettings = useMemo(
    () => showClaimTypeInScheduleTimesheets(spRosteringSetting),
    [spRosteringSetting]
  );

  const advanceParticipantSelectKey = useMemo(() => {
    if (!isAdvanceMode) return "basic";
    if (
      watchFormData?.advance_sil_home_enabled &&
      watchFormData?.advance_sil_home_uuid
    ) {
      return `home-${watchFormData.advance_sil_home_uuid}`;
    }
    if (commonParticipantOptions) {
      return "common-pt";
    }
    return "all-participants";
  }, [
    watchFormData?.advance_sil_home_enabled,
    watchFormData?.advance_sil_home_uuid,
    commonParticipantOptions,
    isAdvanceMode,
  ]);

  const advanceWorkerSelectKey = useMemo(() => {
    if (!isAdvanceMode) return "basic";
    if (commonWorkerOptions !== null) {
      const groupedCount = commonWorkerGroupedOptions?.reduce(
        (sum, group) => sum + (group.options?.length || 0),
        0
      );
      return `common-wr-${advanceCommonNearbyWorkers.length}-${groupedCount ?? commonWorkerOptions.length}`;
    }
    if (commonAnchor === "participant") {
      return `common-wr-pending-${advanceSelectedKey || "none"}`;
    }
    return "all-workers";
  }, [
    isAdvanceMode,
    commonWorkerOptions,
    commonWorkerGroupedOptions,
    commonAnchor,
    advanceCommonNearbyWorkers.length,
    advanceSelectedKey,
  ]);

  const modalContentRef = useRef(null);
  const shiftFormScrollRef = useRef(null);
  /** Seed pt_id/worker_id from calendar cell once per modal open; do not re-apply after user clears. */
  const cellContextSeedRef = useRef({ participant: false, worker: false });
  const [notes, setNotes] = useState([]);
  /** V5 advance show: per-worker timesheet notes (read-only on shift form). */
  const [shiftNotes, setShiftNotes] = useState([]);

  const participantRatio = watch("pt_id");
  const workerRatio = watch("worker_id");

  const [recurringUpdateShiftData, setRecurringUpdateShiftData] =
    useState(null);
  const [isLessThan12Hours, setIsLessThan12Hours] = useState(false);

  const [isShiftSplit, setIsShiftSplit] = useState(false);
  /** Show basic Service Category error only after Create / Create and Publish. */
  const [basicValidationAttempted, setBasicValidationAttempted] =
    useState(false);
  const {
    fields: splitShifts,
    append,
    remove,
    replace,
  } = useFieldArray({
    control,
    name: "splitShifts",
  });

  const {
    fields: advanceSplitsFields,
    append: appendAdvanceSplit,
    remove: removeAdvanceSplit,
    replace: replaceAdvanceSplits,
    insert: insertAdvanceSplit,
  } = useFieldArray({
    control,
    name: "advance_splits",
  });

  const {
    fields: advanceCarerFields,
    replace: replaceAdvanceCarers,
  } = useFieldArray({
    control,
    name: "advance_carers",
  });

  const seedAdvanceModeFromBasicSelections = useCallback(() => {
    // Prefer live form values; if empty (race into Advance before prefill),
    // fall back to the shift-request row (mobile/family — no web shift yet).
    const request = prefillFromShiftRequest;
    const formatRequestTime = (value) =>
      value
        ? moment(value, ["HH:mm:ss", "HH:mm"]).format("HH:mm")
        : "";

    const startTime =
      watch("start_time") ||
      formatRequestTime(request?.start_time) ||
      "";
    const endTime =
      watch("end_time") || formatRequestTime(request?.end_time) || "";
    const serviceCategoryId =
      watch("invoice_service_type_id") ??
      request?.service_category_id ??
      request?.invoice_service_type?.id ??
      null;

    if (startTime) {
      setValue("start_time", startTime, { shouldDirty: false });
    }
    if (endTime) {
      setValue("end_time", endTime, { shouldDirty: false });
    }
    if (serviceCategoryId != null && serviceCategoryId !== "") {
      setValue("invoice_service_type_id", Number(serviceCategoryId), {
        shouldDirty: false,
      });
    }
    if (request?.req_date && !watch("shift_date")) {
      setValue(
        "shift_date",
        moment(request.req_date).format("YYYY-MM-DD"),
        { shouldDirty: false }
      );
    }

    const basicPtId =
      watch("pt_id") ||
      (Array.isArray(request?.participants) && request.participants.length > 1
        ? request.participants
        : request?.participants?.[0]?.uuid) ||
      null;
    const basicWorkerId = watch("worker_id");
    const shiftTimes = {
      start_time: startTime,
      end_time: endTime,
      sta: watch("sta"),
      invoice_service_type_id:
        serviceCategoryId != null && serviceCategoryId !== ""
          ? Number(serviceCategoryId)
          : null,
    };

    const participants = resolveParticipantsList(
      basicPtId,
      participantOptions,
      calendarView === "participant-view" ? userItem : null
    );

    setValue("advance_selected_participants", participants, {
      shouldDirty: true,
    });
    replaceAdvanceSplits(
      participants.length > 0
        ? participants.map((p) => createEmptyClientSplit(p, shiftTimes))
        : []
    );

    // Tag basic-mode tasks with participant ids so they land under the right
    // advance participant section (shared tasks list stays the same).
    if (participants.length > 0) {
      const defaultPtId = participants[0]?.id ?? null;
      setTasks((prev) =>
        (prev || []).map((task) =>
          task?.pt_id != null && task?.pt_id !== ""
            ? task
            : { ...task, pt_id: defaultPtId ?? null }
        )
      );
      setNotes((prev) => syncParticipantNoteRows(participants, prev));
    }

    const workers = resolveWorkersList(
      basicWorkerId,
      workerOptions,
      calendarView === "worker-view" ? userItem : null
    );

    setValue("advance_selected_workers", workers, { shouldDirty: true });
    replaceAdvanceCarers(
      workers.length > 0
        ? workers.map((w) => createWorkerCarerRow(w, shiftTimes))
        : []
    );

    setValue("advance_open_shift", false);
    setValue("pt_id", null);
    setValue("worker_id", null);
  }, [
    watch,
    participantOptions,
    workerOptions,
    calendarView,
    userItem,
    setValue,
    replaceAdvanceSplits,
    replaceAdvanceCarers,
    prefillFromShiftRequest,
  ]);

  /** Inverse of seedAdvanceModeFromBasicSelections — restore basic fields when leaving advance. */
  const seedBasicModeFromAdvanceSelections = useCallback(() => {
    const participants = watch("advance_selected_participants") || [];
    const workers = watch("advance_selected_workers") || [];
    const isOpenShift = parseBooleanVal(watch("advance_open_shift"));
    const isNewShift = selectedShift == null;

    const participantUuids = [
      ...new Set(participants.map(getParticipantUuid).filter(Boolean)),
    ];
    const workerUuids = [
      ...new Set(workers.map(getWorkerUuid).filter(Boolean)),
    ];

    if (participantUuids.length > 1) {
      // Keep option/object shape used by basic group multi-select.
      setValue("pt_id", participants.filter((p) => getParticipantUuid(p)), {
        shouldDirty: true,
      });
      setValue("is_group_shift", true, { shouldDirty: true });
    } else if (participantUuids.length === 1) {
      setValue("pt_id", participantUuids[0], { shouldDirty: true });
    } else if (
      isNewShift &&
      userItem &&
      calendarView === "participant-view"
    ) {
      // Calendar cell create: field stays locked — re-apply the row participant.
      setValue("pt_id", userItem.uuid, { shouldDirty: true });
    } else {
      setValue("pt_id", null, { shouldDirty: true });
    }

    if (isOpenShift) {
      setValue("worker_id", null, { shouldDirty: true });
    } else if (workerUuids.length === 1) {
      setValue("worker_id", workerUuids[0], { shouldDirty: true });
    } else if (workerUuids.length > 1) {
      // Basic mode is single-worker; keep the first restored selection.
      setValue("worker_id", workerUuids[0], { shouldDirty: true });
    } else if (isNewShift && userItem && calendarView === "worker-view") {
      // Calendar cell create: field stays locked — re-apply the row worker.
      setValue("worker_id", userItem.uuid, { shouldDirty: true });
    } else {
      setValue("worker_id", null, { shouldDirty: true });
    }

    // Keep one-shot calendar seed marked so the open-effect does not overwrite
    // a restored (or intentionally empty) selection after returning to basic.
    if (calendarView === "participant-view") {
      cellContextSeedRef.current.participant = true;
    }
    if (calendarView === "worker-view") {
      cellContextSeedRef.current.worker = true;
    }
  }, [watch, setValue, selectedShift, userItem, calendarView]);

  const handleAdvanceHomeParticipantsChange = useCallback(
    (participants, { autoSelect = true } = {}) => {
      if (!participants) {
        setAdvanceHomeParticipantOptions(null);
        return;
      }
      participants = participants.filter(isActiveParticipantStatus);
      // Empty home roster → fall back to searchable participant list (paginated API).
      // Homes with assigned participants keep the home-only options behavior.
      if (participants.length === 0) {
        setAdvanceHomeParticipantOptions(null);
        if (autoSelect) {
          setValue("advance_selected_participants", [], { shouldDirty: true });
          replaceAdvanceSplits([]);
        }
        return;
      }
      const options = sortParticipantsByName(participants);
      setAdvanceHomeParticipantOptions(options);
      // On edit/draft resume the participants + splits already come from the
      // details/draft API — don't overwrite selection or rebuild splits.
      // Still upgrade any draft stubs (Participant #<id>) once home options load.
      if (!autoSelect) {
        const selected = watch("advance_selected_participants") || [];
        const splits = watch("advance_splits") || [];
        const selectedNeedsFix = selected.some(participantNeedsResolve);
        const splitsNeedFix = splits.some((split) =>
          participantNeedsResolve(getSplitParticipant(split))
        );
        if (!selectedNeedsFix && !splitsNeedFix) return;

        let changed = false;
        const resolvedSelected = selected.map((p) => {
          if (!participantNeedsResolve(p)) return p;
          const match = resolveParticipantAgainstOptions(p, options);
          if (match && !participantNeedsResolve(match)) {
            changed = true;
            return match;
          }
          return p;
        });
        const resolvedSplits = splits.map((split) => {
          const pt = getSplitParticipant(split);
          if (!participantNeedsResolve(pt)) return split;
          const fromSelected = resolvedSelected.find((p) =>
            participantsMatchIdentity(p, pt)
          );
          const match =
            (fromSelected && !participantNeedsResolve(fromSelected)
              ? fromSelected
              : null) || resolveParticipantAgainstOptions(pt, options);
          if (match && !participantNeedsResolve(match)) {
            changed = true;
            return { ...split, participant: match, participants: [match] };
          }
          return split;
        });
        if (changed) {
          setValue("advance_selected_participants", resolvedSelected, {
            shouldDirty: false,
          });
          replaceAdvanceSplits(resolvedSplits);
        }
        return;
      }
      const shiftTimes = {
        start_time: watch("start_time"),
        end_time: watch("end_time"),
      };
      setValue("advance_selected_participants", options, { shouldDirty: true });
      replaceAdvanceSplits(
        options.map((p) => createEmptyClientSplit(p, shiftTimes))
      );
    },
    [setValue, watch, replaceAdvanceSplits]
  );

  const handleHomeManagementDisabled = useCallback(() => {
    setAdvanceHomeParticipantOptions(null);
    setValue("advance_selected_participants", [], { shouldDirty: true });
    replaceAdvanceSplits([]);
    setValue("sta", false, { shouldDirty: true });
    resetCommonResources();
  }, [setValue, replaceAdvanceSplits, resetCommonResources]);

  const handleAdvanceStaMasterChange = useCallback(
    (value) => {
      setValue("sta", value, { shouldDirty: true });
      const allSplits = watch("advance_splits") || [];
      const seen = new Set();
      allSplits.forEach((s, i) => {
        const uuid = getParticipantUuid(getSplitParticipant(s));
        if (uuid && !seen.has(uuid)) {
          seen.add(uuid);
          setParticipantSta(uuid, value, allSplits, setValue);
        }
        clearSplitLineItemAndClaimTypeOnSplit(i, s, setValue);
      });
      if (value) {
        applyStaServiceCategoryToAllSplits(allSplits, serviceTypes, setValue);
        propagateStaDefaultsFromFirstParticipant({
          splits: allSplits,
          selectedParticipants: watch("advance_selected_participants") || [],
          setValue,
        });
        applyStaFullDayShiftTimes(setValue, getValues);
      }
    },
    [watch, setValue, getValues, serviceTypes]
  );

  const handleAdvanceModeToggle = () => {
    if (isAdvanceModeEntering) return;

    if (!isAdvanceMode) {
      setIsAdvanceModeEntering(true);
      // Warm the lazy chunk while the skeleton is on screen.
      import("./components/AdvanceModeView");

      if (advanceModeEnterTimerRef.current) {
        window.clearTimeout(advanceModeEnterTimerRef.current);
      }

      requestAnimationFrame(() => {
        advanceModeEnterTimerRef.current = window.setTimeout(() => {
          advanceModeEnterTimerRef.current = null;
          setIsShiftSplit(false);
          replace([]);
          resetCommonResources();
          setAdvanceEditAnchor(null);
          setAdvanceHomeParticipantOptions(null);
          setAdvanceHomeParticipantsLoading(false);
          seedAdvanceModeFromBasicSelections();
          unregister(["pt_id", "worker_id"]);
          clearErrors(["pt_id", "worker_id"]);
          if (!watch("shift_date")) {
            setValue(
              "shift_date",
              selectedDate || moment().format("YYYY-MM-DD"),
              { shouldDirty: false }
            );
          }
          setIsAdvanceMode(true);
          isAdvanceModeRef.current = true;
          setAdvanceValidationAttempted(false);
          setIsAdvanceModeEntering(false);
        }, 120);
      });
      return;
    }

    if (advanceModeEnterTimerRef.current) {
      window.clearTimeout(advanceModeEnterTimerRef.current);
      advanceModeEnterTimerRef.current = null;
    }
    setIsAdvanceModeEntering(false);
    setAdvanceHomeParticipantOptions(null);
    setAdvanceHomeParticipantsLoading(false);
    resetCommonResources();
    setAdvanceEditAnchor(null);
    setValue("sta", false);
    seedBasicModeFromAdvanceSelections();
    setIsAdvanceMode(false);
    isAdvanceModeRef.current = false;
    advanceAppliedTaskPtIdsRef.current = [];
    advanceSkipInitialTaskHydrateRef.current = false;
    advanceEditTaskLockRef.current = false;
    setAdvanceValidationAttempted(false);
  };

  const advanceLocationRequestRef = useRef(0);
  const advanceLocationAbortRef = useRef(null);
  const shiftInstructionsAbortRef = useRef(null);
  const shiftInstructionsRequestRef = useRef(0);

  const advanceShiftLocationContext = useMemo(() => {
    if (!isAdvanceMode) {
      return { key: null, hasSource: false, request: null };
    }
    const request = getAdvanceShiftLocationRequest(watchFormData);
    return {
      key: getAdvanceShiftLocationRequestKey(request),
      hasSource: !!request,
      request,
    };
  }, [
    isAdvanceMode,
    watchFormData?.advance_sil_home_enabled,
    watchFormData?.advance_sil_home_uuid,
    advanceSelectedKey,
  ]);

  const applyAdvanceShiftLocation = useCallback(
    async (request, { showSuccessToast = false } = {}) => {
      if (!request?.uuids?.length) return false;

      const requestId = ++advanceLocationRequestRef.current;
      advanceLocationAbortRef.current = replaceAbortController(
        advanceLocationAbortRef.current
      );
      const signal = advanceLocationAbortRef.current?.signal;

      const fetchMappedLocation = async (locationRequest) => {
        const res = await api.postShiftLocation(
          {
            source: locationRequest.source,
            uuids: locationRequest.uuids,
          },
          { signal }
        );
        if (requestId !== advanceLocationRequestRef.current) return null;
        const raw = extractShiftLocationFromResponse(res);
        return mapShiftLocationApiResponse(raw);
      };

      try {
        // 1) Prefer home (or primary request). 2) If not displayable, try participants.
        let locationData = await fetchMappedLocation(request);
        if (requestId !== advanceLocationRequestRef.current) return false;

        let resolvedSource = request.source;
        if (
          !hasDisplayableShiftLocation(locationData) &&
          request.fallback?.uuids?.length
        ) {
          locationData = await fetchMappedLocation(request.fallback);
          if (requestId !== advanceLocationRequestRef.current) return false;
          resolvedSource = request.fallback.source;
        }

        // Neither home nor any selected participant has a displayable address.
        if (!hasDisplayableShiftLocation(locationData)) {
          setShiftLocation({ ...EMPTY_SHIFT_LOCATION });
          setIsLocationManuallySet(false);
          setValue("shift_location", null, { shouldValidate: false });
          return "empty";
        }

        setShiftLocation(locationData);
        setIsLocationManuallySet(false);
        setValue(
          "shift_location",
          {
            street: locationData.street,
            suburb: locationData.suburb,
            state: locationData.state || null,
            state_name: locationData.state_name || "",
            postcode: locationData.postcode || "",
            lat: locationData.lat || null,
            lng: locationData.lng || null,
          },
          { shouldValidate: false }
        );

        if (
          !isValidShiftCoordinate(locationData.lat, locationData.lng) &&
          locationData.street &&
          locationData.suburb
        ) {
          try {
            const geocodeResponse = await apiPostRequest(
              URL_ROSTERING_GEOCODE_ADDRESS,
              {
                street: locationData.street || "",
                suburb: locationData.suburb || "",
                state: locationData.state_name || locationData.state || "",
                postcode: locationData.postcode || "",
              },
              null,
              signal ? { signal } : {}
            );
            if (requestId !== advanceLocationRequestRef.current) return true;

            if (
              geocodeResponse?.data?.coordinates?.lat &&
              geocodeResponse?.data?.coordinates?.lng
            ) {
              const coords = {
                lat: geocodeResponse.data.coordinates.lat,
                lng: geocodeResponse.data.coordinates.lng,
              };
              if (isValidShiftCoordinate(coords.lat, coords.lng)) {
                setShiftLocation((prev) => ({
                  ...prev,
                  lat: coords.lat,
                  lng: coords.lng,
                }));
              }
            }
          } catch (err) {
            if (isRequestCancelled(err)) return false;
            // Geocoding is optional when coordinates are missing
          }
        }

        if (showSuccessToast) {
          toast.success(
            resolvedSource === "home"
              ? "Location updated to home address"
              : `Location updated to ${participantLabel.toLowerCase()}'s address`
          );
        }

        return true;
      } catch (err) {
        if (isRequestCancelled(err)) return false;
        if (requestId === advanceLocationRequestRef.current) {
          toast.error("Could not fetch shift location. Please try again.");
        }
        return false;
      }
    },
    [setValue, participantLabel]
  );

  useEffect(() => {
    if (!isAdvanceMode) return;
    if (isLocationManuallySet || selectedShift) return;

    const { request } = advanceShiftLocationContext;

    if (!request) {
      setShiftLocation({ ...EMPTY_SHIFT_LOCATION });
      setIsLocationManuallySet(false);
      setValue("shift_location", null, { shouldValidate: false });
      return;
    }

    applyAdvanceShiftLocation(request);
  }, [
    isAdvanceMode,
    advanceShiftLocationContext.key,
    isLocationManuallySet,
    selectedShift,
    applyAdvanceShiftLocation,
    setValue,
  ]);

  // When pt_id is a calendar cell uuid, resolve full participant once options load
  useEffect(() => {
    if (!isAdvanceMode) return;
    if (
      watchFormData?.advance_sil_home_enabled &&
      watchFormData?.advance_sil_home_uuid
    ) {
      return;
    }

    const selected = watchFormData?.advance_selected_participants || [];
    const splits = watchFormData?.advance_splits || [];
    const lookupOptions = [
      ...(advanceModeParticipantOptions || []),
      ...(participantOptions || []),
      ...(commonParticipantOptions || []),
      ...(workerAndParticipantOptions?.participants || []),
    ];

    const selectedNeedsFix = selected.some(participantNeedsResolve);
    const splitsNeedFix = splits.some((split) =>
      participantNeedsResolve(getSplitParticipant(split))
    );

    // Upgrade draft stubs (Participant #<id>) once any participant options are available.
    // Previously early-returned on commonParticipantOptions and skipped stubs that had labels.
    if (lookupOptions.length > 0 && (selectedNeedsFix || splitsNeedFix)) {
      let changed = false;

      const resolvedSelected = selected.map((p) => {
        if (!participantNeedsResolve(p)) return p;
        const match = resolveParticipantAgainstOptions(p, lookupOptions);
        if (match && !participantNeedsResolve(match)) {
          changed = true;
          return match;
        }
        return p;
      });

      const resolvedSplits = splits.map((split) => {
        const pt = getSplitParticipant(split);
        if (!participantNeedsResolve(pt)) return split;
        const fromSelected = resolvedSelected.find((p) =>
          participantsMatchIdentity(p, pt)
        );
        const match =
          (fromSelected && !participantNeedsResolve(fromSelected)
            ? fromSelected
            : null) || resolveParticipantAgainstOptions(pt, lookupOptions);
        if (match && !participantNeedsResolve(match)) {
          changed = true;
          return { ...split, participant: match, participants: [match] };
        }
        return split;
      });

      if (changed) {
        setValue("advance_selected_participants", resolvedSelected, {
          shouldDirty: false,
        });
        replaceAdvanceSplits(resolvedSplits);
      }
      return;
    }

    if (commonParticipantOptions) {
      return;
    }

    const needsFix = selectedNeedsFix;

    if (!needsFix) return;

    const resolved = resolveParticipantsList(
      watchFormData?.pt_id,
      participantOptions,
      userItem
    );
    if (!resolved.length) return;

    const resolvedKey = resolved.map((p) => getParticipantUuid(p)).join(",");
    if (
      advanceSelectedKey === resolvedKey &&
      !selected.some(participantNeedsResolve)
    ) {
      return;
    }

    setValue("advance_selected_participants", resolved);
    if (splits.length === 0) {
      replaceAdvanceSplits(
        resolved.map((p) => createEmptyClientSplit(p, watchFormData))
      );
    } else {
      replaceAdvanceSplits(
        splits.map((split) => {
          const pt = split?.participant || split?.participants?.[0];
          if (!pt || participantNeedsResolve(pt)) {
            const match = resolved.find((r) =>
              participantsMatchIdentity(r, pt)
            );
            if (match) {
              return { ...split, participant: match, participants: [match] };
            }
          }
          return split;
        })
      );
    }
  }, [
    isAdvanceMode,
    participantOptions,
    advanceModeParticipantOptions,
    commonParticipantOptions,
    workerAndParticipantOptions?.participants,
    userItem,
    watchFormData?.pt_id,
    watchFormData?.advance_sil_home_enabled,
    watchFormData?.advance_sil_home_uuid,
    advanceSelectedKey,
  ]);

  useEffect(() => {
    if (!isAdvanceMode) return;
    if (parseBooleanVal(watchFormData?.advance_open_shift)) return;

    const selected = watchFormData?.advance_selected_workers || [];
    const carers = watchFormData?.advance_carers || [];
    const lookupOptions = [
      ...(advanceModeWorkerOptions || []),
      ...(workerOptions || []),
      ...flattenGroupedWorkerOptions(advanceModeGroupedWorkerOptions || []),
    ];

    const selectedNeedsFix = selected.some(workerNeedsResolve);
    const carersNeedFix = carers.some(
      (row) => !isOpenSlotRow(row) && workerNeedsResolve(row?.worker)
    );

    // Once common-resources workers are available, upgrade draft stubs (Worker #<id>).
    // The previous early-return on commonWorkerOptions left stubs permanently unresolved.
    if (lookupOptions.length > 0 && (selectedNeedsFix || carersNeedFix)) {
      let changed = false;

      const resolvedSelected = selected.map((w) => {
        if (!workerNeedsResolve(w)) return w;
        const match = resolveWorkerAgainstOptions(w, lookupOptions);
        if (match && !workerNeedsResolve(match)) {
          changed = true;
          return match;
        }
        return w;
      });

      const resolvedCarers = carers.map((row) => {
        if (isOpenSlotRow(row) || !workerNeedsResolve(row?.worker)) return row;
        const fromSelected = resolvedSelected.find((w) =>
          workersMatchIdentity(w, row?.worker)
        );
        const match =
          (fromSelected && !workerNeedsResolve(fromSelected)
            ? fromSelected
            : null) || resolveWorkerAgainstOptions(row.worker, lookupOptions);
        if (match && !workerNeedsResolve(match)) {
          changed = true;
          return {
            ...row,
            worker: match,
            worker_id: match.id ?? row.worker_id,
          };
        }
        return row;
      });

      if (changed) {
        setValue("advance_selected_workers", resolvedSelected, {
          shouldDirty: false,
        });
        replaceAdvanceCarers(resolvedCarers);
      }
      return;
    }

    if (commonWorkerOptions) {
      return;
    }

    const needsFix = selectedNeedsFix;

    if (!needsFix) return;

    const resolved = resolveWorkersList(
      watchFormData?.worker_id,
      workerOptions,
      userItem
    );
    if (!resolved.length) return;

    const resolvedKey = resolved.map((w) => getWorkerUuid(w)).join(",");
    if (
      advanceSelectedWorkersKey === resolvedKey &&
      !selected.some(workerNeedsResolve)
    ) {
      return;
    }

    setValue("advance_selected_workers", resolved);
    const openSlots = carers.filter(isOpenSlotRow);
    const workerRows = carers.filter((r) => !isOpenSlotRow(r));

    if (workerRows.length === 0) {
      replaceAdvanceCarers([
        ...resolved.map((w) => createWorkerCarerRow(w, watchFormData)),
        ...openSlots,
      ]);
    } else {
      replaceAdvanceCarers([
        ...workerRows.map((row) => {
          const w = row?.worker;
          if (!w || workerNeedsResolve(w)) {
            const match = resolved.find((r) => workersMatchIdentity(r, w));
            if (match) return { ...row, worker: match };
          }
          return row;
        }),
        ...openSlots,
      ]);
    }
  }, [
    isAdvanceMode,
    commonWorkerOptions,
    advanceModeWorkerOptions,
    advanceModeGroupedWorkerOptions,
    workerOptions,
    userItem,
    watchFormData?.worker_id,
    watchFormData?.advance_open_shift,
    advanceSelectedWorkersKey,
  ]);

  // Add a new split shift row
  const handleAddSplitShift = () => {
    if (splitShifts?.length >= 5) {
      toast.warning("Maximum of 5 split shifts allowed", {
        toastId: TOAST_IDS.MAX_SPLIT_SHIFT_LIMIT,
      });
      return;
    }
    setIsShiftSplit(true);
    // Only seed from an explicitly selected parent Service Category that is
    // still in the options list. Do not silent-fill from participant default —
    // that hid required validation when the parent category was never chosen.
    const parentCategoryId = getValues("invoice_service_type_id");
    const isAllowedParentCategory =
      parentCategoryId != null &&
      parentCategoryId !== "" &&
      (serviceTypes || []).some(
        (opt) => String(opt?.value) === String(parentCategoryId)
      );
    const seededCategoryId = isAllowedParentCategory ? parentCategoryId : "";
    const existingSplits = getValues("splitShifts") || [];
    const isFirstSplitRow = existingSplits.length === 0;
    const previousEndTime = isFirstSplitRow
      ? ""
      : existingSplits[existingSplits.length - 1]?.end_time || "";
    const seededStartTime = isFirstSplitRow
      ? getValues("start_time") || ""
      : previousEndTime;
    const seededEndTime = getValues("end_time") || "";
    append({
      support_item_number: "",
      support_item_name: "",
      start_time: seededStartTime,
      end_time: seededEndTime,
      invoice_item_id: "",
      custom_line_item_uuid: null,
      custom_line_item: null,
      invoice_service_type_id: seededCategoryId,
      price: 0,
      sleepover: false,
      duration: 0,
      claim_type: DEFAULT_ADVANCE_CLAIM_TYPE,
    });
  };

  // Update a split shift row
  const handleRemoveSplitShift = (idx) => {
    remove(idx);
    if (splitShifts.length === 1) setIsShiftSplit(false);
  };

  // Worker availability comes back as a JSON string (or sometimes an already
  // parsed object / null). Parse defensively so a missing or malformed value
  // never throws during render or blocks the availability modal from opening.
  const workerAvailabilityData = (() => {
    const raw = workerProfileDetails?.availability;
    if (!raw) return null;
    if (typeof raw === "object") return raw;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  })();

  const savedServiceTypeIdsKey = useMemo(() => {
    const ids = new Set();
    const add = (id) => {
      if (id != null && id !== "") ids.add(String(id));
    };
    add(watchFormData?.invoice_service_type_id);
    (watchFormData?.splitShifts || []).forEach((split) =>
      add(split?.invoice_service_type_id)
    );
    (watchFormData?.advance_splits || []).forEach((split) =>
      add(split?.invoice_service_type_id)
    );
    return [...ids].sort().join(",");
  }, [
    watchFormData?.invoice_service_type_id,
    watchFormData?.splitShifts,
    watchFormData?.advance_splits,
  ]);

  useEffect(() => {
    // New shift from shift request: fetch with include_ids up front so a bare
    // service-type response cannot race in and wipe orphan categories.
    if (!selectedShift) {
      const categoryId = resolveShiftRequestCategoryId(prefillFromShiftRequest);
      shiftRequestCategoryIncludeKeyRef.current = null;
      shiftRequestCategoryInjectedRef.current = null;
      getServiceTypes(categoryId != null ? [categoryId] : [], { withLoader: true });
    }
  }, [selectedShift?.uuid, prefillFromShiftRequest?.uuid, resolveShiftRequestCategoryId]);

  // Shift-request View: re-fetch if the category is still missing from options.
  useEffect(() => {
    if (!isShow || !prefillFromShiftRequest || selectedShift) {
      return;
    }
    const categoryId = resolveShiftRequestCategoryId(prefillFromShiftRequest);
    if (categoryId == null) {
      return;
    }
    if (
      Array.isArray(serviceTypes) &&
      serviceTypes.some((opt) => String(opt.value) === String(categoryId))
    ) {
      return;
    }
    const fetchKey = `${prefillFromShiftRequest?.uuid ?? ""}|${categoryId}`;
    if (shiftRequestCategoryIncludeKeyRef.current === fetchKey) {
      return;
    }
    shiftRequestCategoryIncludeKeyRef.current = fetchKey;
    getServiceTypes([categoryId], { withLoader: false });
  }, [
    isShow,
    prefillFromShiftRequest?.uuid,
    prefillFromShiftRequest?.service_category_id,
    prefillFromShiftRequest?.invoice_service_type?.id,
    selectedShift,
    serviceTypes,
    resolveShiftRequestCategoryId,
  ]);

  // Last resort: list/detail already has invoice_service_type — keep dropdown label.
  useEffect(() => {
    if (!isShow || !prefillFromShiftRequest || selectedShift) {
      return;
    }
    const categoryId = resolveShiftRequestCategoryId(prefillFromShiftRequest);
    const categoryName =
      prefillFromShiftRequest?.invoice_service_type?.name ??
      prefillFromShiftRequest?.invoiceServiceType?.name;
    if (categoryId == null || !categoryName) {
      return;
    }
    if (
      Array.isArray(serviceTypes) &&
      serviceTypes.some((opt) => String(opt.value) === String(categoryId))
    ) {
      return;
    }
    const injectKey = `${prefillFromShiftRequest?.uuid ?? ""}|${categoryId}`;
    if (shiftRequestCategoryInjectedRef.current === injectKey) {
      return;
    }
    shiftRequestCategoryInjectedRef.current = injectKey;
    setServiceTypes((prev) => [
      ...(prev || []),
      {
        label: categoryName,
        value: categoryId,
        funding_type:
          prefillFromShiftRequest?.invoice_service_type?.funding_type ||
          prefillFromShiftRequest?.invoiceServiceType?.funding_type ||
          "NDIS",
      },
    ]);
  }, [
    isShow,
    prefillFromShiftRequest,
    selectedShift,
    serviceTypes,
    resolveShiftRequestCategoryId,
  ]);

  useEffect(() => {
    if (!isShow || !selectedShift?.uuid) {
      if (!isShow) serviceTypesFetchKeyRef.current = "";
      return;
    }
    const ids = savedServiceTypeIdsKey
      ? savedServiceTypeIdsKey.split(",").filter(Boolean)
      : [];
    const fetchKey = `${selectedShift.uuid}|${savedServiceTypeIdsKey}`;
    const missing = ids.filter(
      (id) => !serviceTypes.some((opt) => String(opt.value) === String(id))
    );
    if (serviceTypes.length > 0 && ids.length > 0 && missing.length === 0) {
      serviceTypesFetchKeyRef.current = fetchKey;
      return;
    }
    if (serviceTypesFetchKeyRef.current === fetchKey) return;
    serviceTypesFetchKeyRef.current = fetchKey;
    getServiceTypes(ids, { withLoader: serviceTypes.length === 0 });
  }, [isShow, selectedShift?.uuid, savedServiceTypeIdsKey, serviceTypes]);

  useEffect(() => {
    const startVal = watchFormData?.start_time;
    const endVal = watchFormData?.end_time;
    const sleepOverVal = watchFormData?.sleepover;
    if (!startVal || !endVal || sleepOverVal === false) {
      setIsLessThan12Hours(false);
      return;
    }

    const parseFormats = ["HH:mm", "hh:mm A", "h:mm A"];
    const start = moment(startVal, parseFormats, true);
    const end = moment(endVal, parseFormats, true);

    if (!start.isValid() || !end.isValid()) {
      setIsLessThan12Hours(false);
      return;
    }

    // if end is before start assume next day; same clock time = 24h window
    if (end.isBefore(start)) {
      end.add(1, "day");
    } else if (
      start.format("HH:mm") === end.format("HH:mm") &&
      isBasicSameClockTimeFullDay(startVal, endVal)
    ) {
      end.add(1, "day");
    }

    const diffHours = end.diff(start, "hours", true);
    if(sleepOverVal === true){
      setIsLessThan12Hours(diffHours < 12);
    }
  }, [watchFormData?.start_time, watchFormData?.end_time, watchFormData?.sleepover, isShiftSplit]);

  // Sync shiftLocation state with form data when location is updated
  useEffect(() => {
    // Street/suburb (or postcode) is enough to show in the location selector.
    if (hasDisplayableShiftLocation(shiftLocation)) {
      setValue("shift_location", {
        street: shiftLocation.street || "",
        suburb: shiftLocation.suburb || "",
        state: shiftLocation.state || shiftLocation.state_id || null,
        state_name: shiftLocation.state_name || "",
        postcode: shiftLocation.postcode || "",
        lat: shiftLocation.lat || null,
        lng: shiftLocation.lng || null,
      }, { shouldValidate: false });
    } else if (!shiftLocation?.street && !shiftLocation?.suburb && !shiftLocation?.postcode) {
      // Clear location from form when shiftLocation is reset
      setValue("shift_location", null, { shouldValidate: false });
    }
  }, [shiftLocation, setValue]);

  // Function to clear/reset location
  const handleClearLocation = () => {
    setShiftLocation({
      street: "",
      suburb: "",
      state: null,
      postcode: "",
      state_name: "",
      lat: null,
      lng: null,
    });
    setValue("shift_location", null, { shouldValidate: false });
    // Reset manual location flag when location is cleared
    setIsLocationManuallySet(false);
  };

  // Function to revert to participant's location
  // When multiple participants are selected, uses the first one (by order) whose location exists
  const handleUseParticipantLocation = async () => {
    if (isAdvanceMode) {
      const request = getAdvanceShiftLocationRequest(watchFormData);
      if (!request) {
        toast.error(`Select a home or ${participantLabel.toLowerCase()} first.`);
        return;
      }
      const applied = await applyAdvanceShiftLocation(request, {
        showSuccessToast: true,
      });
      // Only this case — do not double-toast on network/abort failures.
      if (applied === "empty") {
        toast.error(
          request.source === "home"
            ? `Home has no address and no selected ${participantLabel.toLowerCase()} has a location set. Please enter location manually.`
            : `No selected ${participantLabel.toLowerCase()} has a location set. Please set an address or enter location manually.`
        );
      }
      return;
    }

    if (!watchFormData?.pt_id) {
      return; // No participant selected
    }

    const participantIds = Array.isArray(watchFormData.pt_id)
      ? watchFormData.pt_id.map((item) => item?.uuid ?? item?.value ?? item).filter(Boolean)
      : [watchFormData.pt_id];

    if (participantIds.length === 0) return;

    let participantData = null;
    let participantIdToUse = null;

    for (const id of participantIds) {
      const participant = participantOptions.find((p) => p.uuid === id || p.value === id);
      if (participant?.street_no && participant?.suburb && participant?.post_code) {
        participantData = participant;
        participantIdToUse = id;
        break;
      }
      try {
        let response = await apiGetRequest(
          `sp/participants/setting-update/${id}`,
          null,
          { allowNotFound: true }
        );
        if (!response?.data?.data || (!response.data.data.street_no && !response.data.data.suburb)) {
          response = await apiGetRequest(`sp/participants/${id}`);
        }
        if (response?.data?.data) {
          const data = response.data.data;
          if (data.street_no && data.suburb && data.post_code) {
            participantData = data;
            participantIdToUse = id;
            break;
          }
        }
      } catch (e) {
        continue;
      }
    }

    if (!participantData || !participantIdToUse) {
      toast.error(`Could not fetch ${participantLabel.toLowerCase()} location. Please try again.`);
      return;
    }

    try {
      if (participantData) {
        
        // Get state name from state_id or state (string)
        let stateName = participantData.state;
        let stateValue = participantData.state;

        if (stateName && typeof stateName === 'string') {
          const stateOption = STATES_LIST.find(
            (s) => s.value?.toLowerCase() === stateName?.toLowerCase()
          );
          
          if (!stateOption) {
            const stateOptionByLabel = STATES_LIST.find(
              (s) => s.label?.toLowerCase() === stateName?.toLowerCase()
            );
            if (stateOptionByLabel) {
              stateName = stateOptionByLabel.value;
              stateValue = stateOptionByLabel.value;
            }
          } else {
            stateName = stateOption.value;
            stateValue = stateOption.value;
          }
        } else if (!stateName && participantData.state_id && stateOptions && stateOptions.length > 0) {
          const stateFromOptions = stateOptions.find(
            (s) => s.value === participantData.state_id || s.id === participantData.state_id
          );
          if (stateFromOptions) {
            stateName = stateFromOptions.name || stateFromOptions.label;
            stateValue = stateFromOptions.name || stateFromOptions.label;
            
            const stateOption = STATES_LIST.find(
              (s) => s.label?.toLowerCase() === stateName?.toLowerCase()
            );
            if (stateOption) {
              stateName = stateOption.value;
              stateValue = stateOption.value;
            }
          }
        }

        // Build location data from participant
        const locationData = {
          street: participantData.street_no || "",
          suburb: participantData.suburb || "",
          state: stateValue || null,
          state_name: stateName || stateValue || "",
          postcode: participantData.post_code || "",
          lat: participantData.lat !== null && participantData.lat !== undefined && participantData.lat !== '' 
            ? Number(participantData.lat) : null,
          lng: participantData.lng !== null && participantData.lng !== undefined && participantData.lng !== '' 
            ? Number(participantData.lng) : null,
        };

        // Validate coordinates
        const isValidCoordinate = (lat, lng) => {
          if (lat == null || lng == null) return false;
          const numLat = Number(lat);
          const numLng = Number(lng);
          return !isNaN(numLat) && !isNaN(numLng) &&
                 numLat >= -90 && numLat <= 90 &&
                 numLng >= -180 && numLng <= 180 &&
                 !(numLat === 0 && numLng === 0);
        };

        // Clear invalid coordinates
        if (locationData.lat != null && locationData.lng != null && !isValidCoordinate(locationData.lat, locationData.lng)) {
          locationData.lat = null;
          locationData.lng = null;
        }

        // Set location from participant
        setShiftLocation(locationData);
        setIsLocationManuallySet(false); // Clear manual flag so participant location is used

        // If coordinates are missing, geocode the address
        const hasValidCoordinates = isValidCoordinate(locationData.lat, locationData.lng);
        if (!hasValidCoordinates && locationData.street && locationData.suburb) {
          try {
            const geocodeResponse = await apiPostRequest(URL_ROSTERING_GEOCODE_ADDRESS, {
              street: locationData.street || "",
              suburb: locationData.suburb || "",
              state: locationData.state_name || locationData.state || "",
              postcode: locationData.postcode || "",
            });
            
            if (geocodeResponse?.data?.coordinates?.lat && geocodeResponse?.data?.coordinates?.lng) {
              const coords = {
                lat: geocodeResponse.data.coordinates.lat,
                lng: geocodeResponse.data.coordinates.lng,
              };
              
              if (isValidCoordinate(coords.lat, coords.lng)) {
                setShiftLocation((prev) => ({
                  ...prev,
                  lat: coords.lat,
                  lng: coords.lng,
                }));
              }
            }
          } catch (e) {
            // Geocoding failed, but location is still set
          }
        }
        
        // Show success message
        toast.success(`Location updated to ${participantLabel.toLowerCase()}'s address`);
      }
    } catch (error) {
      toast.error(`Error fetching ${participantLabel.toLowerCase()} location. Please try again.`);
    }
  };
  
  // Wrapper function for setShiftLocation that tracks if location was manually set
  const handleSetShiftLocation = (locationData) => {
    setShiftLocation(locationData);
    // If location was set via LocationModal (manually entered by user), mark it as manually set
    // This ensures manually set locations take precedence over participant addresses
    // The flag is set if the location has address fields (street or suburb), indicating user input
    if (locationData && (locationData.street || locationData.street_address || locationData.suburb)) {
      setIsLocationManuallySet(true);
    } else {
      setIsLocationManuallySet(false);
    }
  };

  const getServiceTypes = async (includeIds = [], { withLoader = false } = {}) => {
    const requestId = ++serviceTypesRequestRef.current;
    if (withLoader) {
      serviceTypesLoaderRequestRef.current = requestId;
      setShiftDetailLoader(true);
    }
    try {
      const uniqueIncludeIds = [
        ...new Set(
          (includeIds || [])
            .filter((id) => id != null && id !== "")
            .map((id) => String(id))
        ),
      ];
      const query =
        uniqueIncludeIds.length > 0
          ? `?${uniqueIncludeIds
              .map((id) => `include_ids[]=${encodeURIComponent(id)}`)
              .join("&")}`
          : "";
      const res = await apiGetRequest(`/roster-invoices/service-type${query}`);
      if (requestId !== serviceTypesRequestRef.current) return;
      if (res.data) {
        // funding_type is required so SplitShift can load NDIS vs custom catalogues.
        const modifiedValues = res.data.data.map((item) => ({
          label: item.name,
          value: item.id,
          funding_type: item.funding_type || "NDIS",
        }));
        setServiceTypes(modifiedValues);
      }
    } catch (error) {
      // Service types are optional for rendering the add-shift form.
    } finally {
      if (withLoader && serviceTypesLoaderRequestRef.current === requestId) {
        serviceTypesLoaderRequestRef.current = null;
        setShiftDetailLoader(false);
      }
    }
  };

  useEffect(() => {
    if (watchFormData?.is_recurring && modalContentRef.current) {
      modalContentRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [watchFormData?.is_recurring, recurringType]);

  // Recurring is not allowed on past dates. The UI hides the toggle, but form
  // state used to keep is_recurring true and submit still required an interval.
  useEffect(() => {
    if (selectedShift !== null) return;
    if (!watchFormData?.is_recurring) return;
    if (!isDateInPast(watchFormData?.shift_date)) return;

    setValue("is_recurring", false);
    setRecurringType(null);
    setRecurrInterval(null);
    setRecurringDates([]);
  }, [selectedShift, watchFormData?.is_recurring, watchFormData?.shift_date, setValue]);

  // Reset location flags when creating a new shift (not editing)
  useEffect(() => {
    if (selectedShift === null) {
      // When creating a new shift, reset the manual location flag
      // Location will be auto-populated from participant if available
      setIsLocationManuallySet(false);
      setShiftNotes([]);
      // Allow create-mode settings task hydrate after leaving an edit session.
      lastAppliedTaskParticipantKeyRef.current = null;
    }
  }, [selectedShift]);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedShift && selectedShift.uuid) {
        // Incomplete advance builders — resume from draft API, never V2/V5 shift show
        if (isAdvanceShiftDraft(selectedShift)) {
          // Same as V5 edit: lock UI with advanceShiftDetailsLoading so
          // getServiceTypes clearing shiftDetailLoader cannot unlock Create.
          advanceEditTaskLockRef.current = true;
          advanceSkipInitialTaskHydrateRef.current = true;
          setAdvanceShiftDetailsLoading(true);
          setShiftDetailLoader(true);
          setIsAdvanceMode(true);
          isAdvanceModeRef.current = true;
          await getAdvanceDraftDetails(selectedShift.uuid);
          return;
        }
        // V5 advance (multi-assignment) shifts load from the v5 endpoint and
        // open directly in advance mode. Legacy/basic shifts keep the v2 flow.
        if (isAdvanceMultiAssignmentShift(selectedShift)) {
          // Show advance skeleton immediately (before the async request starts)
          // so empty form fields never flash while waiting on V5 details.
          // Lock settings-task hydrate until saved shift_tasks are applied —
          // otherwise this early isAdvanceMode flip reseeds participant settings.
          advanceEditTaskLockRef.current = true;
          advanceSkipInitialTaskHydrateRef.current = true;
          setAdvanceShiftDetailsLoading(true);
          setShiftDetailLoader(true);
          setIsAdvanceMode(true);
          isAdvanceModeRef.current = true;
          await getAdvanceShiftDetails(selectedShift.uuid);
        } else {
          setAdvanceShiftDetailsLoading(false);
          await getShiftDetails(selectedShift.uuid);
        }
      } else {
        setAdvanceShiftDetailsLoading(false);
      }
    };
    fetchData();
  }, [selectedShift?.uuid, selectedShift?.is_draft]);

  useEffect(() => {
    if (!isShow || selectedShift !== null) return;

    const currentShiftDate = watch("shift_date");
    if (!currentShiftDate) {
      setValue(
        "shift_date",
        selectedDate || moment().format("YYYY-MM-DD"),
        { shouldDirty: false }
      );
    }

    const requestHasTimes = Boolean(
      prefillFromShiftRequest?.start_time || prefillFromShiftRequest?.end_time
    );

    // Slot-click create uses preselected hour/half-hour window (1h).
    // Toolbar / weekly Add Shift keep the existing 00:00 defaults.
    // Skip defaults when opening from a shift request (times come from prefill).
    if (!isAdvanceMode) {
      if (preselectedStartTime || preselectedEndTime) {
        if (preselectedStartTime) {
          setValue("start_time", preselectedStartTime, { shouldDirty: false });
        }
        if (preselectedEndTime) {
          setValue("end_time", preselectedEndTime, { shouldDirty: false });
        }
      } else if (!requestHasTimes) {
        const currentStartTime = watch("start_time");
        const currentEndTime = watch("end_time");
        if (!currentStartTime) {
          setValue("start_time", "00:00", { shouldDirty: false });
        }
        if (!currentEndTime) {
          setValue("end_time", "00:00", { shouldDirty: false });
        }
      }
    }

    if (selectedDate) {
      setShiftLocation({
        street: "",
        suburb: "",
        state: null,
        postcode: "",
        state_name: "",
        lat: null,
        lng: null,
      });
    }
  }, [
    isShow,
    isAdvanceMode,
    selectedDate,
    selectedShift,
    preselectedStartTime,
    preselectedEndTime,
    prefillFromShiftRequest,
    setValue,
    watch,
  ]);

  // Seed create form from Shift Requests "View" (list/detail row — no roster shift yet).
  useEffect(() => {
    if (!isShow || !prefillFromShiftRequest || selectedShift) {
      return;
    }
    const request = prefillFromShiftRequest;
    const participants = Array.isArray(request?.participants)
      ? request.participants
      : [];
    const mappedParticipants = mapParticipantsToFormValue(participants);
    const startTime = request?.start_time
      ? moment(request.start_time, ["HH:mm:ss", "HH:mm"]).format("HH:mm")
      : "";
    const endTime = request?.end_time
      ? moment(request.end_time, ["HH:mm:ss", "HH:mm"]).format("HH:mm")
      : "";
    const resolvedCategoryId = resolveShiftRequestCategoryId(request);

    // Inject into select options so Participant name renders (list has names;
    // async select only shows a match from options).
    if (mappedParticipants.length > 0) {
      setParticipantOptions((prev) => {
        const merged = [...(Array.isArray(prev) ? prev : [])];
        let added = false;
        mappedParticipants.forEach((mp) => {
          const exists = merged.some(
            (p) =>
              String(p.uuid) === String(mp.uuid) ||
              String(p.value) === String(mp.value)
          );
          if (!exists) {
            merged.push(mp);
            added = true;
          }
        });
        return added ? sortParticipantsByName(merged) : prev;
      });
    }

    if (!isAdvanceMode) {
      if (mappedParticipants.length > 1) {
        setValue("pt_id", mappedParticipants, { shouldDirty: false });
        setValue("is_group_shift", true, { shouldDirty: false });
      } else if (mappedParticipants[0]?.uuid) {
        setValue("pt_id", mappedParticipants[0].uuid, { shouldDirty: false });
      }
    }

    if (request?.req_date) {
      setValue(
        "shift_date",
        moment(request.req_date).format("YYYY-MM-DD"),
        { shouldDirty: false }
      );
    }
    if (startTime) {
      setValue("start_time", startTime, { shouldDirty: false });
    }
    if (endTime) {
      setValue("end_time", endTime, { shouldDirty: false });
    }

    if (resolvedCategoryId != null) {
      setValue("invoice_service_type_id", resolvedCategoryId, {
        shouldDirty: false,
      });
    }

    // Advance mode: mirror request onto participants + billing breakdowns.
    if (isAdvanceMode) {
      const resolvedParticipants = resolveParticipantsList(
        mappedParticipants.length > 0 ? mappedParticipants : watch("pt_id"),
        participantOptions,
        calendarView === "participant-view" ? userItem : null
      );
      if (resolvedParticipants.length > 0) {
        setValue("advance_selected_participants", resolvedParticipants, {
          shouldDirty: false,
        });
      }

      const existingSplits = getValues("advance_splits") || [];
      const shiftTimes = {
        start_time: startTime || watch("start_time") || "",
        end_time: endTime || watch("end_time") || "",
        sta: watch("sta"),
        invoice_service_type_id: resolvedCategoryId,
      };

      if (existingSplits.length > 0) {
        replaceAdvanceSplits(
          existingSplits.map((split) => ({
            ...split,
            participant_start_time:
              shiftTimes.start_time || split.participant_start_time || "",
            participant_end_time:
              shiftTimes.end_time || split.participant_end_time || "",
            invoice_service_type_id:
              resolvedCategoryId ?? split.invoice_service_type_id ?? null,
          }))
        );
      } else if (resolvedParticipants.length > 0) {
        replaceAdvanceSplits(
          resolvedParticipants.map((p) =>
            createEmptyClientSplit(p, shiftTimes)
          )
        );
      }
    }
  }, [
    prefillFromShiftRequest,
    isShow,
    selectedShift,
    setValue,
    serviceTypes,
    isAdvanceMode,
    participantOptions,
    calendarView,
    userItem,
    watch,
    getValues,
    replaceAdvanceSplits,
    resolveShiftRequestCategoryId,
  ]);

  useEffect(() => {
    if (!isShow) {
      if (advanceModeEnterTimerRef.current) {
        window.clearTimeout(advanceModeEnterTimerRef.current);
        advanceModeEnterTimerRef.current = null;
      }
      cellContextSeedRef.current = { participant: false, worker: false };
      shiftRequestCategoryIncludeKeyRef.current = null;
      shiftRequestCategoryInjectedRef.current = null;
      setIsAdvanceMode(false);
      setIsAdvanceModeEntering(false);
      setAdvanceEditAnchor(null);
      setAdvanceValidationAttempted(false);
      setBasicValidationAttempted(false);
      isAdvanceModeRef.current = false;
      pendingSubmitRef.current = null;
      setActiveDraftUuid(null);
      setDraftSaving(false);
      if (calendarLinkedShiftRequestRef.current) {
        calendarLinkedShiftRequestRef.current = false;
        setLinkedInReviewShiftRequest(null);
        if (typeof clearPendingShiftRequestApproval === "function") {
          clearPendingShiftRequestApproval();
        }
      }
    }
  }, [isShow, clearPendingShiftRequestApproval]);

  useEffect(() => {
    if (!userItem || selectedShift || isAdvanceMode) return;
    // Participant(s) already seeded from shift-request prefill.
    if (prefillFromShiftRequest && calendarView === "participant-view") {
      cellContextSeedRef.current.participant = true;
      return;
    }

    if (
      calendarView === "worker-view" &&
      !cellContextSeedRef.current.worker
    ) {
      setValue("worker_id", userItem.uuid);
      cellContextSeedRef.current.worker = true;
    } else if (
      calendarView === "participant-view" &&
      !cellContextSeedRef.current.participant
    ) {
      setValue("pt_id", userItem.uuid);
      cellContextSeedRef.current.participant = true;
    }
  }, [
    userItem,
    calendarView,
    selectedShift,
    setValue,
    isAdvanceMode,
    prefillFromShiftRequest,
  ]);

  useEffect(() => {
    if (workerAndParticipantOptions) {
      const { workers, participants } = workerAndParticipantOptions;
      if (
        calendarView === "worker-view" &&
        workers?.length > 0 &&
        calendarView === "worker-view" &&
        !watchFormData?.is_group_shift
        //  && (selectedShift !==null && calendarView==="worker-view"
        //   && !selectedShift?.is_group_shift)
      ) {
        setWorkerOptionsSorted(workers);
      }
      if (calendarView === "participant-view" && participants?.length > 0) {
        setParticipantOptions(sortParticipantsByName(participants));
      }
    }
  }, []);

  // Fetch nearby workers when shift location is set (basic mode only)
  useEffect(() => {
    if (isAdvanceMode) return;

    setNearbyWorkers([]);

    // Validate coordinates are within reasonable bounds
    const isValidCoordinate = (lat, lng) => {
      if (lat == null || lng == null) return false;
      const numLat = Number(lat);
      const numLng = Number(lng);
      // Check if they're valid numbers and within valid lat/lng ranges
      // Also exclude 0,0 which is often a default/placeholder value
      return !isNaN(numLat) && !isNaN(numLng) &&
             numLat >= -90 && numLat <= 90 &&
             numLng >= -180 && numLng <= 180 &&
             !(numLat === 0 && numLng === 0);
    };

    const fetchNearbyWorkers = async () => {
      if (
        isValidCoordinate(shiftLocation?.lat, shiftLocation?.lng) &&
        !nearbyWorkersLoading
      ) {
        setNearbyWorkersLoading(true);
        try {
          const response = await apiPostRequest(URL_ROSTERING_GET_NEARBY_WORKERS, {
            lat: shiftLocation.lat,
            lng: shiftLocation.lng,
            max_distance: 10000, // Very large distance to get all workers with distances
            limit: 10000, // Get all workers
          });
          
          if (response?.data?.nearby_workers?.workers) {
            setNearbyWorkers(response.data.nearby_workers.workers);
          } else {
            setNearbyWorkers([]);
          }
        } catch (error) {
          setNearbyWorkers([]);
        } finally {
          setNearbyWorkersLoading(false);
        }
      } else {
        // Clear nearby workers if coordinates are invalid or missing
        setNearbyWorkers([]);
      }
    };

    fetchNearbyWorkers();
  }, [shiftLocation?.lat, shiftLocation?.lng, isAdvanceMode]);

  // Enhanced worker options with distance when coordinates are available (only for new design)
  const enhancedWorkerOptions = useMemo(() => {
    // Validate coordinates are within reasonable bounds
    const isValidCoordinate = (lat, lng) => {
      if (lat == null || lng == null) return false;
      const numLat = Number(lat);
      const numLng = Number(lng);
      // Check if they're valid numbers and within valid lat/lng ranges
      // Also exclude 0,0 which is often a default/placeholder value
      return !isNaN(numLat) && !isNaN(numLng) &&
             numLat >= -90 && numLat <= 90 &&
             numLng >= -180 && numLng <= 180 &&
             !(numLat === 0 && numLng === 0);
    };

    if ( !isValidCoordinate(shiftLocation?.lat, shiftLocation?.lng)) {
      return workerOptions;
    }
    
    // If we don't have nearby workers data yet, return regular options
    if (nearbyWorkers.length === 0 && !nearbyWorkersLoading) {
      return workerOptions;
    }

    // Create a map of nearby workers by UUID for quick lookup
    const nearbyWorkersMap = new Map();
    nearbyWorkers.forEach(worker => {
      nearbyWorkersMap.set(worker.uuid, worker.distance);
    });

    // Format distance for display (show meters if < 1km, otherwise km)
    const formatDistance = (distance) => {
      if (distance === undefined || distance === null) return '';
      if (distance < 1) {
        // Show meters for distances less than 1km
        const meters = Math.round(distance * 1000);
        return `${meters}m`;
      }
      // Show km with 1 decimal place for distances >= 1km
      return `${distance.toFixed(1)}km`;
    };

    // Enhance worker options with distance information
    const enhanced = workerOptions.map(option => {
      const distance = nearbyWorkersMap.get(option.value);
      if (distance !== undefined && distance !== null) {
        return {
          ...option,
          label: `${option.label} (${formatDistance(distance)})`,
          distance: distance,
        };
      }
      // If worker is not in nearbyWorkers but we have location data, 
      // they might be beyond max_distance or have invalid coordinates
      // Show them without distance
      return {
        ...option,
        distance: null, // Mark as no distance available
      };
    });

    // Sort by distance (workers with distance first, sorted by distance, then workers without distance sorted by name)
    return enhanced.sort((a, b) => {
      const aHasDistance = a.distance !== undefined && a.distance !== null;
      const bHasDistance = b.distance !== undefined && b.distance !== null;
      
      // If both have distance, sort by distance (closest first)
      if (aHasDistance && bHasDistance) {
        return a.distance - b.distance;
      }
      
      // Workers with distance always come before workers without distance
      if (aHasDistance && !bHasDistance) return -1;
      if (!aHasDistance && bHasDistance) return 1;
      
      // If neither has distance, sort alphabetically by label/name
      if (!aHasDistance && !bHasDistance) {
        const aLabel = a.label || '';
        const bLabel = b.label || '';
        return aLabel.localeCompare(bLabel);
      }
      
      return 0;
    });
  }, [workerOptions, nearbyWorkers, shiftLocation?.lat, shiftLocation?.lng, nearbyWorkersLoading]);

  // Ensure worker options are always sorted when used (use distance sorting when coordinates are available)
  const sortedWorkerOptions = useMemo(() => {
    // Validate coordinates are within reasonable bounds
    const isValidCoordinate = (lat, lng) => {
      if (lat == null || lng == null) return false;
      const numLat = Number(lat);
      const numLng = Number(lng);
      // Check if they're valid numbers and within valid lat/lng ranges
      // Also exclude 0,0 which is often a default/placeholder value
      return !isNaN(numLat) && !isNaN(numLng) &&
             numLat >= -90 && numLat <= 90 &&
             numLng >= -180 && numLng <= 180 &&
             !(numLat === 0 && numLng === 0);
    };

    // If we have valid coordinates, use enhancedWorkerOptions
    // (which handles distance sorting and fallback to regular options)
    // Otherwise, sort alphabetically
    if (isValidCoordinate(shiftLocation?.lat, shiftLocation?.lng)) {
      // enhancedWorkerOptions already handles:
      // - Adding distance labels when nearbyWorkers data is available
      // - Sorting by distance first, then alphabetically
      // - Falling back to regular workerOptions when data isn't ready
      return enhancedWorkerOptions;
    }
    // When coordinates are not available or invalid, return alphabetically sorted options
    return sortWorkersByName(workerOptions);
  }, [workerOptions, enhancedWorkerOptions,  shiftLocation?.lat, shiftLocation?.lng]);

  const participantAlreadySelected = () => {
    const ptId = getValues("pt_id");
    if (Array.isArray(ptId)) return ptId.length > 0;
    return ptId != null && ptId !== "";
  };

  const fetchParticipantsorWorkersForAddShift = async (
    obj = {}
  
  ) => {
    try {
      const response = await fetchOptionsForWorkerAndParticpant(
        calendarView === "worker-view" ? "participant" : "worker",
        // isCoreParticipant
      );

      if (response) {
        if (calendarView === "worker-view") {
          setParticipantOptions(sortParticipantsByName([...response]));
        } else if (!participantAlreadySelected()) {
          // Participant view with no participant yet. Once a participant is
          // chosen, worker_participant_list owns the dropdown. A late
          // employee-list must not replace those associated workers.
          setWorkerOptionsSorted([...response]);
        }
      }
    } catch (err) {
    }
  };

  useEffect(() => {
    if (!isShiftRequestApprovalFlow) return;
    // Shift request already has its participant. Skip employee-list so it
    // cannot overwrite associated workers from worker_participant_list.
    if (calendarView !== "worker-view" && participantAlreadySelected()) return;
    fetchParticipantsorWorkersForAddShift({});
  }, [isShiftRequestApprovalFlow, linkedInReviewShiftRequest?.uuid]);

  // Calendar edit on a shift that belongs to an in_review shift request.
  useEffect(() => {
    if (!isShow || !selectedShift?.uuid || prefillFromShiftRequest) {
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const res = await rosteringApi.getShiftRequestInReviewByShiftUuid(
          selectedShift.uuid
        );
        const row = res?.data?.data ?? res?.data ?? null;
        if (
          cancelled ||
          !row ||
          String(row?.status || "").toLowerCase() !== "in_review"
        ) {
          return;
        }
        setLinkedInReviewShiftRequest(row);
        calendarLinkedShiftRequestRef.current = true;
        if (typeof setPendingShiftRequestApproval === "function") {
          setPendingShiftRequestApproval(row.uuid);
        }
      } catch (linkError) {
        // Not linked to a shift request — normal calendar edit.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    isShow,
    selectedShift?.uuid,
    prefillFromShiftRequest,
    setPendingShiftRequestApproval,
  ]);

  useEffect(() => {
    if (
      userItem !== null &&
      watchFormData?.pt_id &&
      watchFormData?.worker_id === null
      // && !selectedShift?.is_group_shift
      // &&
      // !watchFormData?.open_shift
    ) {
      const UUUID = Array.isArray(watchFormData?.pt_id)
        ? watchFormData?.pt_id?.map((item) => item.uuid)
        : watchFormData?.pt_id;
      handleChangeWorkerOrParticipant({
        type: "participant",
        uuid: UUUID,
      }).then(() => setIsParticipantLoaded(false));
    }
  }, [watchFormData.pt_id]);

  // Auto-populate shift location from participant's address when single participant is selected
  // This effect runs when participant changes to refresh the address
  useEffect(() => {
    let isActive = true;

    // Do NOT clear worker_id when pt_id changes on create. That wiped Add Shift
    // "select worker first, then participant". Worker options refresh preserves
    // the selection instead (see withPreservedSelectedWorker).

    if (isAdvanceMode) {
      return () => {
        isActive = false;
      };
    }

    // Normalize pt_id to array of participant IDs (single or multiple selection)
    const participantIds = watchFormData?.pt_id
      ? (Array.isArray(watchFormData.pt_id)
          ? watchFormData.pt_id.map((item) => item?.uuid ?? item?.value ?? item).filter(Boolean)
          : [watchFormData.pt_id])
      : [];

    // Auto-populate when at least one participant is selected (single or group shift with multiple)
    // For multiple participants: use the first participant (by order) whose location exists
    if (participantIds.length > 0) {
      const fetchParticipantAndSetLocation = async () => {
        let participant = null;
        let participantId = null;

        // Find first participant (in selection order) that has location data
        for (const id of participantIds) {
          participantId = id;
          let p = participantOptions.find(
            (opt) => opt.value === id || opt.uuid === id
          );

          if (!p || !p.street_no || !p.suburb || !p.post_code) {
            try {
              let response = await apiGetRequest(
                `sp/participants/setting-update/${id}`,
                null,
                { allowNotFound: true }
              );
              if (!response?.data?.data || (!response.data.data.street_no && !response.data.data.suburb)) {
                response = await apiGetRequest(`sp/participants/${id}`);
              }
              if (response?.data?.data) {
                const data = response.data.data;
                const apiLat = data.lat;
                const apiLng = data.lng;
                const parsedLat = (apiLat !== null && apiLat !== undefined && apiLat !== '')
                  ? Number(apiLat) : (p?.lat != null && p?.lat !== '') ? Number(p?.lat) : null;
                const parsedLng = (apiLng !== null && apiLng !== undefined && apiLng !== '')
                  ? Number(apiLng) : (p?.lng != null && p?.lng !== '') ? Number(p?.lng) : null;
                p = {
                  ...(p || {}),
                  ...data,
                  street_no: data.street_no || p?.street_no,
                  suburb: data.suburb || p?.suburb,
                  state: data.state || p?.state,
                  state_id: data.state_id || p?.state_id,
                  post_code: data.post_code || p?.post_code,
                  lat: parsedLat,
                  lng: parsedLng,
                };
              }
            } catch (error) {
              continue;
            }
          }

          if (p && p.street_no && p.suburb && p.post_code) {
            participant = p;
            break;
          }
        }

        // If we found a participant with address data, auto-populate location
        if (participant) {
          // Get state name from state_id or state (string)
          let stateName = participant.state;
          let stateValue = participant.state;
          
          // First, if we have state (string) from settings endpoint, use it and get full name from STATES_LIST
          if (stateName && typeof stateName === 'string') {
            const stateOption = STATES_LIST.find(
              (s) => s.value?.toLowerCase() === stateName?.toLowerCase()
            );
            
            // If not found by value, try matching by label (short code like "VIC")
            if (!stateOption) {
              const stateOptionByLabel = STATES_LIST.find(
                (s) => s.label?.toLowerCase() === stateName?.toLowerCase()
              );
              if (stateOptionByLabel) {
                stateName = stateOptionByLabel.value; // Get full name like "Victoria"
                stateValue = stateOptionByLabel.value;
              } else {
                // Keep the original state string if not found in STATES_LIST
              }
            } else {
              stateName = stateOption.value;
              stateValue = stateOption.value;
            }
          }
          // If we don't have state (string) but have state_id, look it up from stateOptions
          // stateOptions structure: { id: X, value: X, name: "State Name", label: "STATE NAME" }
          else if (!stateName && participant.state_id && stateOptions && stateOptions.length > 0) {
            // stateOptions uses value: x.id, so match against value
            const stateFromOptions = stateOptions.find(
              (s) => s.value === participant.state_id || s.id === participant.state_id
            );
            if (stateFromOptions) {
              // Use name (original case) or label (uppercase) - prefer name for better display
              stateName = stateFromOptions.name || stateFromOptions.label;
              stateValue = stateFromOptions.name || stateFromOptions.label;
              
              // Try to get full name from STATES_LIST if we got a short code
              const stateOption = STATES_LIST.find(
                (s) => s.label?.toLowerCase() === stateName?.toLowerCase()
              );
              if (stateOption) {
                stateName = stateOption.value; // Convert "VIC" to "Victoria"
                stateValue = stateOption.value;
              }
            } else {
            }
          }

          // Only set state if we have a string value, not the numeric state_id
          // state_name should always be the display name
          // Ensure lat/lng are numbers if they exist
          const locationData = {
            street: participant.street_no || "",
            suburb: participant.suburb || "",
            state: stateValue || null, // Don't use state_id here, only use if we have a string value
            state_name: stateName || stateValue || "", // This is what will be displayed
            postcode: participant.post_code || "",
            lat: participant.lat !== null && participant.lat !== undefined && participant.lat !== '' 
              ? Number(participant.lat) : null,
            lng: participant.lng !== null && participant.lng !== undefined && participant.lng !== '' 
              ? Number(participant.lng) : null,
          };
          
          if (!isActive) return;
          
          // Check if coordinates are valid - stricter validation
          const isValidCoordinate = (lat, lng) => {
            if (lat == null || lng == null) return false;
            const numLat = Number(lat);
            const numLng = Number(lng);
            // Check if they're valid numbers and within valid lat/lng ranges
            // Also exclude 0,0 which is often a default/placeholder value
            return !isNaN(numLat) && !isNaN(numLng) &&
                   numLat >= -90 && numLat <= 90 &&
                   numLng >= -180 && numLng <= 180 &&
                   !(numLat === 0 && numLng === 0);
          };
          
          const participantHasCoords = isValidCoordinate(participant.lat, participant.lng);
          const locationDataHasCoords = isValidCoordinate(locationData.lat, locationData.lng);
          
          // If coordinates already exist in the database, trust them and use them
          const hasValidCoordinates = participantHasCoords || locationDataHasCoords;
          
          // Only clear coordinates if they are invalid
          if (locationData.lat != null && locationData.lng != null && !isValidCoordinate(locationData.lat, locationData.lng)) {
            locationData.lat = null;
            locationData.lng = null;
          }
          
          // If location was manually set or we're editing a shift, preserve current location
          if (isLocationManuallySet || selectedShift) {
            return;
          }

          // Update location from participant data (only if not manually set and not editing)
          setShiftLocation(locationData);
          setIsLocationManuallySet(false);

          // If participant address exists but coordinates are missing, geocode it
          if (
            isActive &&
            !hasValidCoordinates
          ) {
            // Use backend geocoding API instead of Google Maps API on frontend
            const addressParts = [
              locationData.street,
              locationData.suburb,
              locationData.state_name || locationData.state || "",
              locationData.postcode,
            ].filter(Boolean);
            
            if (addressParts.length === 0) {
              return;
            }
            
            try {
              const response = await apiPostRequest(URL_ROSTERING_GEOCODE_ADDRESS, {
                street: locationData.street || "",
                suburb: locationData.suburb || "",
                state: locationData.state_name || locationData.state || "",
                postcode: locationData.postcode || "",
              });
              
              if (response?.data?.coordinates?.lat && response?.data?.coordinates?.lng) {
                const coords = {
                  lat: response.data.coordinates.lat,
                  lng: response.data.coordinates.lng,
                };
                
                // Additional validation: ensure coordinates are valid
                const isValidCoord = (lat, lng) => {
                  if (lat == null || lng == null) return false;
                  const numLat = Number(lat);
                  const numLng = Number(lng);
                  return !isNaN(numLat) && !isNaN(numLng) &&
                         numLat >= -90 && numLat <= 90 &&
                         numLng >= -180 && numLng <= 180 &&
                         !(numLat === 0 && numLng === 0);
                };
                
                if (isValidCoord(coords.lat, coords.lng) && isActive) {
                  setShiftLocation((prev) => ({
                    ...prev,
                    lat: coords.lat,
                    lng: coords.lng,
                  }));
                }
              }
            } catch (e) {
              // Geocoding failed silently
            }
          }
        } else {
          // No participant with address in selection - only clear location if it wasn't manually set
          if (!selectedShift && !isLocationManuallySet) {
            setShiftLocation({
              street: "",
              suburb: "",
              state: null,
              state_name: "",
              postcode: "",
              lat: null,
              lng: null,
            });
            setIsLocationManuallySet(false);
          }
        }
      };

      fetchParticipantAndSetLocation();
    } else {
      // No participant selected - only clear location if it wasn't manually set
      if (!selectedShift && !isLocationManuallySet) {
        setShiftLocation({
          street: "",
          suburb: "",
          state: null,
          state_name: "",
          postcode: "",
          lat: null,
          lng: null,
        });
        setIsLocationManuallySet(false);
      }
    }
      return () => {
        isActive = false;
      };
  }, [watchFormData?.pt_id, watchFormData?.is_group_shift, participantOptions, selectedShift, isAdvanceMode]);

  /**
   * Load a V5 advance (multi-assignment) shift and open advance mode populated
   * from GET /api/v5/sp/rostering/shift/{idOrUuid}. Frontend-only: falls back to
   * the legacy v2 details flow if the v5 payload can't be parsed.
   * Skeleton stays up until this API succeeds and form fields are populated.
   */
  const markAdvanceTasksLoadedFromApi = (participants = []) => {
    const loadedIds = (participants || [])
      .map((participant) =>
        participant?.id != null ? Number(participant.id) : null
      )
      .filter((id) => id != null && !Number.isNaN(id));
    // Saved shift_tasks are the source of truth — even when the user deleted
    // every settings-prefetched row. Mark those participants as already applied
    // so the hydrate effect cannot put the settings tasks back.
    advanceSkipInitialTaskHydrateRef.current = true;
    advanceAppliedTaskPtIdsRef.current = loadedIds;
    advanceEditTaskLockRef.current = false;
  };

  const getAdvanceShiftDetails = async (idOrUuid) => {
    try {
      advanceEditTaskLockRef.current = true;
      advanceSkipInitialTaskHydrateRef.current = true;
      setAdvanceShiftDetailsLoading(true);
      setShiftDetailLoader(true);
      // Enter advance mode up-front so the modal opens directly in the
      // full-screen advance layout (with the skeleton) instead of briefly
      // flashing the basic modal before the v5 details resolve.
      setIsAdvanceMode(true);
      isAdvanceModeRef.current = true;
      const response = await rosteringApi.getAdvanceWorkerShiftDetails({
        idOrUuid,
      });
      const shift = unwrapAdvanceShiftPayload(response);
      const parsed = shift
        ? parseAdvanceShiftEditResponse(shift, {
            settingsDefaultKmCode,
          })
        : null;

      if (!parsed) {
        // Could not interpret the v5 response — degrade to the legacy flow.
        advanceEditTaskLockRef.current = false;
        advanceSkipInitialTaskHydrateRef.current = false;
        setAdvanceShiftDetailsLoading(false);
        setIsAdvanceMode(false);
        isAdvanceModeRef.current = false;
        await getShiftDetails(idOrUuid);
        return;
      }

      setShiftDetailData(shift);

      // Shared / basic fields
      setValue("shift_date", parsed.shift_date);
      setValue("start_time", parsed.start_time || null);
      setValue("end_time", parsed.end_time || null);
      setValue("location_tracking", parsed.location_tracking);
      setValue("is_signature", parsed.is_signature);
      setValue("is_radius", parsed.is_radius);
      setValue("sleepover", parsed.sleepover);
      setValue("sta", parsed.sta);
      setValue("is_group_shift", true);
      if (parsed.shift_instruction) {
        setValue("shift_instruction", parsed.shift_instruction);
      }

      // Advance-mode selections + segments
      setValue("advance_open_shift", parsed.advance_open_shift);
      setValue(
        "advance_selected_participants",
        parsed.advance_selected_participants,
        { shouldDirty: false }
      );
      setValue("advance_selected_workers", parsed.advance_selected_workers, {
        shouldDirty: false,
      });
      replaceAdvanceSplits(parsed.advance_splits);
      replaceAdvanceCarers(parsed.advance_carers);

      // SIL home — V5 GET returns sil_home_id; uuid/label hydrated in HomeSection
      if (parsed.advance_sil_home_enabled) {
        setValue("advance_sil_home_enabled", true, { shouldDirty: false });
        setValue("advance_sil_home_id", parsed.advance_sil_home_id, {
          shouldDirty: false,
        });
        if (parsed.advance_sil_home_uuid) {
          setValue("advance_sil_home_uuid", parsed.advance_sil_home_uuid, {
            shouldDirty: false,
          });
        }
        if (parsed.advance_sil_home_label) {
          setValue("advance_sil_home_label", parsed.advance_sil_home_label, {
            shouldDirty: false,
          });
        }
      }

      // Shift location
      if (parsed.shift_location) {
        setShiftLocation(parsed.shift_location);
        setIsLocationManuallySet(true);
        setValue("shift_location", parsed.shift_location, {
          shouldValidate: false,
        });
      }

      // Tasks & notes
      setTasks(parsed.tasks || []);
      setNotes(parsed.notes || []);
      setShiftNotes(parsed.shiftNotes || []);
      markAdvanceTasksLoadedFromApi([
        ...(parsed.advance_selected_participants || []),
        ...((shift.form?.participant_ids || []).map((id) => ({ id }))),
        ...((shift.participants || []).map((participant) => ({
          id: participant?.id,
        }))),
      ]);

      // Clear basic single-selects so they don't conflict with advance fields
      setValue("pt_id", null);
      setValue("worker_id", null);

      // Anchor common-resources on participants for the edit fetch
      // (type=participant + participant uuids) even though workers are present.
      setAdvanceEditAnchor("participant");

      setIsAdvanceMode(true);
      isAdvanceModeRef.current = true;

      // V5 details succeeded and fields are populated — remove skeleton.
      setAdvanceShiftDetailsLoading(false);
      setShiftDetailLoader(false);
    } catch (err) {
      // V5 404 / unreadable payload: degrade to legacy v2 details without
      // leaving the modal stuck empty.
      advanceEditTaskLockRef.current = false;
      advanceSkipInitialTaskHydrateRef.current = false;
      setIsAdvanceMode(false);
      isAdvanceModeRef.current = false;
      try {
        await getShiftDetails(idOrUuid);
      } catch (_fallbackErr) {
        setAdvanceShiftDetailsLoading(false);
        setShiftDetailLoader(false);
      }
    }
  };

  /**
   * Resume an incomplete advance builder from GET /shift-drafts/{uuid}.
   * Prefills advance mode from `form` — never calls V2/V5 shift show.
   * Keeps advanceShiftDetailsLoading true until success/failure so Create
   * cannot unlock early when getServiceTypes clears shiftDetailLoader.
   */
  const getAdvanceDraftDetails = async (uuid) => {
    const clearDraftResumeLoaders = () => {
      advanceEditTaskLockRef.current = false;
      setShiftDetailLoader(false);
      setAdvanceShiftDetailsLoading(false);
    };

    try {
      advanceEditTaskLockRef.current = true;
      advanceSkipInitialTaskHydrateRef.current = true;
      setAdvanceShiftDetailsLoading(true);
      setShiftDetailLoader(true);
      setIsAdvanceMode(true);
      isAdvanceModeRef.current = true;
      setActiveDraftUuid(uuid);

      const response = await rosteringApi.getAdvanceShiftDraft({ uuid });
      const envelope = unwrapAdvanceDraftResponse(response);
      // Prefer hydrated `form` from draft show. Raw `payload` only has worker_ids.
      const form = envelope?.form || envelope?.payload || null;

      if (!form) {
        toast.error("Could not load advance shift draft.");
        clearDraftResumeLoaders();
        return;
      }

      // Resolve participant/worker names (SIL home + common-resources) BEFORE
      // mounting the form so chips/cards never flash Participant/Worker #<id>.
      const {
        participantLookup,
        workerLookup,
        silHomeUuid,
        silHomeLabel,
        homeParticipantOptions,
      } = await resolveDraftLookupsBeforeParse({
        form,
        rosteringApi,
        participantLookup: [
          ...(participantOptions || []),
          ...(advanceModeParticipantOptions || []),
          ...(workerAndParticipantOptions?.participants || []),
        ],
        workerLookup: [
          ...(workerOptions || []),
          ...(advanceModeWorkerOptions || []),
          ...(workerAndParticipantOptions?.workers || []),
        ],
      });

      const parsed = parseAdvanceDraftForm(form, {
        participantLookup,
        workerLookup,
        silHomeUuid,
        silHomeLabel,
      });

      if (!parsed) {
        toast.error("Could not load advance shift draft.");
        clearDraftResumeLoaders();
        return;
      }

      setShiftDetailData({
        ...(envelope?.draft || {}),
        is_draft: true,
        form,
      });

      // Seed home options before form mount so selects don't rematch later
      if (homeParticipantOptions?.length) {
        setAdvanceHomeParticipantOptions(
          sortParticipantsByName(
            homeParticipantOptions.filter(isActiveParticipantStatus)
          )
        );
      }

      setValue("shift_date", parsed.shift_date);
      setValue("start_time", parsed.start_time || null);
      setValue("end_time", parsed.end_time || null);
      setValue("location_tracking", parsed.location_tracking);
      setValue("is_signature", parsed.is_signature);
      setValue("is_radius", parsed.is_radius);
      setValue("sleepover", parsed.sleepover);
      setValue("sta", parsed.sta);
      setValue("is_group_shift", true);

      setValue("advance_open_shift", parsed.advance_open_shift);
      setValue(
        "advance_selected_participants",
        parsed.advance_selected_participants,
        { shouldDirty: false }
      );
      setValue("advance_selected_workers", parsed.advance_selected_workers, {
        shouldDirty: false,
      });
      replaceAdvanceSplits(parsed.advance_splits);
      replaceAdvanceCarers(parsed.advance_carers);

      if (parsed.advance_sil_home_enabled) {
        setValue("advance_sil_home_enabled", true, { shouldDirty: false });
        setValue("advance_sil_home_id", parsed.advance_sil_home_id, {
          shouldDirty: false,
        });
        if (parsed.advance_sil_home_uuid) {
          setValue("advance_sil_home_uuid", parsed.advance_sil_home_uuid, {
            shouldDirty: false,
          });
        }
        if (parsed.advance_sil_home_label) {
          setValue("advance_sil_home_label", parsed.advance_sil_home_label, {
            shouldDirty: false,
          });
        }
      }

      if (parsed.shift_location) {
        setShiftLocation(parsed.shift_location);
        setIsLocationManuallySet(true);
        setValue("shift_location", parsed.shift_location, {
          shouldValidate: false,
        });
      }

      setTasks(parsed.tasks || []);
      setNotes(parsed.notes || []);
      setShiftNotes([]);
      markAdvanceTasksLoadedFromApi(parsed.advance_selected_participants);
      setValue("pt_id", null);
      setValue("worker_id", null);
      setAdvanceEditAnchor("participant");
      setIsAdvanceMode(true);
      isAdvanceModeRef.current = true;
      clearDraftResumeLoaders();
    } catch (err) {
      toast.error(err?.message || "Could not load advance shift draft.");
      clearDraftResumeLoaders();
    }
  };

  const getShiftDetails = async (shiftUuid) => {
    try {
      setShiftDetailLoader(true);
      const response = await rosteringApi.workerShiftDetails({ shiftUuid });

      if (response && response?.shift_detail) {
        const data = response.shift_detail;

        setShiftDetailData(data);

        setValue("is_group_shift", parseBooleanVal(data?.is_group_shift));

        // Participant-view group edit: hydrate worker from shift_detail (not calendar
        // row payload). Calendar `selectedShift.worker` is often missing on the
        // 2nd+ participant row, which left the multi-select empty.
        const hasAssignedWorker = Boolean(data?.worker_id || data?.worker?.uuid);
        if (data?.open_group_shift) {
          setValue("open_shift", true);
          setValue("worker_id", null);
        } else if (
          hasAssignedWorker &&
          data?.worker?.uuid &&
          calendarView === "participant-view" &&
          parseBooleanVal(data?.is_group_shift)
        ) {
          setValue("worker_id", [
            {
              ...data.worker,
              label: `${data.worker.first_name || ""} ${
                data.worker.last_name || ""
              }`.trim(),
              value: data.worker.uuid,
              uuid: data.worker.uuid,
            },
          ]);
          setValue("open_shift", false);
        } else if (hasAssignedWorker && data?.worker?.uuid) {
          setValue("worker_id", data.worker.uuid);
          setValue("open_shift", false);
        }

        if (
          parseBooleanVal(data?.is_group_shift) &&
          Array.isArray(data?.participants) &&
          data.participants.length > 0
        ) {
          const mappedParticipants = mapParticipantsToFormValue(
            data.participants
          );
          setParticipantOptions((prev) => {
            const merged = [...(Array.isArray(prev) ? prev : [])];
            mappedParticipants.forEach((mp) => {
              const exists = merged.some(
                (p) => p.uuid === mp.uuid || p.value === mp.value
              );
              if (!exists) merged.push(mp);
            });
            return sortParticipantsByName(merged);
          });
          setValue("pt_id", mappedParticipants);
          if (typeof setSelectedOptions === "function") {
            setSelectedOptions(mappedParticipants);
          }
        } else {
          setValue("pt_id", userItem?.uuid ?? data?.participants?.[0]?.uuid);
        }
        setValue(
          "shift_date",
          moment(data.shift_date, "YYYY-MM-DD").format("YYYY-MM-DD")
        );

        setValue(
          "end_time",
          data?.end_time
            ? moment(data.end_time, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
            : // moment(data.end_time).toDate()
              null
        );

        setValue(
          "start_time",
          data?.start_time
            ? moment(data.start_time, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
            : // moment(data.start_time).toDate()
              null
        );

        // setValue("timeRange", [
        //   data?.start_time
        //     ? // ? moment(data.start_time, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
        //       moment(data.start_time).toDate()
        //     : null,
        //   data?.end_time
        //     ? // ? moment(data.end_time, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
        //       moment(data.end_time).toDate()
        //     : null,
        // ]);

        setValue(
          "worker_start_time",
          data?.worker_start_time
            ? moment(data.worker_start_time, "YYYY-MM-DD HH:mm:ss").format(
                "hh:mm A"
              )
            : null
        );
        setValue(
          "worker_end_time",
          data?.worker_end_time
            ? moment(data.worker_end_time, "YYYY-MM-DD HH:mm:ss").format(
                "hh:mm A"
              )
            : null
        );
        setValue("location_tracking", data?.location_tracking);
        // Seed task-selection key like WorkerShift.jsx so edit can either keep
        // API tasks or allow one settings hydrate when shift_tasks is empty.
        const loadedParticipantKey = getParticipantSelectionKey(
          Array.isArray(data?.participants) && data.participants.length > 0
            ? data.participants
            : data?.participants?.[0] ?? null
        );
        const apiTasks = Array.isArray(data?.shift_tasks)
          ? data.shift_tasks
          : [];
        const hasApiTasks = apiTasks.some(
          (task) => String(task?.task ?? "").trim() !== ""
        );
        if (hasApiTasks) {
          lastAppliedTaskParticipantKeyRef.current =
            loadedParticipantKey || null;
          setTasks(apiTasks);
        } else {
          // Leave null so basic settings hydrate can fill once on edit open.
          lastAppliedTaskParticipantKeyRef.current = null;
        }
        if (data?.shift_notes) {
          setNotes(data?.shift_notes);
        }
        // is_group_shift already set above from shift_detail (boolean-safe)
        setValue("shift_accept", data?.shift_accept ?? true);
        setValue("is_signature", data?.is_signature ?? true);
        setValue("invoice_service_type_id", data?.invoice_service_type_id);
        setValue("sleepover", data?.sleepover);
        setValue("sta", parseBooleanVal(data?.sta));
        setValue("is_radius", data?.is_radius ?? false);
        setValue("shift_instruction", data?.shift_instruction || "");

        // Initialize location data if it exists
        if (data?.shift_location) {
          let locationData = data.shift_location;
          // Parse if it's a JSON string
          if (typeof locationData === 'string') {
            try {
              locationData = JSON.parse(locationData);
            } catch (e) {
              locationData = null;
            }
          }
          
          if (locationData && (locationData.street || locationData.street_address || locationData.suburb)) {
            setShiftLocation({
              street: locationData.street || locationData.street_address || "",
              suburb: locationData.suburb || "",
              state: locationData.state || null,
              postcode: locationData.postcode || "",
              state_name: locationData.state_name || "",
              lat: locationData.lat || null,
              lng: locationData.lng || null,
            });
            // When editing, preserve the shift's saved location: do not let the participant
            // sync effect overwrite or clear it. Treat any loaded shift_location as manually set.
            setIsLocationManuallySet(true);

            // Also set in form data
            setValue("shift_location", {
              street: locationData.street || locationData.street_address || "",
              suburb: locationData.suburb || "",
              state: locationData.state || null,
              state_name: locationData.state_name || "",
              postcode: locationData.postcode || "",
              lat: locationData.lat || null,
              lng: locationData.lng || null,
            }, { shouldValidate: false });
          }
        }
    
      }
      setShiftDetailLoader(false);
      {
        /*Calling the API again to ensure that participants are preselected correctly in the worker view for group shifts, as the participant dropdown sometimes preselects and sometimes remains empty.*/
      }

      if (response?.shift_detail) {
        const loadedShift = response.shift_detail;
        if (userItem !== null && calendarView === "worker-view") {
          handleChangeWorkerOrParticipant({
            type: "worker",
            uuid: loadedShift?.worker?.uuid ?? watchFormData.worker_id,
          })
            .then(() => setIsWorkerLoaded(false))
            .catch(() => setIsWorkerLoaded(false));
        } else if (userItem !== null && calendarView === "participant-view") {
          // Load worker options for this participant; worker_id already hydrated
          // from shift_detail above so 2nd+ participant rows still show workers.
          const ptUuid =
            parseBooleanVal(loadedShift?.is_group_shift) &&
            Array.isArray(loadedShift?.participants) &&
            loadedShift.participants.length > 0
              ? loadedShift.participants.map((p) => p.uuid)
              : loadedShift?.participants?.[0]?.uuid ?? userItem?.uuid;
          if (ptUuid) {
            handleChangeWorkerOrParticipant({
              type: "participant",
              uuid: ptUuid,
            }).catch(() => {});
          }
        }
      }
    } catch (err) {
      setShiftDetailLoader(false);
    }
  };

  const [
    shouldCallHandleChangeWorkerOrParticipant,
    setShouldCallHandleChangeWorkerOrParticipant,
  ] = useState(true);
  const groupShiftParticipantKey = getParticipantSelectionKey(
    watchFormData?.pt_id
  );
  useEffect(() => {
    if (
      userItem !== null &&
      calendarView === "worker-view" &&
      parseBooleanVal(watchFormData?.is_group_shift) &&
      watchFormData?.pt_id &&
      shouldCallHandleChangeWorkerOrParticipant &&
      groupShiftParticipantKey &&
      lastGroupShiftListingKeyRef.current !== groupShiftParticipantKey
    ) {
      const UUUID = Array.isArray(watchFormData?.pt_id)
        ? watchFormData?.pt_id
            ?.map((item) => item?.uuid ?? item?.value ?? item)
            .filter(Boolean)
        : watchFormData?.pt_id;

      lastGroupShiftListingKeyRef.current = groupShiftParticipantKey;
      handleChangeWorkerOrParticipant({
        type: "participant",
        uuid: UUUID,
      }).then(() => setIsParticipantLoaded(false));
    }
  }, [
    groupShiftParticipantKey,
    watchFormData?.is_group_shift,
    shouldCallHandleChangeWorkerOrParticipant,
    userItem,
    calendarView,
  ]);

  // Allow a fresh listing fetch after group shift is turned off then on again.
  useEffect(() => {
    if (!parseBooleanVal(watchFormData?.is_group_shift)) {
      lastGroupShiftListingKeyRef.current = null;
    }
  }, [watchFormData?.is_group_shift]);

  const handleChangeWorkerOrParticipant = async (
    { type, uuid, id = null, isChanged = false },
    additionalParams = {}
  ) => {
    try {
      setIsFetchRecordDetailLoader(true);

      // Capture before await so participant refresh cannot drop the selection
      // if workerOptions changes while the request is in flight.
      const workerIdBeforeFetch = getValues("worker_id");
      const preservedWorkerOption =
        workerIdBeforeFetch != null &&
        workerIdBeforeFetch !== "" &&
        !Array.isArray(workerIdBeforeFetch)
          ? (workerOptions || []).find(
              (w) =>
                String(w?.value) === String(workerIdBeforeFetch) ||
                String(w?.uuid) === String(workerIdBeforeFetch)
            ) || null
          : null;

      let params =
        type === "worker"
          ? { type: type, worker_id: uuid }
          : { type: type, pt_id: uuid };

      if (isShiftRequestApprovalFlow && calendarView === "participant-view") {
        params.parent_view = "participant";
      }

      const response = await api.getWorkerAndParticipantList(params);

      const mapWorkersToOptions = (list = []) =>
        (list || []).map((x) => ({
          ...x,
          label: `${x.first_name} ${x.last_name}`,
          value: x.uuid,
          icon: x?.photo
            ? baseURLImage(x.photo)
            : getNameProfile(x.first_name, x.last_name || " "),
        }));

      // Add Shift: selecting a participant refreshes worker options. If the
      // already-selected worker is missing from the new list, Select clears
      // worker_id. Keep that worker in options so the selection is preserved.
      const withPreservedSelectedWorker = (nextWorkers = []) => {
        if (!(isCallFromAddShift && selectedShift === null)) {
          return nextWorkers || [];
        }
        const currentWorkerId =
          getValues("worker_id") ?? workerIdBeforeFetch;
        if (
          currentWorkerId == null ||
          currentWorkerId === "" ||
          Array.isArray(currentWorkerId)
        ) {
          return nextWorkers || [];
        }
        const workerKey = String(currentWorkerId);
        const list = nextWorkers || [];
        if (
          list.some(
            (w) =>
              String(w?.value) === workerKey || String(w?.uuid) === workerKey
          )
        ) {
          return list;
        }
        const prev =
          preservedWorkerOption ||
          (workerOptions || []).find(
            (w) =>
              String(w?.value) === workerKey || String(w?.uuid) === workerKey
          );
        return prev ? [prev, ...list] : list;
      };

      if (
        isCallFromAddShift &&
        additionalParams?.isCheckWorkerExist &&
        getValues("worker_id")
      ) {
        // Compatibility check only — do not clear an already-selected worker on
        // Add Shift when they are absent from the participant's worker list.
        if (type === "participant") {
          // fall through to option refresh + preserve
        }
      } else if (
        isCallFromAddShift &&
        additionalParams?.isCheckParticipantExist &&
        watchFormData?.pt_id
      ) {
        if (type === "worker") {
          const index =
            response?.worker_participant_listing?.worker?.participants?.findIndex(
              (c) => c.uuid === watchFormData?.pt_id
            );
          if (index === -1) {
            setValue("pt_id", null);
            setParticipantOptions(sortParticipantsByName([
              ...response.worker_participant_listing.participant?.participants.map(
                (x) => ({
                  ...x,
                  label: `${x.first_name} ${x.last_name}`,
                  value: x.uuid,
                  icon: x?.profile_picture
                    ? baseURLImage(x.profile_picture)
                    : getNameProfile(x.first_name, x.last_name || " "),
                })
              ),
            ]));
            setIsFetchRecordDetailLoader(false);
            return;
          }
        }
      }

      if (
        type === "worker" &&
        response &&
        response.worker_participant_listing &&
        response.worker_participant_listing.worker &&
        response.worker_participant_listing.worker.participants
      ) {
        setParticipantOptions(sortParticipantsByName([
          ...response.worker_participant_listing.worker.participants.map(
            (x) => ({
              ...x,
              label: `${x.first_name} ${x.last_name}`,
              value: x.uuid,
              icon: x?.profile_picture
                ? baseURLImage(x.profile_picture)
                : getNameProfile(x.first_name, x.last_name || " "),
              participant_tasks:
                x.participant_tasks ?? x.participantTasks ?? x.tasks ?? [],
            })
          ),
        ]));

        if (id && isCallFromAddShift) {
          setValue("worker_id", id);
        }
      } else if (
        type === "participant" &&
        response &&
        response?.worker_participant_listing &&
        (response?.worker_participant_listing?.participant ||
          response?.worker_participant_listing?.common_worker)
      ) {
        if (watchFormData?.open_shift || shiftDetailData?.open_group_shift) {
          setWorkerOptionsSorted(
            withPreservedSelectedWorker(
              mapWorkersToOptions(
                response.worker_participant_listing?.common_worker
              )
            )
          );
        } else if (
          calendarView === "worker-view" &&
          (shiftDetailData?.is_group_shift || watchFormData?.is_group_shift) &&
          response?.worker_participant_listing?.common_worker
        ) {
          setWorkerOptionsSorted(
            withPreservedSelectedWorker(
              mapWorkersToOptions(
                response.worker_participant_listing?.common_worker
              )
            )
          );
        } else {
          setWorkerOptionsSorted(
            withPreservedSelectedWorker(
              mapWorkersToOptions(
                response.worker_participant_listing?.participant?.sp_workers
              )
            )
          );
        }

        // Re-assert worker after options refresh so Select cannot leave it empty.
        if (
          isCallFromAddShift &&
          selectedShift === null &&
          workerIdBeforeFetch != null &&
          workerIdBeforeFetch !== "" &&
          !Array.isArray(workerIdBeforeFetch)
        ) {
          setValue("worker_id", workerIdBeforeFetch, { shouldDirty: true });
        }
      }

      // Basic mode: hydrate shift tasks from participant settings in the API
      // response (advance mode uses its own participant-selection effect).
      if (!isAdvanceModeRef.current) {
        const selectionKeyForTaskRefresh =
          type === "participant"
            ? getParticipantSelectionKey(uuid)
            : getParticipantSelectionKey(watchFormData?.pt_id);
        const hasTaskParticipantSelectionChanged =
          lastAppliedTaskParticipantKeyRef.current != null &&
          selectionKeyForTaskRefresh !== "" &&
          selectionKeyForTaskRefresh !==
            lastAppliedTaskParticipantKeyRef.current;

        // Edit open with empty shift_tasks: one settings hydrate (create already does this).
        const hasExistingNonEmptyTasks = (tasksRef.current || []).some(
          (task) => String(task?.task ?? "").trim() !== ""
        );
        const shouldHydrateEmptyEditFromSettings =
          selectedShift !== null &&
          !isChanged &&
          !hasExistingNonEmptyTasks &&
          lastAppliedTaskParticipantKeyRef.current == null;

        const shouldRefreshTasksFromParticipantSettings =
          selectedShift === null ||
          (isChanged && hasTaskParticipantSelectionChanged) ||
          shouldHydrateEmptyEditFromSettings;

        if (
          shouldRefreshTasksFromParticipantSettings &&
          (watchFormData?.pt_id || (type === "participant" && uuid))
        ) {
          let participantsWithTasks = [];

          if (type === "participant") {
            const listing = response?.worker_participant_listing?.participant;
            if (listing) {
              participantsWithTasks = Array.isArray(listing)
                ? listing
                : [listing];
            }
          } else if (
            type === "worker" &&
            response?.worker_participant_listing?.worker?.participants
          ) {
            const allParticipants =
              response.worker_participant_listing.worker.participants;
            const watchPtId = watchFormData.pt_id;
            const selectedUuids = Array.isArray(watchPtId)
              ? watchPtId.map((item) => item?.uuid ?? item?.value ?? item)
              : [watchPtId];
            participantsWithTasks = allParticipants.filter((participant) =>
              selectedUuids.includes(participant.uuid)
            );
          }

          if (participantsWithTasks.length > 0) {
            const shiftTasks =
              mapParticipantTasksToShiftTasks(participantsWithTasks);
            if (shiftTasks.length > 0) {
              lastAppliedTaskParticipantKeyRef.current =
                selectionKeyForTaskRefresh;
              setTasks(shiftTasks);
            } else {
              const selectedPtIds = new Set(
                participantsWithTasks
                  .map((participant) => Number(participant?.id))
                  .filter(Boolean)
              );
              const hasTasksForCurrentSelection = (
                tasksRef.current || []
              ).some(
                (task) =>
                  String(task?.task ?? "").trim() !== "" &&
                  selectedPtIds.has(Number(task?.pt_id))
              );
              // Create or participant-change: drop previous participant's tasks
              // when this selection has none. Keep only if rows already belong
              // to the current pt_id (listing may omit task arrays).
              const shouldApplyEmptyTasks =
                !hasTasksForCurrentSelection &&
                (selectedShift === null ||
                  hasTaskParticipantSelectionChanged ||
                  shouldHydrateEmptyEditFromSettings);

              if (shouldApplyEmptyTasks) {
                lastAppliedTaskParticipantKeyRef.current =
                  selectionKeyForTaskRefresh;
                const isMultiParticipantGroup =
                  parseBooleanVal(watchFormData?.is_group_shift) &&
                  participantsWithTasks.length > 1;
                setTasks(
                  isMultiParticipantGroup ? [] : [{ ...EMPTY_SHIFT_TASK }]
                );
              }
            }
          } else if (
            hasTaskParticipantSelectionChanged ||
            shouldHydrateEmptyEditFromSettings
          ) {
            lastAppliedTaskParticipantKeyRef.current =
              selectionKeyForTaskRefresh;
            const selectedCount = Array.isArray(watchFormData?.pt_id)
              ? watchFormData.pt_id.length
              : watchFormData?.pt_id
              ? 1
              : 0;
            const isMultiParticipantGroup =
              parseBooleanVal(watchFormData?.is_group_shift) &&
              selectedCount > 1;
            setTasks(isMultiParticipantGroup ? [] : [{ ...EMPTY_SHIFT_TASK }]);
          }
        }
      }

      setIsFetchRecordDetailLoader(false);

      if (selectedShift !== null) {
        const isGroupShiftForm = parseBooleanVal(getValues("is_group_shift"));
        const mapListingParticipantsToForm = (listing) => {
          const list = Array.isArray(listing)
            ? listing
            : listing
            ? [listing]
            : [];
          return list
            .filter((p) => p?.uuid || p?.value)
            .map((p) => ({
              ...p,
              uuid: p.uuid ?? p.value,
              value: p.uuid ?? p.value,
              label:
                p.label ||
                `${p.first_name || ""} ${p.last_name || ""}`.trim(),
              icon: p.icon
                ? p.icon
                : p.profile_picture
                ? baseURLImage(p.profile_picture)
                : getNameProfile(p.first_name, p.last_name || " "),
            }));
        };

        if (
          calendarView === "worker-view" &&
          response.worker_participant_listing?.participant &&
          isChanged
        ) {
          const listingParticipant =
            response.worker_participant_listing?.participant;
          // Group shift multi-select must stay an array — collapsing to a scalar
          // UUID retriggers ParticipantSelection → listing effect (rate-limit loop).
          if (isGroupShiftForm) {
            const currentPtId = getValues("pt_id");
            const currentKey = getParticipantSelectionKey(currentPtId);
            // Keep MultiSelect selection — rewriting from listing used to collapse
            // length===1 to a scalar UUID and re-trigger the listing effect.
            if (currentKey) {
              lastGroupShiftListingKeyRef.current = currentKey;
            } else {
              const mapped = mapListingParticipantsToForm(listingParticipant);
              if (mapped.length > 0) {
                const nextKey = getParticipantSelectionKey(mapped);
                lastGroupShiftListingKeyRef.current = nextKey;
                setValue("pt_id", mapped);
              }
            }
          } else if (
            parseBooleanVal(shiftDetailData?.is_group_shift) ||
            parseBooleanVal(selectedShift?.is_group_shift)
          ) {
            // Worker-view conversion (group toggle off): keep a scalar UUID so
            // the single SelectOption can bind. Do not change non-group edits.
            const pickedUuid = getValues("pt_id");
            const listingUuid = Array.isArray(listingParticipant)
              ? listingParticipant[0]?.uuid ?? listingParticipant[0]?.value
              : listingParticipant?.uuid ?? listingParticipant?.value;
            const scalarUuid =
              (!Array.isArray(pickedUuid) && pickedUuid) || listingUuid || null;
            if (scalarUuid) {
              setValue("pt_id", scalarUuid);
            }
          } else if (
            Array.isArray(listingParticipant) &&
            listingParticipant.length === 1
          ) {
            setValue("pt_id", listingParticipant[0]?.uuid);
          } else if (Array.isArray(listingParticipant)) {
            setValue("pt_id", listingParticipant);
          } else {
            setValue("pt_id", [listingParticipant]);
          }
        } else if (
          calendarView === "worker-view" &&
          !isChanged &&
          selectedShift?.participants
        ) {
          if (isGroupShiftForm) {
            // Group edit: may hydrate incomplete seed (e.g. only userItem uuid).
            // Restore from shift participants when form has fewer — never scalar,
            // and never shrink a user expansion (single→group add participant).
            const participantsForForm =
              Array.isArray(shiftDetailData?.participants) &&
              shiftDetailData.participants.length > 0
                ? shiftDetailData.participants
                : selectedShift.participants;
            const currentKey = getParticipantSelectionKey(getValues("pt_id"));
            const shiftKey = getParticipantSelectionKey(participantsForForm);
            const currentCount = currentKey
              ? currentKey.split("|").filter(Boolean).length
              : 0;
            const shiftCount = shiftKey
              ? shiftKey.split("|").filter(Boolean).length
              : 0;

            if (shiftCount > 0 && currentCount < shiftCount) {
              const mapped =
                mapListingParticipantsToForm(participantsForForm);
              lastGroupShiftListingKeyRef.current =
                getParticipantSelectionKey(mapped);
              setValue("pt_id", mapped);
            } else if (currentKey) {
              lastGroupShiftListingKeyRef.current = currentKey;
            }
          } else if (
            parseBooleanVal(shiftDetailData?.is_group_shift) ||
            parseBooleanVal(selectedShift?.is_group_shift)
          ) {
            // Conversion: do not re-apply the original group participant list
            // onto the single-select (that undoes the cleared/new pick).
            const currentPtId = getValues("pt_id");
            if (Array.isArray(currentPtId) && currentPtId.length > 0) {
              const first = currentPtId[0];
              setValue(
                "pt_id",
                first?.uuid || first?.value || first || null
              );
            }
          } else if (selectedShift?.participants.length === 1) {
            setValue("pt_id", selectedShift?.participants[0]?.uuid);
          } else {
            setValue("pt_id", selectedShift?.participants);
          }
        } else if (
          calendarView === "participant-view" &&
          selectedShift !== null &&
          !watchFormData?.open_shift &&
          !shiftDetailData?.open_group_shift
        ) {
          // Keep shift_detail hydration (array) if already set — calendar row
          // `selectedShift.worker` is unreliable for non-first participants.
          if (
            Array.isArray(watchFormData?.worker_id) &&
            watchFormData.worker_id.length > 0
          ) {
            // Ensure options include selected workers so MultiSelect can render them
            setWorkerOptions((prev) => {
              const current = Array.isArray(prev) ? prev : [];
              const merged = [...current];
              watchFormData.worker_id.forEach((w) => {
                const uuid = w?.uuid || w?.value || w;
                if (!uuid) return;
                if (merged.some((o) => o.uuid === uuid || o.value === uuid)) {
                  return;
                }
                merged.push({
                  ...w,
                  uuid,
                  value: uuid,
                  label:
                    w?.label ||
                    `${w?.first_name || ""} ${w?.last_name || ""}`.trim(),
                });
              });
              return sortWorkersByName(merged);
            });
          } else {
            const workerSource =
              shiftDetailData?.worker?.uuid
                ? shiftDetailData.worker
                : selectedShift?.worker?.uuid
                ? selectedShift.worker
                : null;
            if (workerSource?.uuid) {
              const isGroup = parseBooleanVal(
                watchFormData?.is_group_shift ||
                  shiftDetailData?.is_group_shift ||
                  selectedShift?.is_group_shift
              );
              if (isGroup) {
                setValue("worker_id", [
                  {
                    ...workerSource,
                    label: `${workerSource.first_name || ""} ${
                      workerSource.last_name || ""
                    }`.trim(),
                    value: workerSource.uuid,
                    uuid: workerSource.uuid,
                  },
                ]);
              } else {
                setValue("worker_id", workerSource.uuid);
              }
            }
          }
        }
      }
    } catch (err) {
      setIsFetchRecordDetailLoader(false);
    }
  };

  useEffect(() => {
    if (
      userItem !== null &&
      watchFormData?.worker_id &&
      watchFormData?.pt_id === null &&
      !watchFormData?.open_shift
    ) {
      handleChangeWorkerOrParticipant({
        type: "worker",
        uuid: watchFormData.worker_id,
      })
        .then(() => setIsWorkerLoaded(false))
        .catch(() => setIsWorkerLoaded(false));
    }
  }, [watchFormData.worker_id]);

  const onSubmit = (data, isPublish = null, submitOptions = {}) => {
    const advanceModeActive =
      submitOptions.advanceMode ?? isAdvanceModeRef.current;
    const preparedShiftInstructions =
      shiftInstructions?.length > 0 &&
      shiftInstructions?.map((item) => ({
        pt_id: item?.id,
        shift_instruction: item?.shift_instruction
          ? item?.shift_instruction
          : null,
      }));

    if (isUserGracePeriodOver) {
      return;
    }

    const showToastMsg = (message, toastId) => {
      setTimeout(() => {
        if (!toast.isActive(toastId)) {
          toast.warning(message, { toastId: toastId });
        }
      }, 200);
    };

    if (advanceModeActive) {
      const workerOrOpenShiftCheck = validateAdvanceWorkerOrOpenShift(watchFormData);
      if (workerOrOpenShiftCheck !== true) {
        showToastMsg(workerOrOpenShiftCheck, "advanceModeNoWorkerOpenShift");
        return;
      }
      const workerShiftCoverageCheck =
        validateAdvanceWorkerShiftWindowCoverage(watchFormData);
      if (workerShiftCoverageCheck !== true) {
        showToastMsg(workerShiftCoverageCheck, "advanceModeWorkerShiftCoverage");
        return;
      }
      if (!parseBooleanVal(watchFormData?.advance_open_shift)) {
        const carers = watchFormData?.advance_carers || [];
        for (let i = 0; i < carers.length; i++) {
          const c = carers[i];
          if (!isOpenSlotRow(c) && !c?.worker) {
            showToastMsg(
              `Worker slot ${i + 1}: select a worker`,
              `advanceModeCarer${i}`
            );
            return;
          }
        }
      }
      if (watchFormData?.advance_sil_home_enabled && !watchFormData?.advance_sil_home_id) {
        showToastMsg("Select a home from Home Management", "advanceModeSilHome");
        return;
      }
    }

    const showToast = (message, toastId) => {
      setTimeout(() => {
        if (!toast.isActive(toastId)) {
          toast.warning(message, { toastId: toastId });
        }
      }, 200);
    };

    if (!advanceModeActive) {
      if (
        watchFormData?.is_group_shift &&
        calendarView === "worker-view" &&
        (watchFormData?.pt_id.length < 2 || !Array.isArray(watchFormData?.pt_id))
      ) {
        const toastId = "isSingleGroupShift";

        setTimeout(() => {
          if (!toast.isActive(toastId)) {
            toast.warning(
              "Single participant can't be selected for group shift",
              { toastId: toastId }
            );
          }
        }, 200);
        return;
      }

      if (
        calendarView === "participant-view" &&
        (!Array.isArray(watchFormData?.pt_id) ||
          watchFormData?.pt_id?.length < 2) &&
        watchFormData?.is_group_shift &&
        watchFormData?.open_shift
      ) {
        const toastId = "isGroupOpenShift";

        setTimeout(() => {
          if (!toast.isActive(toastId)) {
            toast.warning(
              "Single participant can't be selected for open group shift",
              { toastId: toastId }
            );
          }
        }, 200);
        return;
      }

      if (watchFormData?.is_group_shift) {
        if (calendarView === "worker-view" && watchFormData?.pt_id.length < 2) {
          showToast(
            "Single participant can't be selected for group shift",
            "isSingleGroupShift"
          );
          return;
        }

        if (
          calendarView === "participant-view" &&
          watchFormData?.worker_id?.length < 2
        ) {
          showToast(
            "Single worker can't be selected for group shift",
            "isSingleGroupShiftWorker"
          );
          return;
        }
      }
    }

    if (!advanceModeActive && notes?.length > 0) {
      Object.assign(data, {
        shift_notes: notes.map((item) => ({
          pt_id: item?.pt_id,
          notes: item?.notes || null,
        })),
      });
    }

    // UI hides the recurring toggle for past dates; keep submit state in sync.
    if (
      selectedShift === null &&
      isDateInPast(data?.shift_date || watchFormData?.shift_date)
    ) {
      data.is_recurring = false;
    }

    if (
      selectedShift === null &&
      data?.is_recurring &&
      recurringDates.length === 0
    ) {
      showToast(
        "Choose recurring interval or disable the recurring option",
        "isRecurringShiftToast"
      );
      return;
    }

    // if (
    //   watchFormData?.is_recurring &&
    //   recurringDates.length >= 0 &&
    //   watchFormData?.shift_date &&
    //   !validateCurrentDate(
    //     moment(watchFormData?.shift_date),
    //     moment(new Date()),
    //     ["past"],
    //     false
    //   )
    // ) {
    //   showToast(
    //     "Recurring shifts cannot be created for past date.",
    //     "isRecurringShiftDateValidationToast"
    //   );
    //   return;
    // }

    if (
      advanceModeActive &&
      (selectedShift === null || isAdvanceShiftDraft(selectedShift))
    ) {
      const advancePayload = buildAdvanceShiftCreatePayload({
        watchFormData: { ...watchFormData, ...data },
        advanceSplits: data?.advance_splits || watchFormData?.advance_splits || [],
        advanceCarers: data?.advance_carers || watchFormData?.advance_carers || [],
        shiftLocation,
        participantOptions: advanceModeParticipantOptions,
        workerOptions: advanceModeWorkerOptions,
        notes,
        tasks,
        shiftInstructions,
        timezone: momentTimeZone.tz.guess(),
      });

      if (isPublish === "isPublish") {
        advancePayload.is_publish = true;
      }

      // Recurrence — V5 advance create accepts the same legacy-aliased fields the
      // basic create flow sends (handled by StoreV5AdvanceShiftRequest).
      if (
        watchFormData?.is_recurring &&
        recurringDates.length > 0 &&
        !isDateInPast(watchFormData?.shift_date)
      ) {
        Object.assign(advancePayload, {
          is_recurring: true,
          till_dates: recurringDates,
          recurring_days: convertDaysName(selectedDays),
          recurring_interval: capitalizeFirstLetter(recurrInterval.value),
          repeat_for: formatRecurringValue(recurringType.value),
        });
      }

      setISInitialCreateShiftLoader(LOADER_STATUS.PENDING);

      const draftUuidToClear =
        activeDraftUuid ||
        (isAdvanceShiftDraft(selectedShift) ? selectedShift?.uuid : null);

      createOrUpdateWorkerShiftRequest(
        {
          data: advancePayload,
          isAdvanceShift: true,
          calendarView: calendarView,
          isUpdate: false,
          isWorkerChange: false,
          prevWorkerUUID: null,
          name: capitalizeAllLetters(
            `${userItem?.first_name || ""} ${userItem?.last_name || ""}`.trim()
          ),
        },
        async () => {
          // Real shift created from a resumed/saved draft — discard staging draft
          if (draftUuidToClear) {
            try {
              await rosteringApi.deleteAdvanceShiftDraft({
                uuid: draftUuidToClear,
              });
            } catch (e) {
              // Shift was created; draft cleanup is best-effort
            }
            dispatch(
              advanceShiftDraftDeleteLocally({ uuid: draftUuidToClear })
            );
            setActiveDraftUuid(null);
          }
          refreshShiftStats();
        }
      );

      setTimeout(() => {
        refreshShiftStats();
      }, 2000);

      return;
    }

    // Update an existing shift that is being saved as an advance shift. This
    // covers both "advance -> advance" (just updating) and "basic -> advance"
    // (converting). Either way we hit PUT /api/v5/.../shift/{uuid}/advance.
    // The reverse case ("advance -> basic") leaves advanceModeActive false and
    // falls through to the existing v2 update flow below.
    // Drafts are not real shifts — they use the create path above.
    if (
      advanceModeActive &&
      selectedShift !== null &&
      !isAdvanceShiftDraft(selectedShift)
    ) {
      const advancePayload = buildAdvanceShiftCreatePayload({
        watchFormData: { ...watchFormData, ...data },
        advanceSplits: data?.advance_splits || watchFormData?.advance_splits || [],
        advanceCarers: data?.advance_carers || watchFormData?.advance_carers || [],
        shiftLocation,
        participantOptions: advanceModeParticipantOptions,
        workerOptions: advanceModeWorkerOptions,
        notes,
        tasks,
        shiftInstructions,
        timezone: momentTimeZone.tz.guess(),
      });

      if (isPublish === "isPublish") {
        advancePayload.is_publish = true;
      }

      const advanceRequest = {
        data: {
          ...advancePayload,
          uuid: selectedShift.uuid,
          id: selectedShift.id,
        },
        isAdvanceShift: true,
        calendarView: calendarView,
        isUpdate: true,
        isWorkerChange: false,
        prevWorkerUUID: null,
        name: capitalizeAllLetters(
          `${userItem?.first_name || ""} ${userItem?.last_name || ""}`.trim()
        ),
      };

      // Recurring advance shift — show the same "this shift / all future shifts"
      // confirmation used in basic mode. The modal injects recurring_impact onto
      // the payload and re-dispatches this request (which still routes to the V5
      // advance update via isAdvanceShift).
      // Past occurrences: confirm instance-only update (no series toggle / fan-out).
      if (shiftDetailData?.recurring_interval != null) {
        if (!isPastRecurringShiftUpdate()) {
          setRecurringUpdateShiftData(advanceRequest);
          setUpdateShiftRecurringModal(true);
          return;
        }
        advanceRequest.data.recurring_impact = false;
        setRecurringUpdateShiftData(advanceRequest);
        setShowPastRecurringUpdateConfirm(true);
        return;
      }

      setISInitialCreateShiftLoader(LOADER_STATUS.PENDING);

      createOrUpdateWorkerShiftRequest(advanceRequest, () => {
        refreshShiftStats();
      });

      setTimeout(() => {
        refreshShiftStats();
      }, 2000);

      return;
    }

    const currentTimeZone = momentTimeZone.tz.guess();

    const defaultPtId = Array.isArray(selectedParticipant)
      ? selectedParticipant[0]?.id
      : selectedParticipant?.id;

    // Basic/legacy create — single-worker shift; keep worker_id null (all / sole worker).
    const filteredTasks = (tasks || [])
      .filter((task) => task?.task !== "" && task?.task != null)
      .map((task) => {
        const baseTask = {
          task: task.task,
          is_mandatory: resolveMandatoryFlag(task.is_mandatory),
          participant_task_id: task.participant_task_id ?? null,
          pt_id: task.pt_id ?? defaultPtId ?? null,
          worker_id: null,
        };
        if (task.id) {
          return {
            id: task.id,
            uuid: task.uuid,
            is_completed: Boolean(task.is_completed),
            ...baseTask,
          };
        }
        return baseTask;
      });

    // Always send shift_tasks on edit so omitting the key does not wipe DB tasks (V2).
    if (filteredTasks.length > 0 || selectedShift !== null) {
      Object.assign(data, {
        shift_tasks: filteredTasks,
      });
    }
    if (preparedShiftInstructions?.length > 0) {
      Object.assign(data, {
        shift_instructions: preparedShiftInstructions,
      });
    }
    const workerCount = Array.isArray(workerRatio)
      ? workerRatio?.length
      : workerRatio
      ? 1
      : 0;
    const participantCount = Array.isArray(participantRatio)
      ? participantRatio?.length
      : participantRatio
      ? 1
      : 0;

    Object.assign(data, {
      timezone: currentTimeZone,
      // Same start/end clock time = 24h window (matches advance mode). getShiftLength
      // returns "00:00" for equal times, so use the 24h-aware helper instead.
      shift_length:
        getBasicShiftDurationHHMM(
          watchFormData?.start_time,
          watchFormData?.end_time
        ) ||
        getShiftLength(
          watchFormData?.start_time,
          watchFormData?.end_time,
          true
        ),
      is_group_shift: watchFormData?.is_group_shift || false,
      is_signature: watchFormData?.is_signature,
      shift_date: moment(new Date(watchFormData.shift_date)).toISOString(),
      ratio: `${workerCount}:${participantCount}`,

      start_time: convertTimeToDatetimeLocal(
        moment(watchFormData.shift_date),
        watchFormData.start_time
      ),
      end_time:
        isCheckNextDayShift(
          watchFormData?.shift_date,
          watchFormData?.start_time,
          watchFormData?.end_time
        ) !== false
          ? isCheckNextDayShift(
              watchFormData?.shift_date,
              watchFormData?.start_time,
              watchFormData?.end_time
            )
          : convertTimeToDatetimeLocal(
              moment(watchFormData.shift_date),
              watchFormData.end_time
            ),
      worker_start_time:
        shiftDetailData && shiftDetailData?.worker_start_time
          ? shiftDetailData?.worker_start_time
          : "",
      worker_end_time:
        shiftDetailData && shiftDetailData?.worker_end_time
          ? shiftDetailData?.worker_end_time
          : "",
      

      location_tracking: data?.location_tracking,
    });

    if (data.hasOwnProperty("task")) delete data["task"];
    if (!advanceModeActive && calendarView === "worker-view") {
      let participantId;

      if (Array.isArray(watchFormData?.pt_id)) {
        const resolveWorkerViewParticipantId = (item) => {
          if (item == null) return null;
          if (typeof item === "number") return item;
          if (typeof item === "string" && /^\d+$/.test(item)) return Number(item);
          const itemUuid = item?.uuid ?? item?.value ?? item;
          const matchingParticipant = participantOptions.find(
            (option) =>
              option.uuid === itemUuid ||
              option.value === itemUuid ||
              option.id === item?.id
          );
          const resolved = matchingParticipant?.id ?? item?.id ?? null;
          return resolved != null && resolved !== "" ? Number(resolved) : null;
        };

        participantId =
          watchFormData?.is_group_shift &&
          watchFormData &&
          watchFormData.pt_id.length > 0
            ? watchFormData.pt_id
                .map((item) => resolveWorkerViewParticipantId(item))
                .filter((id) => id != null && !Number.isNaN(id))
            : [];
      } else {
        //for one to one
        participantId = participantOptions.find(
          (x) => x.uuid === watchFormData.pt_id
        )?.id;
      }

      let workerId = null;

      if (isCallFromAddShift && isNumber(watchFormData?.worker_id)) {
        workerId = watchFormData?.worker_id;
      } else {
        workerId = workerOptions.find(
          (x) => x.uuid === watchFormData.worker_id
        )?.id;

        // workerOptions can refresh between selection and submit. Without a
        // fallback an unresolved lookup submits worker_id [null], which the API
        // reads as unassigning the shift rather than leaving it untouched.
        if (workerId == null && watchFormData?.worker_id) {
          const hydratedWorker =
            shiftDetailData?.worker ?? selectedShift?.worker ?? null;
          if (
            hydratedWorker?.uuid &&
            hydratedWorker.uuid === watchFormData.worker_id
          ) {
            workerId = hydratedWorker?.id ?? null;
          }
        }

        if (workerId == null && watchFormData?.worker_id) {
          showToast(
            "Could not resolve the selected worker. Please reselect the worker and try again.",
            "isUnresolvedWorkerSelection"
          );
          return;
        }
      }

      Object.assign(data, {
        worker_id: [workerId],
        pt_id: Array.isArray(participantId)
          ? [...participantId]
          : [participantId],
      });
    } else if (!advanceModeActive && calendarView === "participant-view") {
      const resolveParticipantOptionId = (item) => {
        if (item == null) return null;
        if (typeof item === "number") return item;
        if (typeof item === "string" && /^\d+$/.test(item)) return Number(item);
        const itemUuid = item?.uuid ?? item?.value ?? item;
        const matchingParticipant = participantOptions?.find(
          (option) =>
            option.uuid === itemUuid ||
            option.value === itemUuid ||
            option.id === item?.id
        );
        const resolved = matchingParticipant?.id ?? item?.id ?? null;
        return resolved != null && resolved !== "" ? Number(resolved) : null;
      };

      const resolveWorkerOptionIdLocal = (item) => {
        if (item == null) return null;
        if (typeof item === "number") return item;
        if (typeof item === "string" && /^\d+$/.test(item)) return Number(item);
        const itemUuid = item?.uuid ?? item?.value ?? item;
        const matchingWorker = workerOptions?.find(
          (option) =>
            option.uuid === itemUuid ||
            option.value === itemUuid ||
            option.id === item?.id
        );
        const resolved = matchingWorker?.id ?? item?.id ?? null;
        return resolved != null && resolved !== "" ? Number(resolved) : null;
      };

      let participantId = null;
      if (Array.isArray(watchFormData?.pt_id)) {
        // Group / open-group Add Shift: pt_id is an array of option objects
        participantId =
          watchFormData.pt_id.length > 0
            ? watchFormData.pt_id
                .map((item) => resolveParticipantOptionId(item))
                .filter((id) => id != null && !Number.isNaN(id))
            : [];
      } else if (
        selectedShift !== null &&
        parseBooleanVal(
          watchFormData?.is_group_shift ||
            (calendarView === "participant-view" &&
              (shiftDetailData?.is_group_shift ||
                selectedShift?.is_group_shift))
        )
      ) {
        // Participant-view group edit locks pt_id to the row participant (scalar).
        // Always submit the full participant list from shift_detail so siblings
        // are not detached on update.
        const detailParticipants =
          shiftDetailData?.participants || selectedShift?.participants || [];
        const fromDetail = detailParticipants
          .map((p) => resolveParticipantOptionId(p))
          .filter((id) => id != null && !Number.isNaN(id));
        if (fromDetail.length > 0) {
          participantId = fromDetail;
        } else {
          participantId = resolveParticipantOptionId(watchFormData?.pt_id);
        }
      } else {
        participantId = resolveParticipantOptionId(watchFormData?.pt_id);
      }

      let workerId;
      if (Array.isArray(watchFormData?.worker_id)) {
        workerId =
          parseBooleanVal(watchFormData?.is_group_shift) &&
          watchFormData.worker_id?.length > 0
            ? watchFormData.worker_id
                .map((item) => resolveWorkerOptionIdLocal(item))
                .filter((id) => id != null && !Number.isNaN(id))
            : [null];
      } else {
        workerId = resolveWorkerOptionIdLocal(watchFormData?.worker_id);
      }

      const finalPtIds = Array.isArray(participantId)
        ? [...participantId]
        : participantId != null
        ? [participantId]
        : [];
      const finalWorkerIds = Array.isArray(workerId)
        ? [...workerId]
        : workerId != null
        ? [workerId]
        : [null];

      Object.assign(data, {
        pt_id: finalPtIds,
        worker_id: finalWorkerIds,
      });
    }

    if (advanceModeActive) {
      const mapPeople = (people, options) =>
        (people || []).map((item) => {
          const match = options.find(
            (o) => o.uuid === item.uuid || o.id === item.id
          );
          return match?.id ?? item?.id;
        });

      const toDateTime = (timeStr, refStart) => {
        if (!timeStr || !watchFormData?.shift_date) return "";
        const nextDay = isCheckNextDayShift(
          watchFormData.shift_date,
          refStart || watchFormData.start_time,
          timeStr
        );
        if (nextDay !== false) return nextDay;
        return convertTimeToDatetimeLocal(
          moment(watchFormData.shift_date),
          timeStr
        );
      };

      const allAdvanceSplits = data.advance_splits || [];
      const shiftStartClock = watchFormData?.start_time;
      const shiftEndClock = watchFormData?.end_time;
      const fullDaySeenByParticipant = new Set();
      const allocatedAdvanceSplits = allAdvanceSplits.filter((split) => {
        const ptUuid = getParticipantUuid(
          split.participant || split.participants?.[0]
        );
        const ptKey = String(ptUuid || "");
        if (
          isAdvanceUnallocatedSameClockSegment(
            split.participant_start_time,
            split.participant_end_time,
            shiftStartClock,
            shiftEndClock,
            { alreadyCountedFullDay: fullDaySeenByParticipant.has(ptKey) }
          )
        ) {
          return false;
        }
        if (
          isAdvanceSameClockTimeFullDay(
            split.participant_start_time,
            split.participant_end_time
          )
        ) {
          fullDaySeenByParticipant.add(ptKey);
        }
        return true;
      });
      const advance_splits = allocatedAdvanceSplits.map((split, index) => {
        const ptList = split.participant
          ? [split.participant]
          : split.participants || [];
        const ptUuid = getParticipantUuid(
          split.participant || split.participants?.[0]
        );
        const defaultKmCode = getParticipantDefaultKmCode(
          ptUuid,
          allAdvanceSplits
        );
        const includeParticipantFields = isLastSegmentForParticipant(
          index,
          allocatedAdvanceSplits
        );
        // Sync KM flags across every segment; keep STA on last segment only
        // (existing STA payload behaviour).
        return mapSplitRowClaimTypeForApi({
          participants: mapPeople(ptList, participantOptions),
          ratio: split.ratio || "1:1",
          km_for_invoicing: getParticipantKmForInvoicing(
            ptUuid,
            allAdvanceSplits
          ),
          default_km_code:
            defaultKmCode !== undefined ? defaultKmCode : settingsDefaultKmCode,
          sta: includeParticipantFields
            ? getParticipantSta(ptUuid, allAdvanceSplits)
            : false,
          invoice_service_type_id: split.invoice_service_type_id,
          invoice_item_id: split.custom_line_item_uuid
            ? null
            : split.invoice_item_id,
          custom_line_item_uuid: split.custom_line_item_uuid || null,
          support_item_number: split.support_item_number || "",
          support_item_name: split.support_item_name || "",
          claim_type: split.claim_type,
          participant_start_time: toDateTime(
            split.participant_start_time,
            split.participant_start_time
          ),
          participant_end_time: toDateTime(
            split.participant_end_time,
            split.participant_start_time
          ),
        });
      });

      const isAdvanceOpenShift = parseBooleanVal(watchFormData?.advance_open_shift);
      const carersSource =
        isAdvanceOpenShift && !(data.advance_carers || []).some(isOpenSlotRow)
          ? [
              createOpenSlotRow({
                start_time: data.start_time,
                end_time: data.end_time,
              }),
            ]
          : data.advance_carers || [];

      const advance_carers = carersSource.map((row) => {
        if (isOpenSlotRow(row)) {
          return {
            worker_id: null,
            is_open_slot: true,
            worker_start_time: toDateTime(
              row.worker_start_time,
              row.worker_start_time
            ),
            worker_end_time: toDateTime(
              row.worker_end_time,
              row.worker_start_time
            ),
          };
        }
        const w = row.worker;
        const match = workerOptions.find(
          (o) => o.uuid === w?.uuid || o.id === w?.id
        );
        return {
          worker_id: match?.id ?? w?.id,
          is_open_slot: false,
          worker_start_time: toDateTime(
            row.worker_start_time,
            row.worker_start_time
          ),
          worker_end_time: toDateTime(
            row.worker_end_time,
            row.worker_start_time
          ),
        };
      });

      const participant_travel = buildParticipantTravelFromSplits(
        allAdvanceSplits,
        participantOptions
      );

      const advancePayload = {
        is_advance_mode: true,
        advance_splits,
        advance_carers,
        participant_travel,
        open_shift: isAdvanceOpenShift || undefined,
        pt_id: [
          ...new Set(
            advance_splits.flatMap((s) => s.participants).filter(Boolean)
          ),
        ],
        worker_id: [
          ...new Set(advance_carers.map((c) => c.worker_id).filter(Boolean)),
        ],
      };

      if (data.advance_sil_home_enabled && data.advance_sil_home_id) {
        advancePayload.sil_home_id = data.advance_sil_home_id;
        if (data.advance_sil_home_uuid) {
          advancePayload.sil_home_uuid = data.advance_sil_home_uuid;
        }
      }

      Object.assign(data, advancePayload);
    }

    setISInitialCreateShiftLoader(LOADER_STATUS.PENDING);

    if (
      watchFormData?.is_recurring &&
      recurringDates.length > 0 &&
      !isDateInPast(watchFormData?.shift_date)
    ) {
      Object.assign(data, {
        till_dates: recurringDates,
        recurring_days: convertDaysName(selectedDays),
        recurring_interval: capitalizeFirstLetter(recurrInterval.value),
        repeat_for: formatRecurringValue(recurringType.value),
      });
    }

    Object.assign(data, {
      invoice_service_type_id: data?.invoice_service_type_id,
      sleepover: data?.sleepover,
      ...(advanceModeActive && {
        sta:
          resolveStaValue(data?.sta) ||
          (data.advance_splits || []).some((split) =>
            resolveStaValue(split?.sta)
          ),
      }),
      shift_accept: data?.shift_accept,
      is_radius: data?.is_radius,
      overlap: data?.shift_overlapped,
      shift_instruction: data?.shift_instruction,
    });

    if (
      shiftLocation?.street &&
      shiftLocation?.suburb &&
      shiftLocation?.state &&
      shiftLocation?.postcode &&
      shiftLocation?.lat &&
      shiftLocation?.lng
    ) {
      Object.assign(data, {
        shift_location: {
          street: shiftLocation?.street,
          suburb: shiftLocation?.suburb,
          state: shiftLocation?.state,
          state_name: shiftLocation?.state_name,
          postcode: shiftLocation?.postcode,
          lat: shiftLocation?.lat,
          lng: shiftLocation?.lng,
        },
      });
    }

  



    let split_shift = [];
    if (data?.splitShifts?.length > 0) {
      let useNextDay = false;
      let baseDate = moment(data.shift_date);
      split_shift = data.splitShifts.map((split, idx) => {
        const isNextDay =
          isCheckNextDayShift(
            watchFormData?.shift_date,
            split.start_time,
            split.end_time
          ) !== false;

        if (useNextDay) {
          baseDate = moment(baseDate).add(1, "days");
        }

        useNextDay = isNextDay;

        return mapSplitRowClaimTypeForApi({
          ...split,
          duration:
            getBasicShiftDurationHHMM(split.start_time, split.end_time) ||
            split.duration ||
            0,
          start_time:
            split.start_time && data.shift_date
              ? convertTimeToDatetimeLocal(baseDate, split.start_time)
              : split.start_time,
          end_time: isNextDay
            ? isCheckNextDayShift(
                watchFormData?.shift_date,
                split.start_time,
                split.end_time
              )
            : convertTimeToDatetimeLocal(baseDate, split.end_time),
        });
      });
    }
    Object.assign(data, {
      split_shift: split_shift,
    });

    // Always remove splitShifts from payload
    if (data.hasOwnProperty("splitShifts")) delete data.splitShifts;
    if (!advanceModeActive && data.hasOwnProperty("advance_splits")) {
      delete data.advance_splits;
    }
    if (!advanceModeActive && data.hasOwnProperty("advance_carers")) {
      delete data.advance_carers;
    }
    if (!advanceModeActive && data.hasOwnProperty("advance_selected_participants")) {
      delete data.advance_selected_participants;
    }
    if (!advanceModeActive && data.hasOwnProperty("advance_selected_workers")) {
      delete data.advance_selected_workers;
    }
    if (!advanceModeActive && data.hasOwnProperty("advance_open_shift")) {
      delete data.advance_open_shift;
    }
    if (!advanceModeActive && data.hasOwnProperty("advance_sil_home_enabled")) {
      delete data.advance_sil_home_enabled;
    }
    if (!advanceModeActive && data.hasOwnProperty("advance_sil_home_id")) {
      delete data.advance_sil_home_id;
    }
    if (!advanceModeActive && data.hasOwnProperty("advance_sil_home_uuid")) {
      delete data.advance_sil_home_uuid;
    }
    if (!advanceModeActive && data.hasOwnProperty("advance_sil_home_label")) {
      delete data.advance_sil_home_label;
    }
    if (advanceModeActive && !data.advance_sil_home_enabled) {
      delete data.advance_sil_home_id;
      delete data.advance_sil_home_uuid;
      delete data.advance_sil_home_label;
    }
    if (advanceModeActive && data.hasOwnProperty("advance_open_shift")) {
      delete data.advance_open_shift;
    }

    if (isPublish === "isPublish") {
      Object.assign(data, {
        is_publish: true,
      });
    }
    const isRecurringSeriesUpdate =
      selectedShift !== null &&
      shiftDetailData?.recurring_interval !== null;
    const isPastRecurringUpdate =
      isRecurringSeriesUpdate && isPastRecurringShiftUpdate();

    if (isRecurringSeriesUpdate && !isPastRecurringUpdate) {
      setRecurringUpdateShiftData({
        data:
          selectedShift !== null
            ? { ...data, uuid: selectedShift.uuid, id: selectedShift.id }
            : data,
        calendarView: calendarView,
        isUpdate: selectedShift !== null,
        isWorkerChange:
          userItem && data.worker_id[0] === userItem?.id ? false : true,
        prevWorkerUUID:
          userItem && data.worker_id[0] === userItem?.id
            ? null
            : userItem?.uuid,
        name: capitalizeAllLetters(
          `${userItem?.first_name} ${userItem?.last_name}`
        ),
      });
      setUpdateShiftRecurringModal(true);
    } else if (isPastRecurringUpdate) {
      setRecurringUpdateShiftData({
        data: {
          ...data,
          uuid: selectedShift.uuid,
          id: selectedShift.id,
          recurring_impact: false,
        },
        calendarView: calendarView,
        isUpdate: true,
        isWorkerChange:
          userItem && data.worker_id[0] === userItem?.id ? false : true,
        prevWorkerUUID:
          userItem && data.worker_id[0] === userItem?.id
            ? null
            : userItem?.uuid,
        name: capitalizeAllLetters(
          `${userItem?.first_name} ${userItem?.last_name}`
        ),
      });
      setShowPastRecurringUpdateConfirm(true);
    } else {
      createOrUpdateWorkerShiftRequest(
        {
          data:
            selectedShift !== null
              ? { ...data, uuid: selectedShift.uuid, id: selectedShift.id }
              : data,
          calendarView: calendarView,
          isUpdate: selectedShift !== null,
          isWorkerChange:
            userItem && data.worker_id[0] === userItem?.id ? false : true,
          prevWorkerUUID:
            userItem && data.worker_id[0] === userItem?.id
              ? null
              : userItem?.uuid,
          name: capitalizeAllLetters(
            `${userItem?.first_name} ${userItem?.last_name}`
          ),
        },
        (e) => {
          // Local state update is handled by the reducer in CREATE_OR_UPDATE_WORKER_SHIFT.SUCCESS
          if (selectedShift !== null || watchFormData?.is_group_shift) {
            refreshShiftStats();
          }
        }
      );
    }
    if (selectedShift === null) {
      setTimeout(() => {
        refreshShiftStats();
      }, 2000);
    }
  };
  const [editableInstructionIndex, setEditableInstructionIndex] =
    useState(null);

  const handleAddShiftInstruction = useCallback((index) => {
    setEditableInstructionIndex(index);
  }, []);

  const handleShiftInstructionChange = useCallback((index, event) => {
    setShiftInstructions((prev) => {
      const updatedShiftInstructions = [...prev];
      updatedShiftInstructions[index].shift_instruction = event.target.value;
      return updatedShiftInstructions;
    });
  }, []);
  const [runAgain, setRunAgain] = useState(false);

  const generateOptions = useCallback((count, label) => {
    return Array.from({ length: count }, (_, index) => ({
      label: `${index + 1} ${label}${index === 0 ? "" : "s"}`,
      value: `${index + 1}_${label}`,
    }));
  }, []);

  const handleIntervalChange = useCallback(
    (interval) => {
      setRecurrInterval(interval);
      setRecurringType(null);
      setSelectedDays({
        Mon: false,
        Tue: false,
        Wed: false,
        Thu: false,
        Fri: false,
        Sat: false,
        Sun: false,
      });

      let options = [];
      if (interval.value === "weekly") {
        options = generateOptions(52, "Week");
      } else if (interval.value === "fortnight") {
        options = generateOptions(26, "Fortnight");
      } else if (interval.value === "monthly") {
        options = generateOptions(12, "Month");
      }
      setRecurringFor(options);
    },
    [setRecurrInterval, setRecurringType]
  );

  useEffect(() => {
    if (
      shiftDetailData?.recurring_interval !== undefined &&
      shiftDetailData?.recurring_interval !== null &&
      selectedShift !== null
    ) {
      setValue("is_recurring", true);

      const matchingInterval = RECURRING_INTERVAL?.find(
        (el) =>
          capitalizeFirstLetter(el.value) === shiftDetailData.recurring_interval
      );

      if (matchingInterval) {
        handleIntervalChange(matchingInterval);
      }

      setRecurrInterval(matchingInterval);
    }
  }, [shiftDetailData, runAgain]);

  useEffect(() => {
    if (shiftDetailData?.recurring_interval !== null && recurringFor) {
      const recurringValue = convertWeeksToFormat(
        shiftDetailData.recurring_repeat
      );
      const matchingRecurringDuration =
        recurringFor && recurringFor?.find((el) => el.value === recurringValue);
      if (matchingRecurringDuration) {
        setRecurringType(matchingRecurringDuration);
      }
    }
  }, [runAgain, shiftDetailData, recurringFor]);

  useEffect(() => {
    if (
      !createOrUpdateWorkerShiftLoader &&
      (!createOrUpdateWorkerShiftError ||
        createOrUpdateWorkerShiftError.length === 0) &&
      isInitialCreateShiftLoader !== LOADER_STATUS.NA
    ) {
      handleClose();
      setIsFetchRecordDetailLoader(false);
      reset();
      // Reset location after successful submission
      setShiftLocation({
        street: "",
        suburb: "",
        state: null,
        postcode: "",
        state_name: "",
        lat: null,
        lng: null,
      });
    }
  }, [createOrUpdateWorkerShiftLoader]);

  // Recurring create/update summary is rendered at Schedule level. Recurring
  // *updates* never set isInitialCreateShiftLoader, so the effect above leaves
  // the editor open and the summary sat behind Advanced Edit (z-99999) / the
  // basic shift modal (z-10000). Close the editor as soon as that summary
  // opens — same outcome as a successful create.
  useEffect(() => {
    if (!isShow || !isRecurringModal) return;
    handleClose();
  }, [isRecurringModal, isShow]);

  const handleTaskChange = (index, value) => {
    setTasks((prev) => {
      const updatedTasks = [...(prev || [])];
      if (!updatedTasks[index]) return prev;
      const current = updatedTasks[index];
      const next = { ...current, task: value };

      const isAdvanceCreate =
        isAdvanceMode &&
        (selectedShift === null || isAdvanceShiftDraft(selectedShift));
      const isUnsavedUnassigned =
        (current?.pt_id == null || current.pt_id === "") &&
        !current?.id &&
        !(Array.isArray(current?.ids) && current.ids.length);

      // Create/draft only: typing into the default open row must set pt_id.
      if (isAdvanceCreate && isUnsavedUnassigned) {
        const fallbackPtId = getParticipantId(
          (watchFormData?.advance_selected_participants || [])[0],
          advanceModeParticipantOptions
        );
        if (fallbackPtId != null && fallbackPtId !== "") {
          next.pt_id = Number(fallbackPtId);
        }
      }

      updatedTasks[index] = next;
      return updatedTasks;
    });
  };

  const handleTaskMandatoryChange = (index, value) => {
    if (checkRunningShiftStatus(selectedShift?.status)) return;
    const updatedTasks = [...tasks];
    updatedTasks[index] = { ...updatedTasks[index], is_mandatory: value };
    setTasks(updatedTasks);
  };

  const handleTaskWorkerChange = (index, assignee = {}) => {
    if (checkRunningShiftStatus(selectedShift?.status)) return;
    const assignTo =
      assignee?.assign_to === "worker" && assignee?.worker_id != null
        ? "worker"
        : "all";
    const workerId =
      assignTo === "worker" ? Number(assignee.worker_id) : null;
    setTasks((prev) => {
      const updatedTasks = [...(prev || [])];
      if (!updatedTasks[index]) return prev;
      updatedTasks[index] = {
        ...updatedTasks[index],
        assign_to: assignTo,
        worker_id:
          assignTo === "worker" && !Number.isNaN(workerId) ? workerId : null,
      };
      return updatedTasks;
    });
  };

  const handleAddTask = (ptId = null) => {
    if (checkRunningShiftStatus(selectedShift?.status)) return;
    // Button onClick may pass a SyntheticEvent — only accept real participant ids.
    const resolvedPtId =
      ptId != null && typeof ptId === "object" ? null : ptId;
    const isAdvanceCreate =
      isAdvanceMode &&
      (selectedShift === null || isAdvanceShiftDraft(selectedShift));
    const fallbackPtId = isAdvanceCreate
      ? getParticipantId(
          (watchFormData?.advance_selected_participants || [])[0],
          advanceModeParticipantOptions
        )
      : Array.isArray(selectedParticipant)
        ? selectedParticipant[0]?.id
        : selectedParticipant?.id;
    const defaultPtId = resolvedPtId ?? fallbackPtId;
    setTasks([
      ...tasks,
      {
        task: "",
        is_mandatory: false,
        participant_task_id: null,
        pt_id: defaultPtId ?? null,
        assign_to: "all",
        worker_id: null,
      },
    ]);
  };

  const handleTaskDelete = async (Taskindex) => {
    if (isNaN(Taskindex) || Taskindex === null) return;
    if (checkRunningShiftStatus(selectedShift?.status)) return;

    const removeLocally = () =>
      setTasks((prev) => (prev || []).filter((_, i) => i !== Taskindex));

    const savedTaskId = Number(tasks?.[Taskindex]?.id);
    const isSavedAdvanceShift =
      isAdvanceMode &&
      selectedShift?.uuid &&
      !isAdvanceShiftDraft(selectedShift);

    // An already-persisted task is removed server-side (which also clears its
    // per-worker rows), so the removal survives even if the shift is never saved.
    if (
      !isSavedAdvanceShift ||
      !Number.isFinite(savedTaskId) ||
      savedTaskId <= 0
    ) {
      removeLocally();
      return;
    }

    try {
      await rosteringApi.deleteAdvanceShiftTask({
        uuid: selectedShift.uuid,
        taskId: savedTaskId,
      });
      removeLocally();
    } catch (error) {
      toast.error(
        error?.message || "This task could not be removed. Please try again."
      );
    }
  };

  const handleNoteChange = useCallback((index, value) => {
    setNotes((prev) => {
      const updated = [...prev];
      if (!updated[index]) return prev;
      updated[index] = { ...updated[index], notes: value };
      return updated;
    });
  }, []);

  const getSelectedOption = (value) => {
    if (
      calendarView === "worker-view" &&
      selectedShift?.is_group_shift &&
      watchFormData?.worker_id === null
    ) {
      return selectedShift
        ? workerOptions?.find((x) => x?.id === selectedShift?.worker_id)
        : null;
    }
    const watchFormValue = watchFormData && watchFormData?.[`${value}`];

    if (Array.isArray(watchFormValue)) {
      // Prefer options match; fall back to hydrated form value so edit never
      // yields [undefined] while worker options are still loading.
      return watchFormValue
        ?.map((val) => {
          if (val == null) return null;
          const key = val?.uuid ?? val?.value ?? val;
          const match = workerOptions?.find(
            (x) =>
              x?.value === key ||
              x?.uuid === key ||
              x?.value === val?.value ||
              x?.uuid === val?.uuid
          );
          if (match) return match;
          if (typeof val === "object" && (val.uuid || val.value)) {
            return val;
          }
          return null;
        })
        ?.filter((x) => !isEmpty(x));
    } else {
      return watchFormValue
        ? workerOptions?.find(
            (x) =>
              x?.value === watchFormValue || x?.uuid === watchFormValue
          ) || null
        : null;
    }
  };

  const getSelectedParticipant = (value) => {
    const watchFormValue = watchFormData && watchFormData?.[`${value}`];

    if (Array.isArray(watchFormValue)) {
      const updatedids = watchFormValue
        ?.map((val) =>
          participantOptions?.find(
            (x) =>
              x?.uuid === val?.uuid ||
              x?.value === val?.uuid ||
              x?.uuid === val?.value ||
              x?.value === val?.value
          )
        )
        ?.filter((x) => !isEmpty(x));

      return updatedids;
    } else {
      return watchFormValue
        ? participantOptions?.find(
            (x) =>
              x?.value === watchFormValue ||
              x?.uuid === watchFormValue ||
              String(x?.value) === String(watchFormValue) ||
              String(x?.uuid) === String(watchFormValue)
          )
        : null;
    }
  };

  const handleGroupShiftToggleChange = (value) => {
    if (calendarView === "worker-view") {
      if (value === true) {
        const getIdFromParticipantsOpt = getSelectedParticipant("pt_id");
        const singleOpt = Array.isArray(getIdFromParticipantsOpt)
          ? getIdFromParticipantsOpt[0]
          : getIdFromParticipantsOpt;
        setValue(
          "pt_id",
          singleOpt?.uuid ? [{ ...singleOpt }] : null
        );
      } else {
        // Group → single: clear leftover multi-select array so SelectOption
        // can bind a new scalar pick. Participant disappearing is expected.
        setValue("pt_id", null);
        setSelectedOptions([]);
      }
    } else {
      if (watchFormData.is_group_shift) {
        setValue("open_shift", null);
      }
      const getIdFromWorkersOpt = getSelectedOption("worker_id");
      setValue(
        "worker_id",
        value === true && getIdFromWorkersOpt?.uuid
          ? [{ ...getIdFromWorkersOpt }]
          : null
      );
    }
    setValue("is_group_shift", value);
  };

  useEffect(() => {
    if (isAdvanceMode) return;
    if (
      watchFormData?.start_time &&
      watchFormData?.end_time &&
      !isBasicShiftZeroDuration(
        watchFormData?.start_time,
        watchFormData?.end_time
      )
    ) {
      clearErrors("end_time");
    }
  }, [watchFormData?.end_time, watchFormData?.start_time, isAdvanceMode, clearErrors]);

  const checkDisabliltyOfShiftForWorker = (
    isGroupShiftInWorkerView = false
  ) => {
    return !isGroupShiftInWorkerView &&
      userItem &&
      calendarView === "worker-view"
      ? true
      : false;
  };

  // const handleRedirection = (uuid) => {
  //   selectedTabState.save(
  //     JSON.stringify({
  //       name: "Settings",
  //       id: 13,
  //       children: [],
  //     })
  //   );
  //   navigate(`/sp-profile/${uuid}`);
  // };

  // const isParticipantStateMissing = () => {
  //   const selectedParticipant = getSelectedParticipant("pt_id");

  //   if (selectedParticipant) {
  //     if (Array.isArray(selectedParticipant)) {
  //       return selectedParticipant.some((item) => !item?.state_id);
  //     } else {
  //       return !selectedParticipant.state_id;
  //     }
  //   }

  //   return false;
  // };

  const selectedParticipant = useMemo(
    () => getSelectedParticipant("pt_id"),
    [watchFormData?.pt_id, participantOptions]
  );

  const selectedWorker = useMemo(
    () => getSelectedOption("worker_id"),
    [watchFormData?.worker_id]
  );

  // Basic mode: hydrate tasks from participant settings on the options object
  // once per selection (create always; edit only when API shift_tasks was empty).
  useEffect(() => {
    if (isAdvanceMode) return;

    // Edit already applied API or settings tasks for a selection — do not re-run.
    if (
      selectedShift !== null &&
      lastAppliedTaskParticipantKeyRef.current != null
    ) {
      return;
    }

    if (!watchFormData?.pt_id) {
      if (selectedShift === null) {
        lastAppliedTaskParticipantKeyRef.current = null;
        setTasks([{ ...EMPTY_SHIFT_TASK }]);
      }
      return;
    }

    const selectionKey = getParticipantSelectionKey(watchFormData?.pt_id);
    // Already hydrated this participant selection — keep manual edits / extra tasks.
    if (
      selectionKey &&
      lastAppliedTaskParticipantKeyRef.current === selectionKey
    ) {
      return;
    }

    // Edit: API already loaded non-empty tasks before the key was set — keep them.
    if (selectedShift !== null) {
      const hasExistingNonEmptyTasks = (tasksRef.current || []).some(
        (task) => String(task?.task ?? "").trim() !== ""
      );
      if (hasExistingNonEmptyTasks) {
        if (selectionKey) {
          lastAppliedTaskParticipantKeyRef.current = selectionKey;
        }
        return;
      }
    }

    const participants = resolveParticipantsForShiftTasks(
      selectedParticipant,
      participantOptions
    );
    // Wait until the selected participant(s) resolve from options.
    if (participants.length === 0) {
      return;
    }

    const shiftTasks = mapParticipantTasksToShiftTasks(participants);

    if (shiftTasks.length > 0) {
      lastAppliedTaskParticipantKeyRef.current = selectionKey;
      setTasks(shiftTasks);
      return;
    }

    // Keep tasks only when they already belong to the current selection
    // (async listing may populate the same participant before options do).
    // Do not keep previous participant rows just because they have a
    // participant_task_id — that left A's tasks on B when B had none.
    setTasks((prev) => {
      const selectedPtIds = new Set(
        participants
          .map((participant) => Number(participant?.id))
          .filter(Boolean)
      );
      const hasLoadedTasksForSelection =
        Array.isArray(prev) &&
        prev.some(
          (task) =>
            String(task?.task ?? "").trim() !== "" &&
            selectedPtIds.has(Number(task?.pt_id))
        );

      if (hasLoadedTasksForSelection) {
        if (selectionKey) {
          lastAppliedTaskParticipantKeyRef.current = selectionKey;
        }
        return prev;
      }

      if (selectionKey) {
        lastAppliedTaskParticipantKeyRef.current = selectionKey;
      }

      // Group shift (basic create/edit only — this effect returns early in advance mode):
      // empty list so each participant shows an add-task section.
      // Single / non-group still gets one blank row as before.
      const isMultiParticipantGroup =
        parseBooleanVal(watchFormData?.is_group_shift) &&
        participants.length > 1;
      if (isMultiParticipantGroup) {
        return [];
      }

      return [{ ...EMPTY_SHIFT_TASK }];
    });
  }, [
    isAdvanceMode,
    selectedShift,
    watchFormData?.pt_id,
    watchFormData?.is_group_shift,
    selectedParticipant,
    participantOptions,
  ]);

  // Advance mode: keep notes/tasks aligned to each selected participant.
  // Tasks hydrate from participant settings when a participant is newly added.
  useEffect(() => {
    if (!isAdvanceMode) {
      advanceAppliedTaskPtIdsRef.current = [];
      return;
    }

    // V5/draft details still loading — do not consume the skip flag against
    // an empty participant list or leftover create-form state.
    if (advanceEditTaskLockRef.current) {
      return;
    }

    const selected = watchFormData?.advance_selected_participants || [];
    const resolvedSelected = selected.map((participant) => {
      const uuid = getParticipantUuid(participant);
      const fromOptions = (advanceModeParticipantOptions || []).find(
        (opt) => getParticipantUuid(opt) === uuid
      );
      return fromOptions || participant;
    });

    setNotes((prev) => syncParticipantNoteRows(resolvedSelected, prev));

    const currentIds = resolvedSelected
      .map((participant) =>
        participant?.id != null ? Number(participant.id) : null
      )
      .filter((id) => id != null && !Number.isNaN(id));

    if (advanceSkipInitialTaskHydrateRef.current) {
      // Wait until the saved participants are actually in the form (and have
      // numeric ids). Consuming skip against [] marks them as "removed" and
      // the next options-load reseeds participant-settings tasks.
      if (selected.length === 0 || currentIds.length === 0) {
        return;
      }
      advanceSkipInitialTaskHydrateRef.current = false;
      advanceAppliedTaskPtIdsRef.current = Array.from(
        new Set([
          ...(advanceAppliedTaskPtIdsRef.current || []),
          ...currentIds,
        ])
      );
      return;
    }

    const removedIds = advanceAppliedTaskPtIdsRef.current.filter(
      (id) => !currentIds.includes(id)
    );
    // Only drop tasks once we have a resolved current set. An empty currentIds
    // during options load is "ids not ready", not "user removed everyone".
    if (currentIds.length > 0 && removedIds.length > 0) {
      setTasks((prev) =>
        (prev || []).filter(
          (task) =>
            task?.pt_id == null ||
            task?.pt_id === "" ||
            !removedIds.includes(Number(task.pt_id))
        )
      );
    }

    const addedParticipants = resolvedSelected.filter((participant) => {
      const id = participant?.id != null ? Number(participant.id) : null;
      if (id == null || Number.isNaN(id)) return false;
      if (advanceAppliedTaskPtIdsRef.current.includes(id)) return false;
      // Already have tasks for this participant (basic seed / API load).
      const hasExistingTasks = (tasksRef.current || []).some(
        (task) =>
          Number(task?.pt_id) === id && String(task?.task ?? "").trim() !== ""
      );
      return !hasExistingTasks;
    });

    // Fresh create only (not edit, not draft resume): stamp the default blank
    // row so typing into it does not persist pt_id: null.
    const isAdvanceCreate = selectedShift === null;
    const stampDefaultOpenTaskPtId = (prev) =>
      isAdvanceCreate && currentIds.length > 0
        ? stampUnassignedTasksWithParticipant(prev, currentIds[0])
        : prev;

    let cancelled = false;

    const hydrateAddedParticipants = async () => {
      if (addedParticipants.length === 0) {
        if (currentIds.length > 0 || selected.length === 0) {
          advanceAppliedTaskPtIdsRef.current = currentIds;
        }
        if (isAdvanceCreate && currentIds.length > 0) {
          setTasks((prev) => stampDefaultOpenTaskPtId(prev));
        }
        return;
      }

      let participantsWithTasks = [...addedParticipants];
      const missingTaskParticipants = participantsWithTasks.filter(
        (participant) =>
          getParticipantTaskList(participant).length === 0 && participant?.uuid
      );

      if (missingTaskParticipants.length > 0) {
        try {
          const uuids = missingTaskParticipants.map((p) => p.uuid);
          const response = await api.getWorkerAndParticipantList({
            type: "participant",
            pt_id: uuids.length === 1 ? uuids[0] : uuids,
          });
          if (cancelled) return;

          const listing = response?.worker_participant_listing?.participant;
          const list = listing
            ? Array.isArray(listing)
              ? listing
              : [listing]
            : [];

          participantsWithTasks = participantsWithTasks.map((participant) => {
            const match = list.find((item) => item.uuid === participant.uuid);
            if (!match) return participant;
            return {
              ...participant,
              ...match,
              participant_tasks:
                match.participant_tasks ??
                match.participantTasks ??
                match.tasks ??
                [],
            };
          });
        } catch {
          // Keep existing participant objects; settings hydrate is best-effort.
        }
      }

      if (cancelled) return;

      const newTasks = mapParticipantTasksToShiftTasks(participantsWithTasks);
      if (newTasks.length > 0) {
        setTasks((prev) => {
          const cleaned = (prev || []).filter(
            (task) =>
              String(task?.task ?? "").trim() !== "" ||
              (task?.pt_id != null && task?.pt_id !== "")
          );
          const stamped = stampDefaultOpenTaskPtId(cleaned);
          const existingKeys = new Set(
            stamped.map(
              (task) =>
                `${Number(task.pt_id)}::${task.participant_task_id ?? ""}::${String(
                  task.task ?? ""
                ).trim()}`
            )
          );
          const toAdd = newTasks.filter(
            (task) =>
              !existingKeys.has(
                `${Number(task.pt_id)}::${task.participant_task_id ?? ""}::${String(
                  task.task ?? ""
                ).trim()}`
              )
          );
          return [...stamped, ...toAdd];
        });
      } else {
        setTasks((prev) => stampDefaultOpenTaskPtId(prev));
      }

      advanceAppliedTaskPtIdsRef.current = currentIds;
    };

    hydrateAddedParticipants();

    return () => {
      cancelled = true;
    };
  }, [
    isAdvanceMode,
    advanceSelectedKey,
    advanceModeParticipantOptions,
    watchFormData?.advance_selected_participants,
    // Intentionally omit `tasks` — hydrate uses functional updates + refs.
  ]);

  const [shiftOverlap, setShiftOverlap] = useState(null);
  const [onLeave, setOnLeave] = useState(null);
  const [onLeaveMessage, setOnLeaveMessage] = useState(null);
  const isFirstRender = useRef(true);
  const pendingOverlapDateRef = useRef(null);

  const buildShiftOverlapEndTime = useCallback(
    (shiftDate, startTime, endTime) =>
      isCheckNextDayShift(shiftDate, startTime, endTime) !== false
        ? isCheckNextDayShift(shiftDate, startTime, endTime)
        : convertTimeToDatetimeLocal(moment(shiftDate), endTime),
    []
  );

  const handleShiftDateChange = useCallback((nextDate) => {
    pendingOverlapDateRef.current = nextDate || null;
    setRecheckAvailability((prev) => !prev);
  }, []);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const shift_date =
      pendingOverlapDateRef.current || watchFormData?.shift_date;
    pendingOverlapDateRef.current = null;
    const { start_time, end_time, is_group_shift } = watchFormData;

    if (!shift_date || !end_time || !start_time) {
      return;
    }

    let payloadData = null;

    if (isAdvanceMode) {
      const openShift = parseBooleanVal(watchFormData?.advance_open_shift);
      const selectedWorkers = watchFormData?.advance_selected_workers || [];
      const selectedParticipants =
        watchFormData?.advance_selected_participants || [];

      if (openShift || !selectedWorkers.length || !selectedParticipants.length) {
        setShiftOverlap(null);
        setOnLeave(false);
        setOnLeaveMessage(null);
        return;
      }

      const workerIds = resolveAdvanceWorkerIds(
        selectedWorkers,
        advanceModeWorkerOptions
      );
      const participantIds = resolveAdvanceParticipantIds(
        selectedParticipants,
        advanceModeParticipantOptions
      );

      if (!workerIds.length || !participantIds.length) {
        setShiftOverlap(null);
        setOnLeave(false);
        setOnLeaveMessage(null);
        return;
      }

      payloadData = {
        id: selectedShift?.id,
        worker_id: workerIds,
        pt_id: participantIds,
        end_time: buildShiftOverlapEndTime(shift_date, start_time, end_time),
        shift_date: moment(new Date(shift_date)).toISOString(),
        start_time: convertTimeToDatetimeLocal(
          moment(shift_date),
          start_time
        ),
        is_group_shift: participantIds.length > 1,
      };
    } else if (
      watchFormData?.worker_id &&
      selectedParticipant &&
      (selectedWorker ||
        (calendarView === "worker-view" &&
          isCallFromAddShift &&
          !selectedWorker &&
          watchFormData?.worker_id))
    ) {
      const workerId =
        calendarView === "worker-view" &&
        isCallFromAddShift &&
        !selectedWorker
          ? [watchFormData?.worker_id]
          : Array.isArray(selectedWorker)
          ? selectedWorker?.map((item) => item?.id).filter((id) => id != null)
          : selectedWorker?.id != null
          ? [selectedWorker.id]
          : [];

      if (!workerId.length) {
        return;
      }

      const participantIds = Array.isArray(selectedParticipant)
        ? selectedParticipant?.map((item) => item?.id).filter((id) => id != null)
        : selectedParticipant?.id != null
        ? [selectedParticipant.id]
        : [];

      if (!participantIds.length) {
        return;
      }

      payloadData = {
        id: selectedShift?.id,
        worker_id: workerId,
        pt_id: participantIds,
        end_time: buildShiftOverlapEndTime(shift_date, start_time, end_time),
        shift_date: moment(new Date(shift_date)).toISOString(),
        start_time: convertTimeToDatetimeLocal(
          moment(shift_date),
          start_time
        ),
        is_group_shift: is_group_shift || false,
      };
    } else {
      return;
    }

    setLoading(true);

    apiPostRequest(URL_ROSTERING_SHIFT_CHECK_OVERLAPP, payloadData)
      .then((res) => {
        setLoading(false);
        setShiftOverlap(res?.data?.data);
        if (res?.data?.data?.status === "on_leave") {
          setOnLeave(true);
          setOnLeaveMessage(res?.data?.data?.message);
        } else {
          setOnLeave(false);
          setOnLeaveMessage(null);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  }, [
    isAdvanceMode,
    watchFormData?.end_time,
    watchFormData?.worker_id,
    watchFormData?.pt_id,
    watchFormData?.is_group_shift,
    watchFormData?.start_time,
    watchFormData?.shift_date,
    watchFormData?.advance_open_shift,
    advanceSelectedKey,
    advanceSelectedWorkersKey,
    advanceModeWorkerOptions,
    advanceModeParticipantOptions,
    recheckAvailability,
    selectedParticipant,
    selectedWorker,
    calendarView,
    isCallFromAddShift,
    selectedShift?.id,
    buildShiftOverlapEndTime,
  ]);

  // Prefer explicit leave flags; also honor leave payload stored on shiftOverlap
  // so Create stays blocked if the two ever drift.
  const isWorkerOnLeave =
    Boolean(onLeave) || shiftOverlap?.status === "on_leave";
  const workerOnLeaveMessage =
    onLeaveMessage ||
    (shiftOverlap?.status === "on_leave" ? shiftOverlap?.message : null);

  const [shiftInstructions, setShiftInstructions] = useState([]);
  const [debouncedParticipant, setDebouncedParticipant] = useState(null);
  const [isShiftInstructionLoading, setIsShiftInstructionLoading] =
    useState(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (isAdvanceMode) {
        const selected = watchFormData?.advance_selected_participants || [];
        setDebouncedParticipant(selected.length > 0 ? selected : null);
        return;
      }

      if (
        selectedShift?.open_group_shift &&
        watchFormData?.open_shift &&
        Array.isArray(watchFormData?.pt_id)
      ) {
        const participantId = watchFormData?.pt_id;
        setDebouncedParticipant(participantId);
      } else {
        setDebouncedParticipant(selectedParticipant);
      }
    }, 700);

    return () => {
      clearTimeout(handler);
    };
  }, [
    selectedParticipant,
    isAdvanceMode,
    advanceSelectedKey,
    watchFormData?.open_shift,
    selectedShift?.open_group_shift,
    watchFormData?.advance_selected_participants,
  ]);

  useEffect(() => {
    if (!debouncedParticipant) {
      setShiftInstructions([]);
      return;
    }

    const requestId = ++shiftInstructionsRequestRef.current;
    shiftInstructionsAbortRef.current = replaceAbortController(
      shiftInstructionsAbortRef.current
    );
    const signal = shiftInstructionsAbortRef.current?.signal;

    setIsShiftInstructionLoading(true);
    setShiftInstructions([]);
    const payload = {
      participant_ids: Array.isArray(debouncedParticipant)
        ? debouncedParticipant.map((item) => item.uuid)
        : [debouncedParticipant.uuid],
    };

    if (selectedShift !== null) {
      Object.assign(payload, {
        shift_id: selectedShift?.id,
      });
    }
    apiPostRequest(
      URL_ROSTERING_GET_SHIFT_INSTRUCTIONS,
      payload,
      null,
      signal ? { signal } : {}
    )
      .then((res) => {
        if (requestId !== shiftInstructionsRequestRef.current) return;
        setShiftInstructions(res?.data?.data);
      })
      .catch((err) => {
        if (isRequestCancelled(err)) return;
      })
      .finally(() => {
        if (requestId === shiftInstructionsRequestRef.current) {
          setIsShiftInstructionLoading(false);
        }
      });

    return () => {
      try {
        shiftInstructionsAbortRef.current?.abort?.();
      } catch {
        // ignore
      }
    };
  }, [JSON.stringify(debouncedParticipant), selectedShift?.id]);

  const handleShiftUpdatePermissionParticipantView = () => {
    // Advance (multi-assignment) shifts are editable from any calendar view, so
    // the legacy "participant-view group shift" restriction never applies here.
    if (isAdvanceMode || isAdvanceMultiAssignmentShift(selectedShift)) {
      return false;
    }
    if (
      selectedShift !== null &&
      watchFormData?.is_group_shift &&
      calendarView === "participant-view" &&
      shiftDetailData?.participants?.length > 1 &&
      !shiftDetailData?.open_group_shift
    ) {
      return true;
    } else {
      return false;
    }
  };

  const getToolTipContentOpenShift = () => {
    return (
      <div className='flex flex-col gap-4 p-2'>
        <p className='text-xs text-white flex items-center'>
          Open shifts refer to shifts that have not been assigned to any worker
          yet.
        </p>
      </div>
    );
  };

  const handleWorkerAvailability = (item) => {
    setLoadingItemId(item.uuid);
    workerProfileDetailsFetchRequest({
      profile_id: item?.uuid,
    });
    setWorkerProfileUUID(item?.uuid);
    setOpenModal(true);
  };

  const isRecurringShiftReadOnly = useMemo(() => {
    if (selectedShift === null) return false;
    // Drafts are not recurring series — missing interval/repeat is undefined,
    // and `!== null` would incorrectly lock Shift date on resume.
    if (isAdvanceShiftDraft(selectedShift) || activeDraftUuid) return false;
    const source =
      shiftDetailData &&
      !Array.isArray(shiftDetailData) &&
      (shiftDetailData.uuid || shiftDetailData.id)
        ? shiftDetailData
        : selectedShift;
    return isAdvanceShiftInRecurringSeries(source);
  }, [selectedShift, activeDraftUuid, shiftDetailData]);

  const disablDueToRecurringShift = useCallback(
    () => isRecurringShiftReadOnly,
    [isRecurringShiftReadOnly]
  );

  const handleRemoveShiftInstruction = useCallback((index) => {
    setShiftInstructions((prev) => {
      const updatedInstructions = [...prev];
      const instruction = updatedInstructions[index];

      if (instruction?.shift_instruction) {
        instruction.shift_instruction = null;
      }

      return updatedInstructions;
    });

    setEditableInstructionIndex(null);
  }, []);

  const handleChangeServiceCategory = (serviceId) => {
    const nextId = serviceId ?? null;
    // Only keep participant defaults that exist in the loaded category list.
    // Otherwise the form holds a hidden id while the dropdown looks empty.
    if (
      nextId != null &&
      nextId !== "" &&
      Array.isArray(serviceTypes) &&
      serviceTypes.length > 0 &&
      !serviceTypes.some((x) => String(x.value) === String(nextId))
    ) {
      // Refuse invalid/out-of-list defaults (e.g. participant invoice_category_id
      // filtered out of serviceTypes). Do NOT clear a valid current selection —
      // that wiped manually chosen categories when a participant was selected.
      return;
    }
    setValue("invoice_service_type_id", nextId, {
      // Don't surface required errors until Create is pressed.
      shouldValidate: basicValidationAttempted,
      shouldDirty: true,
    });
    if (nextId != null && nextId !== "") {
      clearErrors("invoice_service_type_id");
    }
  };

  // Display only what is actually in the form (ParticipantSelection seeds the value).
  const selectedServiceCategory = useMemo(() => {
    const invoice_service_type_id = watchFormData?.invoice_service_type_id;
    if (invoice_service_type_id == null || invoice_service_type_id === "") {
      return null;
    }
    return (
      serviceTypes?.find(
        (x) => String(x.value) === String(invoice_service_type_id)
      ) || null
    );
  }, [watchFormData?.invoice_service_type_id, serviceTypes]);

  // Drop stale/out-of-list category ids on new basic shifts so required validation can run.
  useEffect(() => {
    if (selectedShift != null || isAdvanceMode || prefillFromShiftRequest) return;
    const currentId = watchFormData?.invoice_service_type_id;
    if (currentId == null || currentId === "" || !serviceTypes?.length) return;
    const inList = serviceTypes.some(
      (opt) => String(opt.value) === String(currentId)
    );
    if (!inList) {
      setValue("invoice_service_type_id", null, { shouldValidate: false });
      clearErrors("invoice_service_type_id");
    }
  }, [
    selectedShift,
    isAdvanceMode,
    prefillFromShiftRequest,
    serviceTypes,
    watchFormData?.invoice_service_type_id,
    setValue,
    clearErrors,
  ]);

  const [NDISItemNameOptions, setNDISItemName] = useState(null);

  useEffect(() => {
    if (
      selectedServiceCategory &&
      watchFormData?.shift_date &&
      selectedParticipant
    ) {
      let ptId = Array.isArray(selectedParticipant)
        ? selectedParticipant[0]?.id
        : selectedParticipant?.id;

      const formattedDate = watchFormData.shift_date
        ? moment.utc(watchFormData.shift_date, "YYYY-MM-DD").toISOString()
        : "";
      if (ptId && formattedDate) {
        apiGetRequest(
          `${URL_ROSTERING_GET_NDIS_LINE_ITEMS_ON_SCHEDULING_SHIFT}?invoice_service_type_id=${selectedServiceCategory.value}&pt_id=${ptId}&shift_date=${formattedDate}`
        )
          .then((res) => {
            const data = res?.data?.data?.items;
            if (data && data.length > 0) {
              const options = data.map((item) => ({
                label: `${item?.support_item_name}`,
                value: item?.id,
                number: item?.support_item_number,
                name: item?.support_item_name,
                price: item?.price,
              }));

              setNDISItemName(options);
            }
          })
          .catch((err) => {
            console.error("Error fetching service types:", err);
          });
      }
    }
  }, [
    selectedParticipant,
    watchFormData?.shift_date,
    selectedServiceCategory?.value,
  ]);

  const selectedNDISItemName = useMemo(() => {
    const result =
      NDISItemNameOptions?.find(
        (x) => x.value === watchFormData?.invoice_item_id
      ) || null;
    if (result) {
      setValue("support_item_number", result?.number);

      setValue("price", result?.price);
      setValue("support_item_name", result?.name);
    }
    return result;
  }, [watchFormData?.invoice_item_id]);

  

  useEffect(() => {
    // Legacy v2 split-shifts only apply to basic shifts. V5 advance
    // (multi-assignment) shifts load their segments from the v5 details API.
    if (isAdvanceMultiAssignmentShift(selectedShift) || isAdvanceMode) return;
    if (selectedShift && selectedShift?.uuid && serviceTypes?.length > 0) {
      apiGetRequest(
        `${URL_ROSTERING_GET_SPLIT_SHIFTS}${selectedShift?.uuid}`,
        null,
        { allowNotFound: true }
      )
        .then((res) => {
          if (res?.data && res?.data?.data && res?.data?.data?.length > 0) {
            const modifiedData = res?.data?.data.map((item) => ({
              support_item_number: item.ndis_support_item_number,
              support_item_name: item.ndis_support_item_name,
              start_time: item.start_time
                ? moment(item.start_time, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
                : "",
              end_time: item.end_time
                ? moment(item.end_time, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
                : "",
              // Preserve custom line identity so Claim Type stays tied to the CLI
              // after reopen (without uuid, SplitShift auto-defaults can replace it).
              invoice_item_id: item.custom_line_item
                ? null
                : item.invoice_item_id,
              custom_line_item_uuid: item.custom_line_item?.uuid ?? null,
              custom_line_item: item.custom_line_item ?? null,
              invoice_service_type_id: item.service_type_id,
              service_type_name: item.service_type_name ?? null,
              service_type_funding_type: item.service_type_funding_type ?? null,
              price: item.invoice_price,
              sleepover: item.is_sleepover,
              duration: item.duration || 0,
              // Same as advance edit hydrate: claim_type primary, is_travel legacy only.
              claim_type:
                item.claim_type ??
                (item.is_travel != null
                  ? claimTypeFromIsTravel(item.is_travel)
                  : null),
            }));

            replace(modifiedData);
            setIsShiftSplit(true);
          }
        })
        .catch((err) => {
          // Error handled silently
        });
    }
  }, [selectedShift?.uuid, serviceTypes, isAdvanceMode]);
  const [isShowEndShiftWarning, setIsShowEndShiftWarning] = useState(false);


  // Shift creation form with modern design
  const createShiftPopup = () => {
    return (
      <div>
        {watchFormData && (
          <>
            <div className='flex justify-between px-3'>
              {
                <WorkerShiftDetail
                  userItem={
                    calendarView === "worker-view"
                      ? getSelectedParticipant("pt_id")
                      : getSelectedOption("worker_id")
                  }
                  shiftDetail={watchFormData}
                  isGroupShift={watchFormData?.is_group_shift}
                  selectedShift={selectedShift}
                  setIsSelectLocationOpen={setIsSelectLocationOpen}
                  onClearLocation={handleClearLocation}
                  onUseParticipantLocation={handleUseParticipantLocation}
                  isLocationManuallySet={isLocationManuallySet}
                  hasParticipant={
                    isAdvanceMode
                      ? advanceShiftLocationContext.hasSource
                      : !!watchFormData?.pt_id
                  }
                  isAdvanceMode={isAdvanceMode}
                />
              }
            </div>
            <div className='divide-y pt-4 border-b border-text-gray-700'></div>
          </>
        )}

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='px-5 pt-7'>
            <div className='flex  gap-x-2  gap-y-2'>
              <div className='flex flex-col w-full sm:w-1/2 gap-y-4'>
                <div className='flex items-center justify-between'>
                  <label className='text-gray-700 lg:text-sm font-medium mb-1 sm:text-xs'>
                    Worker Tracking
                  </label>
                  <Controller
                    name='location_tracking'
                    control={control}
                    defaultValue={watchFormData?.location_tracking || true}
                    render={({ field }) => (
                      <SwitchWithIcon
                        onChange={(value) => {
                          field.onChange(value);
                          setValue("location_tracking", value);
                        }}
                        checked={field.value}
                        disabled={checkRunningShiftStatus(
                          selectedShift?.status
                        )}
                      />
                    )}
                  />
                </div>
                {!isAdvanceMode && (
                <div className='flex flex-col '>
                  <div className='flex items-center justify-between'>
                    <label className='text-gray-700 lg:text-sm font-medium mb-1  sm:text-xs'>
                      Group Shift
                    </label>
                    <SwitchWithIcon
                      additionalCheck={(e) => {
                        if (
                          calendarView === "participant-view" &&
                          e &&
                          (watchFormData?.pt_id === null ||
                            watchFormData?.pt_id === undefined ||
                            watchFormData?.pt_id === "")
                        ) {
                          {
                            /*commented for Open group shift purpose*/
                          }

                          dispatch(
                            showToast({
                              id: TOAST_IDS.GROUP_SHIFT_CANNOT_CREATED,
                              type: TOAST_TYPE.ERROR,
                              title: `Please Select ${participantLabel} First!`,
                            })
                          );

                          setValue("is_group_shift", false);
                          return false;
                        } else if (
                          calendarView === "worker-view" &&
                          e &&
                          (watchFormData?.worker_id === null ||
                            watchFormData?.worker_id === undefined ||
                            watchFormData?.worker_id === "")
                        ) {
                          dispatch(
                            showToast({
                              id: TOAST_IDS.GROUP_SHIFT_CANNOT_CREATED,
                              type: TOAST_TYPE.ERROR,
                              title: "Plase Select Worker First!",
                            })
                          );
                          setValue("is_group_shift", false);
                          return false;
                        }
                        return true;
                      }}
                      onChange={handleGroupShiftToggleChange}
                      checked={parseBooleanVal(watchFormData?.is_group_shift)}
                      disabled={
                        selectedShift &&
                        checkRunningShiftStatus(selectedShift?.status)
                      }
                    />
                  </div>
                </div>
                )}
                {!isAdvanceMode && calendarView === "participant-view" &&
                  watchFormData?.is_group_shift && (
                    <div className='flex items-center justify-between '>
                      <label className='text-gray-700 lg:text-sm font-medium mb-1 sm:text-xs  flex items-center justify-center'>
                        Open Group Shift
                        <a data-tooltip-id='tooltip-open-shift'>
                          <FaQuestionCircle
                            data-tip
                            data-tooltip-id='manualAcceptHelp'
                            className='ml-1 text-gray-500 cursor-pointer'
                          />
                        </a>
                      </label>
                      <Tooltip
                        id='tooltip-open-shift'
                        place='top'
                        content={getToolTipContentOpenShift()}
                        variant='dark'
                        className='z-20'
                      />
                      <Controller
                        name='open_shift'
                        control={control}
                        defaultValue={
                          shiftDetailData?.open_group_shift || false
                        }
                        render={({ field }) => (
                          <SwitchWithIcon
                            onChange={(value) => {
                              field.onChange(value);
                              setValue("open_shift", value);
                            }}
                            checked={field.value}
                          />
                        )}
                      />
                    </div>
                  )}
                {!isAdvanceMode && calendarView === "participant-view" &&
                  !watchFormData?.is_group_shift && (
                    <div className='flex items-center justify-between '>
                      <label className='text-gray-700 lg:text-sm font-medium mb-1 sm:text-xs  flex items-center justify-center'>
                        Open Shift
                        <a data-tooltip-id='tooltip-open-shift'>
                          <FaQuestionCircle
                            data-tip
                            data-tooltip-id='manualAcceptHelp'
                            className='ml-1 text-gray-500 cursor-pointer'
                          />
                        </a>
                      </label>
                      <Tooltip
                        id='tooltip-open-shift'
                        place='top'
                        content={getToolTipContentOpenShift()}
                        variant='dark'
                        className='z-20'
                      />
                      <Controller
                        name='single_open_shift'
                        control={control}
                        defaultValue={false}
                        render={({ field }) => (
                          <SwitchWithIcon
                            onChange={(value) => {
                              field.onChange(value);
                              setValue("single_open_shift", value);
                              if (value) {
                                setValue("worker_id", null);
                                setShiftOverlap(null);
                              }
                            }}
                            checked={field.value}
                          />
                        )}
                      />
                    </div>
                  )}
              </div>
              <div className='w-0.5 mx-1 h-15 bg-gray-300'></div>

              <div className='flex flex-col w-full sm:w-1/2 gap-y-4'>
                <div className='flex items-center justify-between'>
                  <label className='text-gray-700 lg:text-sm font-medium mb-1 sm:text-xs'>
                    {participantLabel}'s Signature
                  </label>
                  <Controller
                    name='is_signature'
                    control={control}
                    defaultValue={watchFormData?.is_signature || false}
                    render={({ field }) => (
                      <SwitchWithIcon
                        onChange={(value) => {
                          field.onChange(value);
                          setValue("is_signature", value);
                        }}
                        checked={field.value}
                        disabled={checkRunningShiftStatus(
                          selectedShift?.status
                        )}
                      />
                    )}
                  />
                </div>
                <div className='flex items-center justify-between'>
                  <label className='text-gray-700 lg:text-sm font-medium mb-1  sm:text-xs flex items-center justify-center'>
                    Enforce Distance Restriction
                  </label>

                  <Controller
                    name='is_radius'
                    control={control}
                    defaultValue={watchFormData?.is_radius || true}
                    render={({ field }) => (
                      <SwitchWithIcon
                        onChange={(value) => {
                          field.onChange(value);
                          setValue("is_radius", value);
                        }}
                        checked={field.value}
                        disabled={checkRunningShiftStatus(
                          selectedShift?.status
                        )}
                      />
                    )}
                  />
                </div>
              </div>
              <div className='w-0.5 h-15 mx-1 bg-gray-300'></div>
              <div className='flex flex-col w-full sm:w-1/2 gap-y-4'>
                <div className='flex items-center justify-between'>
                  <label className='text-gray-700 lg:text-sm font-medium mb-1 sm:text-xs'>
                    Allow Shift Overlapping
                  </label>
                  <Controller
                    name='shift_overlapped'
                    control={control}
                    defaultValue={watchFormData?.shift_overlapped || false}
                    render={({ field }) => (
                      <SwitchWithIcon
                        onChange={(value) => {
                          field.onChange(value);
                          setValue("shift_overlapped", value);
                        }}
                        checked={field.value}
                        disabled={checkRunningShiftStatus(
                          selectedShift?.status
                        )}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            {shiftOverlap &&
              shiftOverlap?.overlapping_shift &&
              shiftOverlap?.overlapping_shift[0]?.overlapped &&
              !watchFormData?.shift_overlapped && (
                <div className='flex items-center mt-2 bg-red-100 border border-red-400 text-red-700 p-1 rounded'>
                  <FaExclamationCircle className='text-red-500 mr-2 h-6 w-6' />
                  <p className='text-sm font-semibold'>
                    {shiftOverlap &&
                      shiftOverlap?.overlapping_shift[0]?.worker_name?.length >
                        0 &&
                      shiftOverlap?.overlapping_shift[0]?.worker_name
                        ?.map((item) => `${item}, `)
                        .join(" ")}{" "}
                    {shiftOverlap?.overlapping_shift[0]?.worker_name?.length >
                      0 &&
                    shiftOverlap?.overlapping_shift[0]?.worker_name?.length ===
                      1
                      ? "already has "
                      : "already have "}
                    shift during this time, causing an overlap. To proceed with
                    scheduling, please turn on the "Allow Shift Overlapping"
                    option
                  </p>
                </div>
              )}

            {shiftOverlap &&
              shiftOverlap?.availability?.length > 0 &&
              shiftOverlap?.availability?.map((item) => (
                <div className='flex items-center min-w-full mt-2 bg-yellow-100 border border-yellow-500 text-yellow-700 p-1 rounded'>
                  <IoWarningOutline className='text-yellow-500 mr-2 h-6 w-6' />
                  <p className='text-sm font-semibold'>
                    {item?.name} is not available for the selected time slot,
                    <span
                      onClick={() => handleWorkerAvailability(item)}
                      className=' text-blue-500 text-sm hover:text-blue-700 cursor-pointer underline'
                    >
                      {getWorkerProfileLoader &&
                      loadingItemId === item?.uuid ? (
                        <Loader cssClass='ml-2' isScheduleScreen isSmallView />
                      ) : (
                        " Please click here to check their availability."
                      )}
                    </span>
                  </p>
                </div>
              ))}
            {onLeave && onLeaveMessage && (
              <div className='flex items-center min-w-full mt-2 bg-yellow-100 border border-yellow-500 text-yellow-700 p-1 rounded'>
                <IoWarningOutline className='text-yellow-500 mr-2 h-6 w-6' />
                <p className='text-sm font-semibold'>{onLeaveMessage}</p>
              </div>
            )}
            {isLessThan12Hours &&  (
                <div className='flex items-center min-w-full mt-2 bg-yellow-100 border border-yellow-500 text-yellow-700 p-1 rounded'>
                  <IoWarningOutline className='text-yellow-500 mr-2 h-6 w-6' />
                  <p className='text-sm font-semibold'>
                    Please note that sleepover shift under SCHADS must be at least 12 hours
                  </p>
                </div>
            )}

            <div className='grid grid-cols-2 gap-y-4 gap-x-5'>
              <WorkerSelection
                selectedWorker={selectedWorker}
                watchFormData={watchFormData}
                calendarView={calendarView}
                selectedShift={selectedShift}
                workerOptions={sortedWorkerOptions}
                register={register}
                setValue={setValue}
                control={control}
                watch={watch}
                getSelectedOption={getSelectedOption}
                setSelectedOptions={setSelectedOptions}
                selectedOptions={selectedOptions}
                clearErrors={clearErrors}
                errors={errors}
                isCallFromAddShift={isShiftRequestApprovalFlow}
                setIsWorkerLoaded={setIsWorkerLoaded}
                isWorkerLoaded={isWorkerLoaded}
                setWorkerOptions={setWorkerOptionsSorted}
                setParticipantOptions={setParticipantOptionsSorted}
                checkDisabilityOfShiftStatus={checkDisabilityOfShiftStatus}
                checkDisabliltyOfShiftForWorker={
                  checkDisabliltyOfShiftForWorker
                }
                checkRunningShiftStatus={checkRunningShiftStatus}
                handleChangeWorkerOrParticipant={
                  handleChangeWorkerOrParticipant
                }
                userItem={userItem}
                isFetchRecordDetailLoader={isFetchRecordDetailLoader}
                setIsParticipantLoaded={setIsParticipantLoaded}
                isOpenShift={watchFormData?.open_shift}
              />
              
              {/* Nearby Workers Suggestion - Only in old design (removed, now only in new design) */}
              {false && nearbyWorkers.length > 0 && shiftLocation?.lat && shiftLocation?.lng && (
                <div className='col-span-2 mt-2 p-3 bg-blue-50 border border-blue-200 rounded-lg'>
                  <div className='flex items-center mb-2'>
                    <span className='text-sm font-semibold text-blue-700'>
                      📍 Nearby Workers (based on shift location)
                    </span>
                  </div>
                  <div className='flex flex-wrap gap-2'>
                    {nearbyWorkers.map((worker) => {
                      // Format distance: show meters if < 1km, otherwise km
                      const formatDistance = (distance) => {
                        if (!distance && distance !== 0) return '';
                        if (distance < 1) {
                          const meters = Math.round(distance * 1000);
                          return `${meters}m`;
                        }
                        return `${distance.toFixed(1)}km`;
                      };
                      
                      return (
                        <button
                          key={worker.uuid}
                          type='button'
                          onClick={() => {
                            setValue("worker_id", worker.uuid);
                            handleChangeWorkerOrParticipant({
                              type: "worker",
                              uuid: worker.uuid,
                            }).then(() => setIsWorkerLoaded(true));
                          }}
                          className='px-3 py-1.5 text-xs bg-white border border-blue-300 rounded-md hover:bg-blue-100 transition-colors flex items-center gap-2'
                          disabled={checkDisabliltyOfShiftForWorker() || checkDisabilityOfShiftStatus(selectedShift?.status)}
                        >
                          <span className='font-medium'>
                            {worker.first_name} {worker.last_name}
                          </span>
                          <span className='text-blue-600 font-semibold'>
                            {formatDistance(worker.distance)}
                          </span>
                        </button>
                      );
                    })}
                  </div>
                  {nearbyWorkersLoading && (
                    <div className='mt-2 text-xs text-gray-500'>
                      Loading nearby workers...
                    </div>
                  )}
                </div>
              )}

              <ParticipantSelection
                getSelectedOption={getSelectedOption}
                getSelectedParticipant={getSelectedParticipant}
                createOrUpdateWorkerShiftLoader={
                  createOrUpdateWorkerShiftLoader
                }
                handleChangeServiceCategory={handleChangeServiceCategory}
                watchFormData={watchFormData}
                calendarView={calendarView}
                setParticipantOptions={setParticipantOptionsSorted}
                participantOptions={sortedParticipantOptions}
                register={register}
                setValue={setValue}
                selectedShift={selectedShift}
                checkRunningShiftStatus={checkRunningShiftStatus}
                checkDisabilityOfShiftStatus={checkDisabilityOfShiftStatus}
                handleChangeWorkerOrParticipant={
                  handleChangeWorkerOrParticipant
                }
                isFetchRecordDetailLoader={isFetchRecordDetailLoader}
                control={control}
                watch={watch}
                setSelectedOptions={setSelectedOptions}
                selectedOptions={selectedOptions}
                clearErrors={clearErrors}
                errors={errors}
                userItem={userItem}
                setIsWorkerLoaded={setIsWorkerLoaded}
                isCallFromAddShift={isShiftRequestApprovalFlow}
                setWorkerOptions={setWorkerOptionsSorted}
                setIsParticipantLoaded={setIsParticipantLoaded}
                isParticipantLoaded={isParticipantLoaded}
                selectedParticipant={selectedParticipant}
                isOpenShift={watchFormData?.open_shift}
                shiftDetailData={shiftDetailData}
                setShouldCallHandleChangeWorkerOrParticipant={
                  setShouldCallHandleChangeWorkerOrParticipant
                }
                serviceTypeSelectedOptions={serviceTypeSelectedOptions}
              />

              <div className='col-span-2'>
                <div className='grid grid-cols-3 gap-x-5'>
                  <div className='col-span-1'>
                    <InputField
                      setValue={setValue}
                      register={register}
                      pattern={
                        validateCurrentDate(
                          moment(watchFormData?.date ?? null),
                          moment(new Date()),
                          ["present", "future", "past"],
                          true
                        )
                          ? DUMMY_REGEX_EXP
                          : null
                      }
                      label={"Shift Date"}
                      type='date'
                      value={
                        watchFormData?.date
                          ? moment(watchFormData?.date).format("DD-MM-YYYY")
                          : null
                      }
                      name='shift_date'
                      isDisabled={checkDisabilityOfShiftStatus(
                        selectedShift?.status
                      )}
                      readOnly={disablDueToRecurringShift()}
                      isRequired={true}
                      ErrorMessage={
                        errors?.shift_date?.type === "required"
                          ? "This field is required!"
                          : errors?.shift_date?.type === "pattern"
                          ? validateCurrentDate(
                              moment(watchFormData?.shift_date ?? null),
                              moment(new Date()),
                              ["present", "future", "past"],
                              false
                            )
                          : null
                      }
                    />
                  </div>
                  <div className='col-span-1'>
                    <label className='text-gray-700 text-sm font-medium mb-1'>
                      Shift Start Time
                    </label>

                    <div className='w-full'>
                      <TimePicker
                        {...(() => {
                          const { ref, ...rest } = register("start_time", { required: true });
                          return rest;
                        })()}
                        className='did-floating-input'
                        hour12Format={true}
                        eachInputDropdown={true}
                        manuallyDisplayDropdown={true}
                        onChange={(e) => {
                          setValue("start_time", e);
                        }}
                        value={watchFormData?.start_time || ""}
                      />
                    </div>
                    {errors.start_time && (
                      <span style={{ color: "red", fontSize: "13px" }}>
                        {errors.start_time.message}
                      </span>
                    )}
                  </div>
                  <div className='col-span-1'>
                    <label className='text-gray-700 text-sm font-medium mb-1'>
                      Shift End Time
                    </label>
                    <div className='w-full flex items-center gap-2'>
                      <TimePicker
                        {...(() => {
                          const { ref, ...rest } = register("end_time", {
                            required: true,
                            validate: () =>
                              getShiftLength(
                                watchFormData?.start_time,
                                watchFormData?.end_time,
                                false,
                                true
                              ),
                          });
                          return rest;
                        })()}
                        className='did-floating-input'
                        hour12Format={true}
                        eachInputDropdown={true}
                        manuallyDisplayDropdown={true}
                        onChange={(e) => {
                          setValue("end_time", e);
                        }}
                        value={watchFormData?.end_time || ""}
                      />
                      {/* Split Shift Icon */}
                      <span
                        className='cursor-pointer border border-purple-300 rounded p-2 hover:bg-purple-100'
                        title='Split Shift'
                        onClick={handleAddSplitShift}
                      >
                        <IoCutSharp className='text-purple-500  text-lg' />
                      </span>
                    </div>
                    {errors.end_time && (
                      <span
                        style={{ color: "red", fontSize: "13px" }}
                        // className='capitalize'
                      >
                        {errors?.end_time?.type === "required"
                          ? "This field is required!"
                          : errors?.end_time?.type === "validate" &&
                            getShiftLength(
                              watchFormData?.start_time,
                              watchFormData?.end_time,
                              true
                            ) === "00:00"
                          ? "Shift can't be zero hours & minutes!"
                          : null}
                      </span>
                    )}
                  </div>
                  <div className='col-span-2'></div>
                </div>
              </div>
              {shiftDetailData && shiftDetailData?.worker_start_time && (
                <div className='col-span-2'>
                  <div className='grid grid-cols-3 gap-x-5'>
                    <div className='col-span-1'>
                      <InputField
                        setValue={setValue}
                        register={register}
                        pattern={
                          validateCurrentDate(
                            moment(watchFormData?.date ?? null),
                            moment(new Date()),
                            ["present", "future", "past"],
                            true
                          )
                            ? DUMMY_REGEX_EXP
                            : null
                        }
                        label={"Shift Date"}
                        type='date'
                        value={
                          watchFormData?.date
                            ? moment(watchFormData?.date).format("DD-MM-YYYY")
                            : null
                        }
                        name='shift_date'
                        isDisabled={selectedShift}
                        isRequired={true}
                        readOnly={true}
                        ErrorMessage={
                          errors?.shift_date?.type === "required"
                            ? "This field is required!"
                            : errors?.shift_date?.type === "pattern"
                            ? validateCurrentDate(
                                moment(watchFormData?.shift_date ?? null),
                                moment(new Date()),
                                ["present", "future", "past"],
                                false
                              )
                            : null
                        }
                      />
                    </div>
                    <div className='col-span-1'>
                      <label className='text-gray-700 text-sm font-medium mb-1'>
                        Shift Start Time(worker)
                      </label>
                      <InputField
                        readOnly={true}
                        register={register}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        name='worker_start_time'
                        cssClass='z-20'
                      />
                    </div>

                    <div className='col-span-1'>
                      <label className='text-gray-700 text-sm font-medium mb-1'>
                        Shift End Time(worker)
                      </label>
                      <InputField
                        readOnly={true}
                        register={register}
                        setValue={setValue}
                        clearErrors={clearErrors}
                        name='worker_end_time'
                        isDisabled={
                          watchFormData?.worker_start_time === null ||
                          watchFormData?.worker_start_time === undefined
                        }
                        cssClass='z-20'
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {!isShiftSplit && (
              <>
                <div className='grid grid-cols-3 gap-x-5 mt-3'>
                  <div className='col-span-1'>
                    <label className='text-gray-700 text-sm font-medium mb-1'>
                      Service Category
                    </label>
                    <SelectOption
                      data={serviceTypes}
                      isDisabled={checkRunningShiftStatus(
                        selectedShift?.status
                      )}
                      isRequired={true}
                      register={register}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      name='invoice_service_type_id'
                      cssClass='z-20'
                      selectedOption={selectedServiceCategory}
                      errorMessage={
                        errors?.invoice_service_type_id?.type === "required"
                          ? "This field is required!"
                          : null
                      }
                    />
                  </div>
                  <div className='flex items-center gap-x-2 col-span-1'>
                    <label className='text-gray-700 text-sm font-medium '>
                      Ratio (Worker: {participantLabelPlural})
                    </label>
                    {Array.isArray(workerRatio)
                      ? workerRatio?.length
                      : workerRatio
                      ? 1
                      : 0}{" "}
                    :{" "}
                    {calendarView === "participant-view" &&
                    selectedShift &&
                    shiftDetailData?.participants?.length > 0
                      ? shiftDetailData?.participants?.length
                      : Array.isArray(participantRatio)
                      ? participantRatio?.length
                      : participantRatio
                      ? 1
                      : 0}
                  </div>

                  <div
                    className='flex items-center gap-x-2 col-span-1'
                    title='select this option if sleepover shift'
                  >
                    <label className='text-gray-700 text-sm font-medium mb-1'>
                      Sleepover Shift
                    </label>
                    <div>
                      <Controller
                        name={`sleepover`}
                        control={control}
                        defaultValue={watchFormData?.sleepover || false}
                        render={({ field }) => (
                          <SwitchWithIcon
                            onChange={(value) => {
                              field.onChange(value);
                              setValue(`sleepover`, value);
                            }}
                            checked={field.value}
                            disabled={checkRunningShiftStatus(
                              selectedShift?.status
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
             
                </div>

                <div className='grid grid-cols-3 gap-x-5 mt-3'></div>
              </>
            )}

            {isShiftSplit && (
              <div className='grid grid-cols-3 gap-x-5 mt-3'>
                <div className='flex items-center gap-x-2 col-span-1'>
                  <label className='text-gray-700 text-sm font-medium '>
                    Ratio (Worker: {participantLabelPlural})
                  </label>
                  {Array.isArray(workerRatio)
                    ? workerRatio?.length
                    : workerRatio
                    ? 1
                    : 0}{" "}
                  :{" "}
                  {calendarView === "participant-view" &&
                  selectedShift &&
                  shiftDetailData?.participants?.length > 0
                    ? shiftDetailData?.participants?.length
                    : Array.isArray(participantRatio)
                    ? participantRatio?.length
                    : participantRatio
                    ? 1
                    : 0}
                </div>
              </div>
            )}

            {isShiftSplit && (
              <div className='flex flex-col gap-2 mt-2'>
                {splitShifts.map((field, index) => (
                  <SplitShift
                    key={field.id || index}
                    index={index}
                    shift={field}
                    watch={watch}
                    register={register}
                    setValue={setValue}
                    control={control}
                    errors={errors}
                    clearErrors={clearErrors}
                    serviceTypes={serviceTypes} 
                    selectedParticipant={selectedParticipant}
                    onRemove={() => handleRemoveSplitShift(index)}
                    totalShiftDuration={getShiftLength(
                      watchFormData?.start_time,
                      watchFormData?.end_time,
                      true
                    )}
                    setIsLessThan12Hours={setIsLessThan12Hours}
                    spRosteringSetting={spRosteringSetting}
                  />
                ))}
              </div>
            )}

            <div className='col-span-2 mt-2'>
              <label className='text-gray-700 text-sm font-medium mb-1'>
                Shift Tasks
              </label>

              {tasks.map((taskObj, index) => (
                <div key={index} className='flex justify-between'>
                  <div className='w-[95%]'>
                    <InputField
                      readOnly={checkRunningShiftStatus(selectedShift?.status)}
                      placeholder='Add your tasks here...'
                      value={taskObj.task}
                      handleChange={(e) => handleTaskChange(index, e)}
                      type='text'
                      name={`task[${index}]`}
                      icon={
                        taskObj?.is_completed && (
                          <HiCheckCircle
                            className=' h-5 w-5 text-green-500'
                            title='Task Completed'
                          />
                        )
                      }
                    />
                  </div>

                  <div className='pt-3'>
                    <div
                      onClick={() =>
                        !checkRunningShiftStatus(selectedShift?.status) &&
                        handleTaskDelete(index)
                      }
                      tabIndex={0}
                      role='button'
                      className='icon-delete-wrapper'
                      title='Delete Task'
                    >
                      <HiOutlineTrash className='icon-size' />
                    </div>
                  </div>
                </div>
              ))}

              <div className='mt-1 text-[#4B6CB7] text-[15px] font-medium max-w-ma'>
                <span
                  onClick={() => handleAddTask()}
                  className={`${
                    !checkRunningShiftStatus(selectedShift?.status) &&
                    "cursor-pointer"
                  }`}
                >
                  + Add More Tasks
                </span>
              </div>

              {/* {shiftDetailData?.length > 0 &&
                shiftDetailData?.shift_notes?.map((singleShiftNote, index) => (
                  <div
                    key={index}
                    className='flex flex-col items-start border-gray-200 border-b py-5'
                  >
                    <label className='text-gray-700 text-sm font-medium mb-1'>
                      Shift Notes for{" "}
                      {capitalizeAllLetters(singleShiftNote?.first_name)}{" "}
                      {capitalizeAllLetters(singleShiftNote?.last_name)}
                    </label>
                    <br />
                    <textarea
                      className='bg-[#4b6bb710] px-4 py-2 border shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full text-sm border-gray-300 text-base rounded-md resize-y overflow-y-auto'
                      rows={1}
                      value={singleShiftNote?.notes}
                      readOnly
                    />
                  </div>
                ))} */}
              {notes?.map((note, index) => (
                <div key={index} className='flex flex-col border-b py-3'>
                  <label className='text-gray-700 text-sm font-medium mb-1'>
                    Shift Notes for {capitalizeAllLetters(note?.first_name)}{" "}
                    {capitalizeAllLetters(note?.last_name)}
                  </label>
                  <textarea
                    className='bg-[#f9fafb] px-4 py-2 border rounded-md'
                    rows={2}
                    value={note.notes || ""}
                    onChange={(e) => {
                      const updatedNotes = [...notes];
                      updatedNotes[index].notes = e.target.value;
                      setNotes(updatedNotes);
                    }}
                  />
                </div>
              ))}

              {isShiftInstructionLoading ? (
                <div className='flex items-center justify-center'>
                  <Loader cssClass='mt-4' isScheduleScreen />
                </div>
              ) : (
                shiftInstructions?.length > 0 &&
                shiftInstructions?.map((instruction, index) => (
                  <div
                    key={index}
                    className='mt-4 p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow'
                  >
                    <label className='block text-gray-800 text-sm font-semibold mb-2'>
                      Shift Instructions for{" "}
                      {capitalizeWords(instruction?.first_name)}{" "}
                      {capitalizeWords(instruction?.last_name)}
                    </label>

                    {instruction?.shift_instruction ||
                    editableInstructionIndex === index ? (
                      <div>
                        <textarea
                          rows={3}
                          value={instruction?.shift_instruction || ""}
                          onChange={(e) =>
                            handleShiftInstructionChange(index, e)
                          }
                          className='w-full p-2 text-gray-900 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all'
                          aria-label={`Shift instructions for ${instruction?.first_name} ${instruction?.last_name}`}
                        />
                        <button
                          onClick={() => handleRemoveShiftInstruction(index)}
                          className='mt-2 text-red-600 text-sm font-semibold hover:underline focus:outline-none'
                          aria-label={`Remove shift instructions for ${instruction?.first_name} ${instruction?.last_name}`}
                        >
                          Remove Shift Instructions
                        </button>
                      </div>
                    ) : (
                      <button
                        onClick={() => handleAddShiftInstruction(index)}
                        className='w-full py-2 px-4 bg-blue-50 text-blue-700 text-sm font-medium rounded-md hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all'
                        aria-label={`Add shift instructions for ${instruction?.first_name} ${instruction?.last_name}`}
                      >
                        + Add Shift Instructions (You can also setup default
                        shift instructions from the {participantLabel.toLowerCase()}'s settings
                        screen)
                      </button>
                    )}
                  </div>
                ))
              )}

              {selectedShift !== null &&
                shiftDetailData?.recurring_interval !== null && (
                  <div
                    className='col-span-2 flex gap-5  items-center   mt-6 '
                    ref={modalContentRef}
                  >
                    <div className='flex gap-3'>
                      <label className='text-gray-700 text-sm font-medium mb-1'>
                        Do you want to make this shift recurring?
                      </label>
                      <div>
                        <Controller
                          name={`is_recurring`}
                          control={control}
                          defaultValue={watchFormData?.is_recurring || false}
                          render={({ field }) => (
                            <SwitchWithIcon
                              onChange={(value) => {
                                field.onChange(value);
                                setValue(`is_recurring`, value);
                                setRecurringType(null);
                                setRecurrInterval(null);
                              }}
                              checked={field.value}
                              disabled={selectedShift !== null}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                )}
              {!isDateInPast(watchFormData?.shift_date) &&
                selectedShift === null && (
                  <div
                    className='col-span-2 flex gap-2  items-center  mt-6 '
                    ref={modalContentRef}
                  >
                    <label className='text-gray-700 text-sm font-medium mb-1'>
                      Do you want to make this shift recurring?
                    </label>
                    <div>
                      <Controller
                        name={`is_recurring`}
                        control={control}
                        defaultValue={watchFormData?.is_recurring || false}
                        render={({ field }) => (
                          <SwitchWithIcon
                            onChange={(value) => {
                              field.onChange(value);
                              setValue(`is_recurring`, value);
                              setRecurringType(null);
                              setRecurrInterval(null);
                            }}
                            checked={field.value}
                            // disabled={selectedShift!==null}
                          />
                        )}
                      />
                    </div>
                  </div>
                )}

              {watchFormData?.is_recurring && (
                <div className='col-span-2'>
                  <RecurringShift
                    setRecurringType={setRecurringType}
                    recurringType={recurringType}
                    watchFormData={watchFormData}
                    setRecurrInterval={setRecurrInterval}
                    recurrInterval={recurrInterval}
                    setRecurringDates={setRecurringDates}
                    setSelectedDays={setSelectedDays}
                    selectedDays={selectedDays}
                    selectedShift={selectedShift}
                    setRecurringFor={setRecurringFor}
                    recurringFor={recurringFor}
                    handleIntervalChange={handleIntervalChange}
                    shiftDetailData={shiftDetailData}
                  />
                </div>
              )}
            </div>
            <div className='hidden'>
              <button
                id='createShiftButton'
                type='submit'
                className='hidden sr-only'
              />
            </div>
          </div>
        </form>
      </div>
    );
  };

  // New redesigned view - Modern, creative design with better UX
  // Same gate as delete: invoice generated OR timesheet approved.
  const advanceStatusSource =
    shiftDetailData &&
    !Array.isArray(shiftDetailData) &&
    (shiftDetailData.uuid || shiftDetailData.id)
      ? { ...selectedShift, ...shiftDetailData }
      : selectedShift;
  const isAdvanceInProgressLocked = ["in_progress", "partial_in_progress"].includes(
    resolveAdvanceDisplayStatus(advanceStatusSource)
  );

  const isEditingInvoicedShift =
    selectedShift !== null &&
    (parseBooleanVal(
      shiftDetailData?.meta?.is_locked ??
        shiftDetailData?.is_locked ??
        selectedShift?.meta?.is_locked ??
        selectedShift?.is_locked
    ) ||
      parseBooleanVal(
        shiftDetailData?.meta?.is_invoiced ??
          shiftDetailData?.is_invoiced ??
          selectedShift?.meta?.is_invoiced ??
          selectedShift?.is_invoiced
      ) ||
      parseBooleanVal(
        shiftDetailData?.meta?.is_timesheet_approved ??
          shiftDetailData?.is_timesheet_approved ??
          selectedShift?.meta?.is_timesheet_approved ??
          selectedShift?.is_timesheet_approved
      ));

  const invoicedShiftInvoiceNumbers = (() => {
    const numbers =
      shiftDetailData?.meta?.invoice_numbers ??
      shiftDetailData?.invoice_numbers ??
      selectedShift?.meta?.invoice_numbers ??
      selectedShift?.invoice_numbers ??
      [];
    return Array.isArray(numbers) ? numbers.filter(Boolean) : [];
  })();

  const renderInvoicedShiftNotice = () => {
    if (!isEditingInvoicedShift) return null;
    return (
      <div className='mb-2 overflow-hidden rounded-xl border border-violet-200 bg-gradient-to-r from-violet-50 via-purple-50/60 to-fuchsia-50 shadow-sm ring-1 ring-violet-100'>
        <div className='flex items-start gap-3 px-3 py-3'>
          <div className='flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-violet-100 text-violet-600 ring-1 ring-violet-200'>
            <FaFileInvoiceDollar className='h-4 w-4' aria-hidden />
          </div>
          <div className='min-w-0 flex-1'>
            <p className='text-sm font-semibold text-violet-900'>
              This shift can&apos;t be edited
            </p>
            <p className='mt-1 text-xs leading-relaxed text-violet-800/90'>
              A shift with an approved timesheet or a created invoice can&apos;t be
              edited. Unapprove the timesheet and/or void its invoice from{" "}
              <span className='font-semibold'>Invoicing</span> first — after that
              you&apos;ll be able to edit this shift.
            </p>
            {invoicedShiftInvoiceNumbers.length > 0 && (
              <p className='mt-1.5 text-xs font-medium text-violet-900'>
                Invoice{invoicedShiftInvoiceNumbers.length > 1 ? "s" : ""}:{" "}
                {invoicedShiftInvoiceNumbers.map((num, idx) => (
                  <span
                    key={`${num}-${idx}`}
                    className='mr-1 inline-flex items-center rounded-md border border-violet-200 bg-white px-1.5 py-0.5 font-semibold text-violet-700'
                  >
                    {num}
                  </span>
                ))}
              </p>
            )}
            <div className='mt-2.5 flex flex-wrap items-center gap-2'>
              <button
                type='button'
                onClick={() => navigate("/rostering/invoicing")}
                className='group inline-flex items-center gap-1.5 rounded-lg border border-violet-300 bg-white px-3 py-1.5 text-xs font-semibold text-violet-700 shadow-sm transition hover:border-violet-400 hover:bg-violet-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400/40'
              >
                <FaFileInvoiceDollar className='h-3.5 w-3.5' aria-hidden />
                Go to Invoicing to void invoice
                <HiOutlineArrowRight className='h-3.5 w-3.5 transition group-hover:translate-x-0.5' aria-hidden />
              </button>
              <button
                type='button'
                onClick={() => navigate("/rostering/timesheet")}
                className='group inline-flex items-center gap-1.5 rounded-lg border border-violet-300 bg-white px-3 py-1.5 text-xs font-semibold text-violet-700 shadow-sm transition hover:border-violet-400 hover:bg-violet-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400/40'
              >
                <HiOutlineClipboardList className='h-3.5 w-3.5' aria-hidden />
                Go to Timesheet to unapprove
                <HiOutlineArrowRight className='h-3.5 w-3.5 transition group-hover:translate-x-0.5' aria-hidden />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const createShiftPopupNew = () => {
    return (
      <div className='bg-slate-50/80 new-design-shift-form'>
        {watchFormData && (
          <div
            className={`flex min-w-0 flex-col gap-1.5 border-b border-slate-200/80 bg-white px-3 sm:flex-row sm:items-center sm:justify-between sm:gap-3 sm:px-4 ${
              isAdvanceMode ? "py-2.5" : "py-2"
            }`}
          >
            <WorkerShiftDetail
              userItem={
                calendarView === "worker-view"
                  ? getSelectedParticipant("pt_id")
                  : getSelectedOption("worker_id")
              }
              shiftDetail={watchFormData}
              isGroupShift={watchFormData?.is_group_shift}
              selectedShift={selectedShift}
              setIsSelectLocationOpen={setIsSelectLocationOpen}
              onClearLocation={handleClearLocation}
              onUseParticipantLocation={handleUseParticipantLocation}
              isLocationManuallySet={isLocationManuallySet}
              hasParticipant={
                isAdvanceMode
                  ? advanceShiftLocationContext.hasSource
                  : !!watchFormData?.pt_id
              }
              isAdvanceMode={isAdvanceMode}
            />
          </div>
        )}

        <form
          ref={shiftFormScrollRef}
          onSubmit={(e) => {
            e.preventDefault();
            submitShiftForm();
          }}
          onMouseDown={(e) => {
            // Prevent form submission when clicking on react-select controls.
            // Never block the options menu (portaled or in-tree) — that breaks
            // single worker/participant selection while group multi still works.
            if (
              e.target.closest('[class*="menu"]') ||
              e.target.closest(".worker-shift-select__menu")
            ) {
              return;
            }
            if (
              e.target.closest('[class*="css-"][class*="control"]') ||
              e.target.closest(".select-basic-single") ||
              e.target.closest(".roleSelector")
            ) {
              e.preventDefault();
            }
          }}
        >
          <div
            className={`flex min-w-0 flex-col xl:flex-row ${
              isAdvanceMode ? "gap-3 p-2" : "gap-2 p-2"
            }`}
          >
            {/* Main Content Area - Left Side */}
            <div className='min-w-0 w-full flex-1 space-y-2'>
              {renderInvoicedShiftNotice()}
              {isAdvanceModeEntering && !isAdvanceMode ? (
                <div className='rounded-xl bg-slate-100/50 p-1 sm:p-2'>
                  <AdvanceModeViewSkeleton />
                </div>
              ) : isAdvanceMode ? (
                <div className='rounded-xl bg-slate-100/50 p-1 sm:p-2'>
                    <Suspense fallback={<AdvanceModeViewSkeleton />}>
                      <AdvanceModeView
                        onExitAdvanceMode={handleAdvanceModeToggle}
                        advanceFormContext={advanceFormContext}
                        register={register}
                        setValue={setValue}
                        control={control}
                        watch={watch}
                        clearErrors={clearErrors}
                        trigger={trigger}
                        errors={errors}
                        selectedShift={selectedShift}
                        checkDisabilityOfShiftStatus={checkDisabilityOfShiftStatus}
                        isRecurringShiftReadOnly={isRecurringShiftReadOnly}
                        onShiftDateChange={handleShiftDateChange}
                        isShiftDateLocked={isAdvanceShiftDateChangeLocked(
                          advanceStatusSource,
                          { isInvoiced: isEditingInvoicedShift }
                        )}
                        clientSplitFields={advanceSplitsFields}
                        appendClientSplit={appendAdvanceSplit}
                        removeClientSplit={removeAdvanceSplit}
                        replaceClientSplits={replaceAdvanceSplits}
                        insertClientSplit={insertAdvanceSplit}
                        getValues={getValues}
                        carerFields={advanceCarerFields}
                        replaceCarers={replaceAdvanceCarers}
                        participantOptions={advanceModeParticipantOptions}
                        usePaginatedParticipantList={advanceUsePaginatedParticipantList}
                        participantOptionsLoading={
                          advanceHomeParticipantsLoading ||
                          (commonAnchor === "worker" && commonResourcesLoading)
                        }
                        participantSelectKey={advanceParticipantSelectKey}
                        workerOptions={advanceModeWorkerOptions}
                        groupedWorkerOptions={advanceModeGroupedWorkerOptions}
                        usePaginatedWorkerList={advanceUsePaginatedWorkerList}
                        useGroupedWorkerList={advanceUseGroupedWorkerList}
                        workerOptionsLoading={
                          (commonAnchor === "participant" &&
                            commonResourcesLoading) ||
                          advanceCommonNearbyWorkersLoading
                        }
                        workerSelectKey={advanceWorkerSelectKey}
                        serviceTypes={serviceTypes}
                        checkRunningShiftStatus={checkRunningShiftStatus}
                        shiftInstructions={shiftInstructions}
                        isShiftInstructionLoading={isShiftInstructionLoading}
                        editableInstructionIndex={editableInstructionIndex}
                        onAddShiftInstruction={handleAddShiftInstruction}
                        onShiftInstructionChange={handleShiftInstructionChange}
                        onRemoveShiftInstruction={handleRemoveShiftInstruction}
                        onHomeParticipantsChange={handleAdvanceHomeParticipantsChange}
                        onHomeParticipantsLoadingChange={setAdvanceHomeParticipantsLoading}
                        onHomeManagementDisabled={handleHomeManagementDisabled}
                        showApplyKmToInvoice={showApplyKmToInvoice}
                        kmCodeOptions={kmCodeOptions}
                        settingsDefaultKmCode={settingsDefaultKmCode}
                        showClaimTypeFromSettings={showClaimTypeFromSettings}
                        spRosteringSetting={spRosteringSetting}
                        showAdvanceValidationErrors={advanceValidationAttempted}
                        shiftOverlap={shiftOverlap}
                        allowShiftOverlapped={watchFormData?.shift_overlapped}
                        onLeave={isWorkerOnLeave}
                        onLeaveMessage={workerOnLeaveMessage}
                        canExitAdvanceMode={
                          // Create / draft can return to basic; saved advance shifts stay advance.
                          selectedShift === null ||
                          isAdvanceShiftDraft(selectedShift)
                        }
                        onCheckWorkerAvailability={handleWorkerAvailability}
                        getWorkerProfileLoader={getWorkerProfileLoader}
                        workerAvailabilityLoadingId={loadingItemId}
                        onRemovedOriginalWorkersChange={
                          handleRemovedOriginalWorkersChange
                        }
                        tasks={tasks}
                        shiftNotes={shiftNotes}
                        onTaskChange={handleTaskChange}
                        onTaskMandatoryChange={handleTaskMandatoryChange}
                        onTaskWorkerChange={handleTaskWorkerChange}
                        onAddTask={handleAddTask}
                        onTaskDelete={handleTaskDelete}
                      />
                    </Suspense>
                </div>
              ) : (
                <div className='rounded-xl bg-slate-100/50 p-1 sm:p-1.5'>
                  <BasicModeView
                    onEnterAdvanceMode={handleAdvanceModeToggle}
                    shiftOverlap={shiftOverlap}
                    allowShiftOverlapped={watchFormData?.shift_overlapped}
                    onCheckWorkerAvailability={handleWorkerAvailability}
                    getWorkerProfileLoader={getWorkerProfileLoader}
                    workerAvailabilityLoadingId={loadingItemId}
                    onLeave={isWorkerOnLeave}
                    onLeaveMessage={workerOnLeaveMessage}
                    isLessThan12Hours={isLessThan12Hours}
                    selectedWorker={selectedWorker}
                    watchFormData={watchFormData}
                    calendarView={calendarView}
                    selectedShift={selectedShift}
                    sortedWorkerOptions={sortedWorkerOptions}
                    register={register}
                    setValue={setValue}
                    getValues={getValues}
                    trigger={trigger}
                    control={control}
                    watch={watch}
                    getSelectedOption={getSelectedOption}
                    setSelectedOptions={setSelectedOptions}
                    selectedOptions={selectedOptions}
                    clearErrors={clearErrors}
                    errors={errors}
                    isCallFromAddShift={isShiftRequestApprovalFlow}
                    setIsWorkerLoaded={setIsWorkerLoaded}
                    isWorkerLoaded={isWorkerLoaded}
                    setWorkerOptionsSorted={setWorkerOptionsSorted}
                    setParticipantOptionsSorted={setParticipantOptionsSorted}
                    checkDisabilityOfShiftStatus={checkDisabilityOfShiftStatus}
                    onShiftDateChange={handleShiftDateChange}
                    isShiftDateLocked={
                      isEditingInvoicedShift ||
                      isAdvanceInProgressLocked ||
                      selectedShift?.progress === "started"
                    }
                    checkDisabliltyOfShiftForWorker={checkDisabliltyOfShiftForWorker}
                    checkRunningShiftStatus={checkRunningShiftStatus}
                    handleChangeWorkerOrParticipant={handleChangeWorkerOrParticipant}
                    userItem={userItem}
                    isFetchRecordDetailLoader={isFetchRecordDetailLoader}
                    setIsParticipantLoaded={setIsParticipantLoaded}
                    getSelectedParticipant={getSelectedParticipant}
                    createOrUpdateWorkerShiftLoader={createOrUpdateWorkerShiftLoader}
                    handleChangeServiceCategory={handleChangeServiceCategory}
                    participantOptions={participantOptions}
                    handleAddSplitShift={handleAddSplitShift}
                    disablDueToRecurringShift={disablDueToRecurringShift}
                    shiftDetailData={shiftDetailData}
                    setShouldCallHandleChangeWorkerOrParticipant={setShouldCallHandleChangeWorkerOrParticipant}
                    serviceTypeSelectedOptions={serviceTypeSelectedOptions}
                    isParticipantLoaded={isParticipantLoaded}
                    selectedParticipant={selectedParticipant}
                    isShiftSplit={isShiftSplit}
                    serviceTypes={serviceTypes}
                    selectedServiceCategory={selectedServiceCategory}
                    showServiceCategoryError={basicValidationAttempted}
                    spRosteringSetting={spRosteringSetting}
                    workerRatio={workerRatio}
                    participantRatio={participantRatio}
                    splitShifts={splitShifts}
                    handleRemoveSplitShift={handleRemoveSplitShift}
                    setIsLessThan12Hours={setIsLessThan12Hours}
                    tasks={tasks}
                    notes={notes}
                    handleTaskChange={handleTaskChange}
                    handleTaskMandatoryChange={handleTaskMandatoryChange}
                    handleAddTask={handleAddTask}
                    handleTaskDelete={handleTaskDelete}
                    handleNoteChange={handleNoteChange}
                    isShiftInstructionLoading={isShiftInstructionLoading}
                    shiftInstructions={shiftInstructions}
                    editableInstructionIndex={editableInstructionIndex}
                    handleShiftInstructionChange={handleShiftInstructionChange}
                    handleRemoveShiftInstruction={handleRemoveShiftInstruction}
                    handleAddShiftInstruction={handleAddShiftInstruction}
                    prefillFromShiftRequest={shiftRequestContext}
                    // spRosteringSetting={spRosteringSetting}
                  />
                </div>
              )}

            </div>
            {/* Quick Settings Sidebar - Right Side (sticky while form scrolls) */}
            <div
              className={`w-full shrink-0 xl:w-56 xl:sticky xl:top-2 xl:self-start xl:z-10 xl:max-h-[calc(100dvh-10rem)] xl:overflow-y-auto custom-scroll ${
                isAdvanceMode ? "space-y-3" : "space-y-2"
              }`}
            >
              {/* Quick Settings Card */}
              <div className='advance-mode-root'>
              <AdvanceModeSection>
                <AdvanceModeSectionHeader
                  theme='violet'
                  icon={HiAdjustments}
                  title='Quick settings'
                  bordered={false}
                  compact={!isAdvanceMode}
                  subtitle={isAdvanceMode ? "Shift options and restrictions" : undefined}
                />
                <AdvanceModeSectionBody
                  className='space-y-0 !pt-0'
                  compact={!isAdvanceMode}
                >
                  {/* Worker Tracking */}
                  <div className='flex items-center justify-between border-b border-slate-100 py-1.5'>
                    <label className='text-xs font-medium text-slate-700'>Worker Tracking</label>
                    <Controller
                      name='location_tracking'
                      control={control}
                      defaultValue={watchFormData?.location_tracking || true}
                      render={({ field }) => (
                        <SwitchWithIcon
                          onChange={(value) => {
                            field.onChange(value);
                            setValue("location_tracking", value);
                          }}
                          checked={field.value}
                          disabled={checkRunningShiftStatus(selectedShift?.status)}
                        />
                      )}
                    />
                  </div>
                  {/* Group Shift */}
                  {!isAdvanceMode && (
                  <div className='flex items-center justify-between border-b border-slate-100 py-1.5'>
                    <label className='text-xs font-medium text-slate-700'>Group Shift</label>
                    <SwitchWithIcon
                      additionalCheck={(e) => {
                        if (
                          calendarView === "participant-view" &&
                          e &&
                          (watchFormData?.pt_id === null ||
                            watchFormData?.pt_id === undefined ||
                            watchFormData?.pt_id === "")
                        ) {
                          dispatch(
                            showToast({
                              id: TOAST_IDS.GROUP_SHIFT_CANNOT_CREATED,
                              type: TOAST_TYPE.ERROR,
                              title: `Please Select ${participantLabel} First!`,
                            })
                          );
                          setValue("is_group_shift", false);
                          return false;
                        } else if (
                          calendarView === "worker-view" &&
                          e &&
                          (watchFormData?.worker_id === null ||
                            watchFormData?.worker_id === undefined ||
                            watchFormData?.worker_id === "")
                        ) {
                          dispatch(
                            showToast({
                              id: TOAST_IDS.GROUP_SHIFT_CANNOT_CREATED,
                              type: TOAST_TYPE.ERROR,
                              title: "Plase Select Worker First!",
                            })
                          );
                          setValue("is_group_shift", false);
                          return false;
                        }
                        return true;
                      }}
                      onChange={handleGroupShiftToggleChange}
                      checked={parseBooleanVal(watchFormData?.is_group_shift)}
                      disabled={
                        selectedShift &&
                        checkRunningShiftStatus(selectedShift?.status)
                      }
                    />
                  </div>
                  )}
                  {/* Open Shift/Open Group Shift */}
                  {!isAdvanceMode && calendarView === "participant-view" &&
                    watchFormData?.is_group_shift && (
                      <div className='flex items-center justify-between border-b border-slate-100 py-1.5'>
                        <label className='flex items-center gap-1 text-xs font-medium text-slate-700'>
                          Open Group Shift
                          <a data-tooltip-id='tooltip-open-shift'>
                            <FaQuestionCircle className='cursor-pointer text-xs text-slate-400' />
                          </a>
                          <Tooltip
                            id='tooltip-open-shift'
                            place='top'
                            content={getToolTipContentOpenShift()}
                            variant='dark'
                            className='!z-[10001]'
                          />
                        </label>
                        <Controller
                          name='open_shift'
                          control={control}
                          defaultValue={
                            shiftDetailData?.open_group_shift || false
                          }
                          render={({ field }) => (
                            <SwitchWithIcon
                              onChange={(value) => {
                                field.onChange(value);
                                setValue("open_shift", value);
                              }}
                              checked={field.value}
                            />
                          )}
                        />
                      </div>
                    )}
                  {!isAdvanceMode && calendarView === "participant-view" &&
                    !watchFormData?.is_group_shift && (
                      <div className='flex items-center justify-between border-b border-slate-100 py-1.5'>
                        <label className='flex items-center gap-1 text-xs font-medium text-slate-700'>
                          Open Shift
                          <a data-tooltip-id='tooltip-open-shift'>
                            <FaQuestionCircle className='cursor-pointer text-xs text-slate-400' />
                          </a>
                          <Tooltip
                            id='tooltip-open-shift'
                            place='top'
                            content={getToolTipContentOpenShift()}
                            variant='dark'
                            className='!z-[10001]'
                          />
                        </label>
                        <Controller
                          name='single_open_shift'
                          control={control}
                          defaultValue={false}
                          render={({ field }) => (
                            <SwitchWithIcon
                              onChange={(value) => {
                                field.onChange(value);
                                setValue("single_open_shift", value);
                                if (value) {
                                  setValue("worker_id", null);
                                  setShiftOverlap(null);
                                }
                              }}
                              checked={field.value}
                            />
                          )}
                        />
                      </div>
                    )}
                  {/* Participant's Signature */}
                  <div className='flex items-center justify-between border-b border-slate-100 py-2'>
                    <label className='text-xs font-medium text-slate-700'>{participantLabel}'s Signature</label>
                    <Controller
                      name='is_signature'
                      control={control}
                      defaultValue={watchFormData?.is_signature || false}
                      render={({ field }) => (
                        <SwitchWithIcon
                          onChange={(value) => {
                            field.onChange(value);
                            setValue("is_signature", value);
                          }}
                          checked={field.value}
                          disabled={checkRunningShiftStatus(selectedShift?.status)}
                        />
                      )}
                    />
                  </div>
                  {/* Enforce Distance Restriction */}
                  <div className='flex items-center justify-between border-b border-slate-100 py-1.5'>
                    <label className='text-xs font-medium text-slate-700'>Enforce Distance Restriction</label>
                    <Controller
                      name='is_radius'
                      control={control}
                      defaultValue={watchFormData?.is_radius || true}
                      render={({ field }) => (
                        <SwitchWithIcon
                          onChange={(value) => {
                            field.onChange(value);
                            setValue("is_radius", value);
                          }}
                          checked={field.value}
                          disabled={checkRunningShiftStatus(selectedShift?.status)}
                        />
                      )}
                    />
                  </div>
                  {!isAdvanceMode && (
                    <div className='flex items-center justify-between border-b border-slate-100 py-1.5'>
                      <label className='text-xs font-medium text-slate-700'>
                        Shift Acceptance Required
                      </label>
                      <Controller
                        name='shift_accept'
                        control={control}
                        defaultValue={parseBooleanVal(
                          watchFormData?.shift_accept ??
                            spRosteringSetting?.shift_acceptance_required
                        )}
                        render={({ field }) => (
                          <SwitchWithIcon
                            onChange={(value) => {
                              field.onChange(value);
                              setValue("shift_accept", value);
                            }}
                            checked={parseBooleanVal(field.value)}
                            disabled={checkRunningShiftStatus(
                              selectedShift?.status
                            )}
                          />
                        )}
                      />
                    </div>
                  )}
                  {/* Allow Shift Overlapping */}
                  <div className='flex items-center justify-between border-b border-slate-100 py-1.5'>
                    <label className='text-xs font-medium text-slate-700'>Allow Shift Overlapping</label>
                    <Controller
                      name='shift_overlapped'
                      control={control}
                      defaultValue={watchFormData?.shift_overlapped || false}
                      render={({ field }) => (
                        <SwitchWithIcon
                          onChange={(value) => {
                            field.onChange(value);
                            setValue("shift_overlapped", value);
                          }}
                          checked={field.value}
                          disabled={checkRunningShiftStatus(selectedShift?.status)}
                        />
                      )}
                    />
                  </div>
                  {/* Sleepover Shift */}
                  <div
                    className={`flex items-center justify-between py-1.5 ${
                      isAdvanceMode ? "border-b border-slate-100" : ""
                    }`}
                  >
                    <label
                      className='text-xs font-medium text-slate-700'
                      title='select this option if sleepover shift'
                    >
                      Sleepover Shift
                    </label>
                    <Controller
                      name='sleepover'
                      control={control}
                      defaultValue={watchFormData?.sleepover || false}
                      render={({ field }) => (
                        <SwitchWithIcon
                          onChange={(value) => {
                            field.onChange(value);
                            setValue("sleepover", value);
                          }}
                          checked={field.value}
                          disabled={checkRunningShiftStatus(selectedShift?.status)}
                        />
                      )}
                    />
                  </div>
                  {false && (
                    <div className='flex items-center justify-between border-b border-slate-100 py-1.5'>
                      <label
                        className='text-xs font-medium text-slate-700'
                        title='Short Term Accommodation (STA) shift'
                      >
                        STA
                      </label>
                      <Controller
                        name='sta'
                        control={control}
                        defaultValue={watchFormData?.sta || false}
                        render={({ field }) => (
                          <SwitchWithIcon
                            onChange={(value) => {
                              field.onChange(value);
                              handleAdvanceStaMasterChange(value);
                            }}
                            checked={!!field.value}
                            disabled={checkRunningShiftStatus(selectedShift?.status)}
                          />
                        )}
                      />
                    </div>
                  )}
                </AdvanceModeSectionBody>
              </AdvanceModeSection>
              </div>

              {/* Recurring Shift Card */}
              {(selectedShift !== null && shiftDetailData?.recurring_interval !== null) ||
              (!isDateInPast(watchFormData?.shift_date) && selectedShift === null) ? (
                <div className='advance-mode-root' ref={modalContentRef}>
                <AdvanceModeSection>
                  <AdvanceModeSectionHeader
                    theme='violet'
                    icon={HiRefresh}
                    title='Recurring shift'
                    subtitle='Repeat this shift on a schedule'
                    bordered={false}
                    action={
                      <Controller
                        name={`is_recurring`}
                        control={control}
                        defaultValue={watchFormData?.is_recurring || false}
                        render={({ field }) => (
                          <SwitchWithIcon
                            onChange={(value) => {
                              field.onChange(value);
                              setValue(`is_recurring`, value);
                              setRecurringType(null);
                              setRecurrInterval(null);
                            }}
                            checked={field.value}
                            disabled={selectedShift !== null}
                          />
                        )}
                      />
                    }
                  />
                  {watchFormData?.is_recurring && (
                    <AdvanceModeSectionBody className='border-t border-slate-100/90 pt-3'>
                      <RecurringShift
                        setRecurringType={setRecurringType}
                        recurringType={recurringType}
                        watchFormData={watchFormData}
                        setRecurrInterval={setRecurrInterval}
                        recurrInterval={recurrInterval}
                        setRecurringDates={setRecurringDates}
                        setSelectedDays={setSelectedDays}
                        selectedDays={selectedDays}
                        selectedShift={selectedShift}
                        setRecurringFor={setRecurringFor}
                        recurringFor={recurringFor}
                        handleIntervalChange={handleIntervalChange}
                        shiftDetailData={shiftDetailData}
                      />
                    </AdvanceModeSectionBody>
                  )}
                </AdvanceModeSection>
                </div>
              ) : null}
            </div>
          </div>
          <div className='hidden'>
            <button
              id='createShiftButton'
              type='submit'
              className='hidden sr-only'
            />
          </div>
        </form>
      </div>
    );
  };

  const shiftRequestInReviewRequiresWorker =
    String(shiftRequestContext?.status || "").toLowerCase() === "in_review";

  const isShiftRequestInReviewWorkerMissing = () => {
    if (!shiftRequestInReviewRequiresWorker) {
      return false;
    }
    const workerId = watchFormData?.worker_id;
    if (workerId == null || workerId === "") {
      return true;
    }
    if (Array.isArray(workerId) && workerId.length === 0) {
      return true;
    }
    return false;
  };

  const createAndPublishFnCheck = () => {
  

    if (
      watchFormData?.shift_date === undefined ||
      watchFormData?.shift_date === null ||
      !watchFormData?.shift_date
    ) {
      return true;
    }
    const participantTimezone = selectedParticipant?.timezone;
    const today = moment().startOf("day");
    const shiftDate = moment(watchFormData?.shift_date).startOf("day");
    const isToday = today.isSame(shiftDate, "day");

    if (isToday) {
      const now = participantTimezone
        ? momentTimeZone.tz(new Date(), participantTimezone)
        : momentTimeZone();

      const shiftStartString = `${watchFormData?.shift_date} ${watchFormData?.start_time}`;
      const shiftStartTime = participantTimezone
        ? momentTimeZone.tz(
            shiftStartString,
            "YYYY-MM-DD hh:mm A",
            participantTimezone
          )
        : momentTimeZone(shiftStartString, "YYYY-MM-DD hh:mm A");

      if (!shiftStartTime.isBefore(now)) {
        return false || parseBooleanVal(watchFormData?.is_recurring);
      }
    }

    return (
      today.isAfter(watchFormData?.shift_date) ||
      parseBooleanVal(watchFormData?.is_recurring) ||
      !today.isBefore(watchFormData?.shift_date)
    );
  };

  const updateAndPublishFnCheck = () => {
    const today = moment().startOf("day");
    const statusArray = [
      SHIFT_STATUS.ACCEPTED,
      SHIFT_STATUS.APPROVED,
      SHIFT_STATUS.EXPIRED,
    ];
    return (
      parseBooleanVal(watchFormData?.is_recurring) ||
      statusArray.includes(selectedShift.status) ||
      today.isAfter(watchFormData?.shift_date)
    );
  };

  /** Panel to land on when the exact invalid field can't be found in the DOM. */
  const getAdvanceFallbackSelector = (fieldPaths = []) => {
    const firstInvalid = getFirstInvalidFieldPath(
      getFieldState,
      formState,
      fieldPaths
    );

    if (!firstInvalid || firstInvalid.startsWith("advance_carers")) {
      return "[data-advance-worker-section]";
    }
    if (
      firstInvalid.startsWith("advance_splits") ||
      firstInvalid.startsWith("advance_selected_participants")
    ) {
      return `#${ADVANCE_MODE_SECTION_IDS.participants}`;
    }
    return `#${ADVANCE_MODE_SECTION_IDS.schedule}`;
  };

  const scrollShiftFormToFirstError = useCallback(
    (submitErrors, orderedFieldPaths = [], fallbackSelector = null) => {
      window.setTimeout(() => {
        scrollToFirstFormError({
          container: shiftFormScrollRef.current,
          errors: submitErrors,
          orderedFieldPaths,
          fallbackSelector,
        });
      }, 0);
    },
    []
  );

  const executeSubmit = async (isPublish = null, submitOptions = {}) => {
    const publishArg = isPublish === "isPublish" ? "isPublish" : isPublish;
    const advanceModeActive =
      submitOptions.advanceMode ?? isAdvanceModeRef.current;
    if (advanceModeActive && isAdvanceInProgressLocked) {
      return;
    }
    if (advanceModeActive) {
      // Hard-stop Advance create/update when check-overlapping reports on_leave.
      if (Boolean(onLeave) || shiftOverlap?.status === "on_leave") {
        toast.warning(
          onLeaveMessage ||
            shiftOverlap?.message ||
            "Selected worker is unavailable on this date due to leave.",
          {
            toastId: "advanceModeWorkerOnLeave",
            autoClose: 6000,
          }
        );
        window.setTimeout(() => {
          const workerSection = shiftFormScrollRef.current?.querySelector(
            "[data-advance-worker-section]"
          );
          if (workerSection) {
            scrollElementIntoView(
              workerSection,
              shiftFormScrollRef.current
            );
          }
        }, 0);
        return;
      }

      clearErrors([
        "pt_id",
        "worker_id",
        "is_group_shift",
        "open_shift",
        "single_open_shift",
      ]);
      setAdvanceValidationAttempted(true);
      const fieldsToValidate = getAdvanceModeValidationFieldPaths(getValues());
      const isValid = await trigger(fieldsToValidate);
      if (!isValid) {
        window.setTimeout(() => {
          scrollToFirstInvalidField({
            container: shiftFormScrollRef.current,
            fieldPaths: fieldsToValidate,
            getFieldState,
            formState,
            fallbackSelector: getAdvanceFallbackSelector(fieldsToValidate),
          });
        }, 0);
        return;
      }

      const workerOrOpenShiftCheck = validateAdvanceWorkerOrOpenShift(getValues());
      if (workerOrOpenShiftCheck !== true) {
        toast.warning(workerOrOpenShiftCheck, {
          toastId: "advanceModeNoWorkerOpenShift",
          autoClose: 6000,
        });
        window.setTimeout(() => {
          const workerSection = shiftFormScrollRef.current?.querySelector(
            "[data-advance-worker-section]"
          );
          if (workerSection) {
            scrollElementIntoView(
              workerSection,
              shiftFormScrollRef.current
            );
          }
        }, 0);
        return;
      }

      const workerShiftCoverageCheck =
        validateAdvanceWorkerShiftWindowCoverage(getValues());
      if (workerShiftCoverageCheck !== true) {
        toast.warning(workerShiftCoverageCheck, {
          toastId: "advanceModeWorkerShiftCoverage",
          autoClose: 6000,
        });
        window.setTimeout(() => {
          const workerSection = shiftFormScrollRef.current?.querySelector(
            "[data-advance-worker-section]"
          );
          if (workerSection) {
            scrollElementIntoView(
              workerSection,
              shiftFormScrollRef.current
            );
          }
        }, 0);
        return;
      }

      // Updating an existing advance shift after removing original workers —
      // confirm timesheet removal first (same message as the red warning banner).
      if (
        !submitOptions.skipRemovedWorkerConfirm &&
        selectedShift !== null &&
        !isAdvanceShiftDraft(selectedShift) &&
        removedOriginalWorkers.length > 0
      ) {
        pendingSubmitRef.current = {
          publish: publishArg,
          advanceMode: true,
        };
        setIsRemoveWorkerTimesheetConfirm(true);
        return;
      }

      // Past-date confirm only after required-field validation passes.
      const advanceShiftDate =
        getValues("shift_date") || watchFormData?.shift_date;
      if (
        !submitOptions.skipPastConfirm &&
        shouldConfirmPastShiftDate(advanceShiftDate)
      ) {
        pendingSubmitRef.current = {
          publish: publishArg,
          advanceMode: true,
        };
        setIsPastShift(true);
        return;
      }

      onSubmit(getValues(), publishArg, { advanceMode: true });
      return;
    }

    // Hard-gate Service Category (does not rely on Select/RHF mount).
    setBasicValidationAttempted(true);
    const formValues = getValues();
    const missingServiceCategoryPaths = getMissingBasicServiceCategoryPaths(
      formValues,
      { isShiftSplit }
    );
    if (missingServiceCategoryPaths.length > 0) {
      missingServiceCategoryPaths.forEach((path) => {
        setError(path, {
          type: "required",
          message: BASIC_FIELD_REQUIRED_MSG,
        });
      });
      // Under-field validation on the Service Category dropdown is enough — no toast.
      window.setTimeout(() => {
        scrollToFirstInvalidField({
          container: shiftFormScrollRef.current,
          fieldPaths: missingServiceCategoryPaths,
          getFieldState,
          formState,
          fallbackSelector: isShiftSplit
            ? "#basic-mode-section-schedule"
            : "#basic-mode-section-service",
        });
      }, 0);
      return;
    }
    clearErrors("invoice_service_type_id");

    // Split mode: parent Service Category Select is unmounted but RHF may keep
    // required rules — that blocked Create with no visible error until splits
    // were removed. Drop parent invoice fields from validation in split mode.
    if (isShiftSplit && (formValues.splitShifts || []).length > 0) {
      clearErrors(["invoice_service_type_id", "invoice_item_id"]);
      unregister(["invoice_service_type_id", "invoice_item_id"]);
    }

    const fieldsToValidate = getBasicModeValidationFieldOrder(formValues, {
      isShiftSplit,
    });
    const isValid = await trigger(fieldsToValidate);
    if (!isValid) {
      window.setTimeout(() => {
        scrollToFirstInvalidField({
          container: shiftFormScrollRef.current,
          fieldPaths: fieldsToValidate,
          getFieldState,
          formState,
          fallbackSelector: isShiftSplit
            ? "#basic-mode-section-schedule"
            : "#basic-mode-section-service",
        });
      }, 0);
      return;
    }

    // Still run handleSubmit so any other registered rules remain enforced.
    // Past-date confirm runs only inside the success path (after all RHF rules).
    handleSubmit(
      (data) => {
        if (
          !submitOptions.skipPastConfirm &&
          shouldConfirmPastShiftDate(
            data?.shift_date || watchFormData?.shift_date
          )
        ) {
          pendingSubmitRef.current = {
            publish: publishArg,
            advanceMode: false,
          };
          setIsPastShift(true);
          return;
        }
        onSubmit(data, publishArg, { advanceMode: false });
      },
      (submitErrors) => {
        scrollShiftFormToFirstError(submitErrors, fieldsToValidate);
      }
    )();
  };

  const submitShiftForm = (isPublish = null) => {
    // Block create/publish while draft resume (or V5 details) APIs are in flight.
    if (shiftDetailLoader || advanceShiftDetailsLoading) return;

    const publishArg = isPublish === "isPublish" ? "isPublish" : isPublish;

    // Required-field validation always runs first; past confirm is inside executeSubmit.
    executeSubmit(publishArg);
  };

  const saveAdvanceShiftAsDraft = async () => {
    if (
      isUserGracePeriodOver ||
      draftSaving ||
      shiftDetailLoader ||
      advanceShiftDetailsLoading
    ) {
      return;
    }

    const formValues = getValues();
    const shiftDateRaw =
      formValues?.shift_date || watchFormData?.shift_date || selectedDate;
    if (!shiftDateRaw) {
      toast.warning("Shift date is required to save a draft.", {
        toastId: "advanceDraftNeedsDate",
      });
      return;
    }

    const draftPayload = buildAdvanceShiftDraftPayload({
      watchFormData: { ...watchFormData, ...formValues },
      advanceSplits:
        formValues?.advance_splits || watchFormData?.advance_splits || [],
      advanceCarers:
        formValues?.advance_carers || watchFormData?.advance_carers || [],
      shiftLocation,
      participantOptions: advanceModeParticipantOptions,
      workerOptions: advanceModeWorkerOptions,
      notes,
      tasks,
      shiftInstructions,
      timezone: momentTimeZone.tz.guess(),
    });

    setDraftSaving(true);
    try {
      const draftUuid =
        activeDraftUuid ||
        (isAdvanceShiftDraft(selectedShift) ? selectedShift?.uuid : null);

      let response;
      if (draftUuid) {
        response = await rosteringApi.updateAdvanceShiftDraft({
          uuid: draftUuid,
          ...draftPayload,
        });
      } else {
        response = await rosteringApi.createAdvanceShiftDraft(draftPayload);
      }

      const saved = unwrapAdvanceDraftResponse(response);
      const savedUuid = saved?.uuid || saved?.draft?.uuid || draftUuid;
      if (savedUuid) {
        setActiveDraftUuid(savedUuid);
      }

      // Keep the advance builder open — upsert draft into schedule state only
      // (no modal close, no full calendar refresh).
      const workerIds = (draftPayload.workers || [])
        .map((w) => w?.worker_id)
        .filter((id) => id != null)
        .map(Number);
      const scheduleDraft = {
        id: saved?.id,
        uuid: savedUuid,
        is_draft: true,
        status: saved?.status || "draft",
        shift_date:
          saved?.shift_date ||
          draftPayload.shift_date ||
          moment(shiftDateRaw).format("YYYY-MM-DD"),
        start_time: saved?.start_time || draftPayload.start_time || null,
        end_time: saved?.end_time || draftPayload.end_time || null,
        summary: saved?.summary || null,
        participant_ids: (draftPayload.participant_ids || []).map(Number),
        worker_ids: [...new Set(workerIds)],
        created_at: saved?.created_at,
        updated_at: saved?.updated_at,
      };
      dispatch(advanceShiftDraftUpsertLocally({ draft: scheduleDraft }));

      toast.success(draftUuid ? "Draft updated." : "Draft saved.");
      handleClose();
    } catch (err) {
      toast.error(err?.message || "Could not save draft.");
    } finally {
      setDraftSaving(false);
    }
  };

  const isAdvanceDraftSession =
    Boolean(activeDraftUuid) || isAdvanceShiftDraft(selectedShift);

  // Draft resume / V5 details in flight — footer is usually hidden, but keep
  // buttons disabled as a belt-and-suspenders guard against race unlocks.
  const isShiftDetailsHydrating =
    shiftDetailLoader || advanceShiftDetailsLoading;

  const modalFooter = () => (
    <>
      {handleShiftUpdatePermissionParticipantView() && (
        <p className='text-sm text-red-400 flex'>
          {" "}
          <FaExclamationCircle className='text-red-500 mr-1 h-5 w-5' /> Group
          shifts for multiple participants can only be updated from worker view.
          Please switch to worker view to make changes.
        </p>
      )}
      {isAdvanceMode &&
        (selectedShift === null || isAdvanceDraftSession) && (
          <CustomButton
            variant='tertiary'
            Icon={<HiOutlineDocumentAdd className='h-4 w-4' />}
            cssClass='!border-sky-500 !bg-sky-600 !text-white shadow-sm hover:!bg-sky-700 hover:!border-sky-600 hover:shadow-md focus:!ring-sky-400 transition-all duration-200'
            clickHandler={() => {
              if (isUserGracePeriodOver || isShiftDetailsHydrating) return;
              saveAdvanceShiftAsDraft();
            }}
            showLoading={draftSaving || isShiftDetailsHydrating}
            isDisabled={
              draftSaving ||
              isShiftDetailsHydrating ||
              createOrUpdateWorkerShiftLoader ||
              isUserGracePeriodOver ||
              !watchFormData?.shift_date
            }
            label={
              isAdvanceDraftSession ? "Update draft" : "Save as draft"
            }
          />
        )}
      {(selectedShift === null || isAdvanceDraftSession) && (
        <CustomButton
          clickHandler={() => {
            if (isUserGracePeriodOver || isShiftDetailsHydrating) {
              return;
            }
            if (checkRunningShiftStatus(selectedShift?.status)) {
              return;
            }
            const buttonRef = document.getElementById("createShiftButton");
            if (buttonRef) {
              submitShiftForm("isPublish");
            }
          }}
          isDisabled={
            isShiftDetailsHydrating ||
            createOrUpdateWorkerShiftLoader ||
            (!isAdvanceMode && loading) ||
            checkRunningShiftStatus(selectedShift?.status) ||
            isUserGracePeriodOver ||
            (shiftOverlap?.overlapping_shift &&
              shiftOverlap?.overlapping_shift[0]?.overlapped &&
              !watchFormData?.shift_overlapped) ||
            handleShiftUpdatePermissionParticipantView() ||
            createAndPublishFnCheck() ||
            isWorkerOnLeave ||
            isShiftRequestInReviewWorkerMissing() ||
            draftSaving
          }
          label={"Create and Publish"}
        />
      )}

      {selectedShift !== null &&
        selectedShift?.uuid &&
        !isAdvanceDraftSession && (
        <div className='flex items-center gap-3'>
          <CustomButton
            clickHandler={() => {
              if (isUserGracePeriodOver || isShiftDetailsHydrating) {
                return;
              }
              if (checkRunningShiftStatus(selectedShift?.status)) {
                return;
              }
              if (isAdvanceInProgressLocked) {
                return;
              }
              const buttonRef = document.getElementById("createShiftButton");
              if (buttonRef) {
                submitShiftForm("isPublish");
              }
            }}
            isDisabled={
              isShiftDetailsHydrating ||
              createOrUpdateWorkerShiftLoader ||
              (!isAdvanceMode && loading) ||
              checkRunningShiftStatus(selectedShift?.status) ||
              isUserGracePeriodOver ||
              (shiftOverlap?.overlapping_shift &&
                shiftOverlap?.overlapping_shift[0]?.overlapped &&
                !watchFormData?.shift_overlapped) ||
              handleShiftUpdatePermissionParticipantView() ||
              updateAndPublishFnCheck() ||
              isEditingInvoicedShift ||
              isAdvanceInProgressLocked ||
              isWorkerOnLeave ||
              isShiftRequestInReviewWorkerMissing()
            }
            label={"Update and Publish"}
          />
        </div>
      )}
      <CustomButton
        clickHandler={() => {
          if (isUserGracePeriodOver || isShiftDetailsHydrating) {
            return;
          }
          if (checkRunningShiftStatus(selectedShift?.status)) {
            return;
          }
          if (isAdvanceInProgressLocked) {
            return;
          }

          submitShiftForm();
        }}
        showLoading={
          loading || createOrUpdateWorkerShiftLoader || isShiftDetailsHydrating
        }
        isDisabled={
          isShiftDetailsHydrating ||
          createOrUpdateWorkerShiftLoader ||
          (!isAdvanceMode && loading) ||
          checkRunningShiftStatus(selectedShift?.status) ||
          isUserGracePeriodOver ||
          (shiftOverlap?.overlapping_shift &&
            shiftOverlap?.overlapping_shift[0]?.overlapped &&
            !watchFormData?.shift_overlapped) ||
          handleShiftUpdatePermissionParticipantView() ||
          isEditingInvoicedShift ||
          isAdvanceInProgressLocked ||
          isWorkerOnLeave ||
          draftSaving
        }
        label={`${
          selectedShift !== null && !isAdvanceDraftSession ? "Update" : "Create"
        }`}
      />
    </>
  );

  const getRefereshedShiftdate = () => {
    if (watchFormData?.shift_date) {
      return moment(watchFormData.shift_date, "YYYY-MM-DD").format(
        "dddd, Do MMM YYYY"
      );
    }
    if (selectedDate) {
      return moment(selectedDate, "YYYY-MM-DD").format("dddd, Do MMM YYYY");
    }
    if (selectedShift?.shift_date) {
      return moment(selectedShift.shift_date, "YYYY-MM-DD").format(
        "dddd, Do MMM YYYY"
      );
    }
    return moment().format("dddd, Do MMM YYYY");
  };

  useEffect(() => {
    if (spRosteringSetting) {
      setValue(
        "is_signature",
        parseBooleanVal(spRosteringSetting?.participant_signature)
      );
      setValue(
        "location_tracking",
        parseBooleanVal(spRosteringSetting?.worker_tracking)
      );
      setValue("is_radius", parseBooleanVal(spRosteringSetting?.is_radius));
    }
  }, [spRosteringSetting]);

  useEffect(() => {
    if (!spRosteringSetting || selectedShift) return;
    setValue(
      "shift_accept",
      parseBooleanVal(spRosteringSetting?.shift_acceptance_required)
    );
  }, [spRosteringSetting, selectedShift, setValue]);

  if (spRosteringSettingLoader) {
    return (
      <div
        className={`flex flex-col w-full min-h-screen bg-gray-50 items-center justify-center`}
      >
        <CircularLoader
          classes='flex justify-center items-center'
          classloader='loader-l'
        />
      </div>
    );
  }



  return (
    <div>
      {isShow && (
        <WorkerShiftModal
          fullScreen={
            isAdvanceMode ||
            isAdvanceModeEntering ||
            advanceShiftDetailsLoading
          }
          title={
            watchFormData?.shift_date
              ? `${
                  selectedShift === null || isAdvanceDraftSession ? "New " : ""
                }${isAdvanceDraftSession ? "Draft " : ""}Shift On ${
                  (() => {
                        const nextDay = isCheckNextDayShift(
                          watchFormData?.shift_date,
                          watchFormData?.start_time,
                          watchFormData?.end_time
                        );
                        const hasNextDay =
                          nextDay !== false ||
                          isBasicSameClockTimeFullDay(
                            watchFormData?.start_time,
                            watchFormData?.end_time
                          );
                        const base = getRefereshedShiftdate();
                        if (hasNextDay) {
                          // Calculate end date directly from shift_date to avoid timezone parsing issues
                          const shiftDate = moment(watchFormData?.shift_date).startOf('day');
                          // Parse time in both 12-hour (hh:mm A) and 24-hour (HH:mm) formats
                          const parseFormats = ["HH:mm", "hh:mm A", "h:mm A"];
                          const endTimeMoment = moment(watchFormData?.end_time, parseFormats, true);
                          if (endTimeMoment.isValid()) {
                            const endDate = shiftDate.clone()
                              .hours(endTimeMoment.hours())
                              .minutes(endTimeMoment.minutes())
                              .add(1, 'day');
                            return `${base} - ${endDate.format("dddd, Do MMM YYYY")}`;
                          }
                          // Fallback: try simple parsing if moment parsing fails
                          const timeParts = watchFormData?.end_time?.match(/(\d+):(\d+)\s*(AM|PM)?/i);
                          if (timeParts) {
                            let hours = parseInt(timeParts[1]);
                            const minutes = parseInt(timeParts[2]);
                            const period = timeParts[3]?.toUpperCase();
                            if (period === 'PM' && hours !== 12) hours += 12;
                            if (period === 'AM' && hours === 12) hours = 0;
                            const endDate = shiftDate.clone().hours(hours).minutes(minutes).add(1, 'day');
                            return `${base} - ${endDate.format("dddd, Do MMM YYYY")}`;
                          }
                        }
                        return base;
                      })()
                }`
              : ""
          }
          isOpen={isShow}
          cssClass={
            isAdvanceMode ||
            isAdvanceModeEntering ||
            advanceShiftDetailsLoading
              ? ""
              : "w-[70%]"
          }
          bodyPadding='px-0'
          closeModal={() => {
            // setCreateShift(false);
            if (advanceModeEnterTimerRef.current) {
              window.clearTimeout(advanceModeEnterTimerRef.current);
              advanceModeEnterTimerRef.current = null;
            }
            handleClose();
            setIsFetchRecordDetailLoader(false);
            setIsAdvanceMode(false);
            setIsAdvanceModeEntering(false);
            isAdvanceModeRef.current = false;
            advanceAppliedTaskPtIdsRef.current = [];
            advanceSkipInitialTaskHydrateRef.current = false;
            advanceEditTaskLockRef.current = false;
            setAdvanceValidationAttempted(false);
            setBasicValidationAttempted(false);
            pendingSubmitRef.current = null;
            setShiftNotes([]);
            setAdvanceShiftDetailsLoading(false);
            reset();
            // Reset location when closing modal
            setShiftLocation({
              street: "",
              suburb: "",
              state: null,
              postcode: "",
              state_name: "",
              lat: null,
              lng: null,
            });
          }}
          modalFooter={
            shiftDetailLoader || advanceShiftDetailsLoading
              ? null
              : modalFooter()
          }
        >
          {advanceShiftDetailsLoading ? (
            <AdvanceModeUpdateSkeleton />
          ) : shiftDetailLoader ? (
            isAdvanceMode ||
            isAdvanceModeEntering ||
            isAdvanceShiftDraft(selectedShift) ? (
              <AdvanceModeUpdateSkeleton />
            ) : (
              <div
                className={`${
                  isAdvanceMode ? "flex h-full min-h-[50vh]" : "min-h-screen"
                } bg-gray-50 items-center justify-center`}
              >
                <CircularLoader
                  classes='flex justify-center items-center'
                  classloader='loader-l'
                />
              </div>
            )
          ) : (
            createShiftPopupNew()
          )}
        </WorkerShiftModal>
      )}

      {openModal && workerProfileDetails && !getWorkerProfileLoader && (
        <WorkerAvailabiltyModal
          isUserGracePeriodOver={isUserGracePeriodOver}
          openModel={openModal}
          handleClose={setOpenModal}
          WorkerId={workerProfileUUID}
          setRefreshPageForWorkerTimeSlot={setRecheckAvailability}
          TimeSlots={workerAvailabilityData}
          workerProfileDetails={workerProfileDetails}
          isWorkerAvailablity={recheckAvailability}
          // Advance mode renders the shift form full-screen at z-[99999]; lift the
          // availability modal above it so it isn't hidden behind the panel.
          overlayZIndex={
            isAdvanceMode || isAdvanceModeEntering ? 100000 : undefined
          }
        />
      )}

      {showUpdateShiftRecurringModal && (
        <UpdateRecurringShiftsModal
          isOpen={showUpdateShiftRecurringModal}
          content={null}
          title='Update Recurring Shift(s)'
          setIsConfirm={setUpdateShiftRecurringModal}
          shiftData={selectedShift}
          refreshCalendar={refreshCalendar}
          watch={watch}
          control={control}
          watchFormData={watchFormData}
          setValue={setValue}
          recurringUpdateShiftData={recurringUpdateShiftData}
          createOrUpdateWorkerShiftRequest={createOrUpdateWorkerShiftRequest}
          elevatedZIndex={isAdvanceMode || isAdvanceModeRef.current}
        />
      )}

      {showPastRecurringUpdateConfirm && (
        <SweetAlertConfirmationModal
          onlyOkBtn={["Cancel", "Proceed"]}
          isOpen={showPastRecurringUpdateConfirm}
          elevatedZIndex={isAdvanceMode || isAdvanceModeRef.current}
          title='Update Past Recurring Shift'
          content={`Are you sure you want to update this past recurring shift? Changes will apply only to this shift and will not affect other shifts in the series.`}
          setIsConfirm={(confirmed) => {
            setShowPastRecurringUpdateConfirm(false);
            if (!confirmed) {
              setRecurringUpdateShiftData(null);
              return;
            }
            const request = recurringUpdateShiftData;
            if (!request) return;
            if (request.isAdvanceShift) {
              setISInitialCreateShiftLoader(LOADER_STATUS.PENDING);
            }
            createOrUpdateWorkerShiftRequest(request, () => {
              refreshShiftStats();
            });
            if (request.isAdvanceShift) {
              setTimeout(() => {
                refreshShiftStats();
              }, 2000);
            }
          }}
        />
      )}

      <AdvanceModeRemoveWorkerConfirmModal
        isOpen={isRemoveWorkerTimesheetConfirm}
        workers={removedOriginalWorkers.map((worker) => ({
          name: getWorkerDisplayName(worker),
        }))}
        onCancel={() => {
          setIsRemoveWorkerTimesheetConfirm(false);
          pendingSubmitRef.current = null;
        }}
        onConfirm={() => {
          setIsRemoveWorkerTimesheetConfirm(false);
          const pending = pendingSubmitRef.current;
          pendingSubmitRef.current = null;
          const publishArg =
            pending && typeof pending === "object" && "publish" in pending
              ? pending.publish
              : pending;
          executeSubmit(publishArg, {
            advanceMode: true,
            skipRemovedWorkerConfirm: true,
          });
        }}
      />

      {isPastShift && (
        <SweetAlertConfirmationModal
          onlyOkBtn={["Cancel", "Proceed"]}
          isOpen={isPastShift}
          elevatedZIndex={isAdvanceMode || isAdvanceModeRef.current}
          // dangerMode={true}
          title='Shift added in the past'
          content={`The selected shift date is in the past. Please confirm if you would like to proceed. Note that past shifts are automatically accepted, and a corresponding timesheet will be generated.`}
          setIsConfirm={(e) => {
            setIsPastShift(false);
            if (e) {
              const pending = pendingSubmitRef.current;
              pendingSubmitRef.current = null;
              const publishArg =
                pending && typeof pending === "object" && "publish" in pending
                  ? pending.publish
                  : pending;
              const advanceMode =
                pending && typeof pending === "object" && "advanceMode" in pending
                  ? pending.advanceMode
                  : isAdvanceModeRef.current;
              // Skip past confirm — user already proceeded; re-run same validation+submit path.
              executeSubmit(publishArg, {
                advanceMode,
                skipPastConfirm: true,
              });
            } else {
              pendingSubmitRef.current = null;
            }
          }}
        />
      )}

      {isShowEndShiftWarning && (
        <SweetAlertConfirmationModal
          onlyOkBtn={["Cancel", "Proceed"]}
          isOpen={isShowEndShiftWarning}
          // dangerMode={true}
          title='Shift End'
          content={`Shift will be ended without shift notes and shift details. Are you sure you want to end the shift?`}
          setIsConfirm={(e) => {
            if (e) {
              const payload = {
                uuid: selectedShift?.uuid,

              };

              apiPostRequest(URL_ROSTERING_MANUALY_END_SHAIFT, payload)
                .then((res) => {
                  if (res.status === 200) {
                    toast.success("Shift ended successfully");
                    refreshCalendar({ isRefreshCall: true });
              
                  } 
                })
                .catch((err) => {
                  // Error handled silently
                })
                .finally(() => {
                  setIsShowEndShiftWarning(false);
                });
            } else {
              setIsShowEndShiftWarning(false);
            }
          }}
        />
      )}
      {isSelectLocationOpen && (
        <LocationModal
          openModal={isSelectLocationOpen}
          handleClose={() => setIsSelectLocationOpen(false)}
          setShiftLocation={handleSetShiftLocation}
          selectedParticipant={selectedParticipant}
          shiftData={selectedShift !== null ? selectedShift : null}
          shiftLocation={shiftLocation}
        />
      )}
    </div>
  );
};
export default WorkerShiftDuplicate;
